module.exports = [
    {
        "id": "11",
        "text": "Agriculture, Forestry, Fishing and Hunting",
        "keywords": "agricultural agriculture animals crops fish fishing forestry growing habitats harvesting hunting natural providing raising research services supply support timber veterinary",
        "children": [
            {
                "id": "111",
                "text": "Crop Production",
                "keywords": "accounting agricultural amount climatic commodity completed conditions consists created crop crops determination employ engage equipment establishment's excluding factors family farm farming farms forestry gate grain greenhouses groves growing grown improved input inputs labour land level market methods modified naics national no nurseries oilseeds operations orchards organic percent plants point price process product production products provided raw required sale seeds these traditional treated trees use vines within",
                "children": [
                    {
                        "id": "1111",
                        "text": "Oilseed and Grain Farming",
                        "keywords": "crop farming grain grains growing oilseed oilseeds producing seeds",
                        "children": [
                            {
                                "id": "111110",
                                "text": "Soybean Farming",
                                "keywords": "farming growing soybean soybeans"
                            },
                            {
                                "id": "111120",
                                "text": "Oilseed (except Soybean) Farming",
                                "keywords": "farming fibrous growing oilseed oilseeds plants produce soybean"
                            },
                            {
                                "id": "111130",
                                "text": "Dry Pea and Bean Farming",
                                "keywords": "bean beans dry farming growing lentils pea peas"
                            },
                            {
                                "id": "111140",
                                "text": "Wheat Farming",
                                "keywords": "farming growing wheat"
                            },
                            {
                                "id": "111150",
                                "text": "Corn Farming",
                                "keywords": "corn farming growing"
                            },
                            {
                                "id": "111160",
                                "text": "Rice Farming",
                                "keywords": "farming growing rice wild"
                            },
                            {
                                "id": "111190",
                                "text": "Other Grain Farming",
                                "keywords": "farming farms grain grains growing oilseeds"
                            }
                        ]
                    },
                    {
                        "id": "1112",
                        "text": "Vegetable and Melon Farming",
                        "keywords": "bedding farming growing melon melons plants producing seeds vegetable vegetables",
                        "children": [
                            {
                                "id": "111211",
                                "text": "Potato Farming",
                                "keywords": "farming growing potato potatoes seed yams"
                            },
                            {
                                "id": "111219",
                                "text": "Other Vegetable (except Potato) and Melon Farming",
                                "keywords": "bedding; farming; growing; melon; melons; plants; potato; potatoes; producing; seed; seeds; vegetable; vegetables; asparagus"
                            }
                        ]
                    },
                    {
                        "id": "1113",
                        "text": "Fruit and Tree Nut Farming",
                        "keywords": "farming fruit growing nut nuts tree",
                        "children": [
                            {
                                "id": "111320",
                                "text": "Citrus (except Orange) Groves",
                                "keywords": "citrus fruit groves growing orange oranges"
                            },
                            {
                                "id": "111330",
                                "text": "Non-Citrus Fruit and Tree Nut Farming",
                                "keywords": "farming fruit growing non-citrus nut nuts tree"
                            },
                            {
                                "id": "111310",
                                "text": "Orange Groves",
                                "keywords": "groves growing orange oranges"
                            }
                        ]
                    },
                    {
                        "id": "1114",
                        "text": "Greenhouse, Nursery and Floriculture Production",
                        "keywords": "cloth cold cover crops floriculture flowers frames greenhouse greenhouses growing grown houses lath maturity nursery production removed various",
                        "children": [
                            {
                                "id": "111411",
                                "text": "Mushroom Production",
                                "keywords": "cover growing mushroom mushrooms production"
                            },
                            {
                                "id": "111412",
                                "text": "Cannabis grown under cover",
                                "keywords": "cannabis grown hydroponically under cover"
                            },
                            {
                                "id": "111419",
                                "text": "Other Food Crops Grown Under Cover",
                                "keywords": "cover crops food glass growing grown protective"
                            },
                            {
                                "id": "111422",
                                "text": "Floriculture Production",
                                "keywords": "cover fields floriculture growing materials open production products propagating"
                            },
                            {
                                "id": "111421",
                                "text": "Nursery and Tree Production",
                                "keywords": "cover crops cycle fields growing growth nursery open production products pulp rotation short stock tree trees woody years"
                            }
                        ]
                    },
                    {
                        "id": "1119",
                        "text": "Other Crop Farming",
                        "keywords": "agave cotton crop crops farming grass growing hay herbs hops maple mint peanuts sap seeds spices sugarbeets sugar-cane tobacco",
                        "children": [
                            {
                                "id": "111910",
                                "text": "Tobacco Farming",
                                "keywords": "farming growing tobacco"
                            },
                            {
                                "id": "111920",
                                "text": "Cotton Farming",
                                "keywords": "cotton farming growing"
                            },
                            {
                                "id": "111930",
                                "text": "Sugar Cane Farming",
                                "keywords": "cane farming growing sugar sugar-cane"
                            },
                            {
                                "id": "111940",
                                "text": "Hay Farming",
                                "keywords": "farming grasses growing hay mixed"
                            },
                            {
                                "id": "111993",
                                "text": "Fruit and Vegetable Combination Farming",
                                "keywords": "farming fruit growing vegetable vegetables"
                            },
                            {
                                "id": "111994",
                                "text": "Maple Syrup and Products Production",
                                "keywords": "maple plants producing production products sap syrup"
                            },
                            {
                                "id": "111995",
                                "text": "Cannabis grown in open fields",
                                "keywords": "cannabis grown open fields, cannabis seeds and seedling"
                            },
                            {
                                "id": "111999",
                                "text": "All Other Miscellaneous Crop Farming",
                                "keywords": "crop crops farming fruit growing miscellaneous vegetable"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "112",
                "text": "Animal production and aquaculture",
                "keywords": "accounting agricultural amount animal animals buildings consists created equipment establishment's factors family farms fattening feedlots grazing input labour land level naics national no pasture percent producing product production products provided raising ranches required specialized treated within",
                "children": [
                    {
                        "id": "1121",
                        "text": "Cattle Ranching and Farming",
                        "keywords": "cattle farming fattening milking raising ranching",
                        "children": [
                            {
                                "id": "112110",
                                "text": "Beef Cattle Ranching and Farming, including Feedlots",
                                "keywords": "beef cattle dairy farming fattening feedlots herd raising ranching replacements"
                            },
                            {
                                "id": "112120",
                                "text": "Dairy Cattle and Milk Production",
                                "keywords": "cattle dairy milk milking production"
                            }
                        ]
                    },
                    {
                        "id": "112210",
                        "text": "Hog and Pig Farming",
                        "keywords": "farming hog hogs pig pigs raising"
                    },
                    {
                        "id": "1123",
                        "text": "Poultry and Egg Production",
                        "keywords": "breeding egg hatching meat poultry production raising",
                        "children": [
                            {
                                "id": "112310",
                                "text": "Chicken Egg Production",
                                "keywords": "chicken chickens egg eggs hatching production raising"
                            },
                            {
                                "id": "112320",
                                "text": "Broiler and Other Meat-Type Chicken Production",
                                "keywords": "broiler chicken chickens meat meat-type production raising"
                            },
                            {
                                "id": "112330",
                                "text": "Turkey Production",
                                "keywords": "production raising turkey turkeys"
                            },
                            {
                                "id": "112340",
                                "text": "Poultry Hatcheries",
                                "keywords": "hatcheries hatching poultry"
                            },
                            {
                                "id": "112391",
                                "text": "Combination Poultry and Egg Production",
                                "keywords": "egg meat no poultry production raising"
                            },
                            {
                                "id": "112399",
                                "text": "All Other Poultry Production",
                                "keywords": "ducks emus geese ostriches pheasant poultry production quail raising"
                            }
                        ]
                    },
                    {
                        "id": "1124",
                        "text": "Sheep and Goat Farming",
                        "keywords": "farming fattening feeding goat goats lambs raising sheep",
                        "children": [
                            {
                                "id": "112420",
                                "text": "Goat Farming",
                                "keywords": "farming goat goats raising"
                            },
                            {
                                "id": "112410",
                                "text": "Sheep Farming",
                                "keywords": "farming fattening feeding lambs raising sheep"
                            }
                        ]
                    },
                    {
                        "id": "112510",
                        "text": "Aquaculture",
                        "keywords": "animals aquaculture aquaponics aquatic artificial farm-raising form growing impoundments integrated intervention natural occur operations plants process production raising rearing these use waters"
                    },
                    {
                        "id": "1129",
                        "text": "Other Animal Production",
                        "keywords": "animal animals bee bees birds cats companion crickets deer dogs equines fur-bearing honey horses laboratory llamas no pet pets production products rabbits raising worms",
                        "children": [
                            {
                                "id": "112920",
                                "text": "Horse and Other Equine Production",
                                "keywords": "donkeys equine equines horse horses mules production raising"
                            },
                            {
                                "id": "112910",
                                "text": "Apiculture",
                                "keywords": "apiculture bees collecting honey performing raising"
                            },
                            {
                                "id": "112930",
                                "text": "Fur-Bearing Animal and Rabbit Production",
                                "keywords": "animal animals fur-bearing production rabbit rabbits raising"
                            },
                            {
                                "id": "112991",
                                "text": "Animal Combination Farming",
                                "keywords": "animal animals farming no raising"
                            },
                            {
                                "id": "112999",
                                "text": "All Other Miscellaneous Animal Production",
                                "keywords": "animal animals miscellaneous production raising"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "113",
                "text": "Forestry and Logging",
                "keywords": "areas balsam barks christmas climatic conditions consequently crop cycle cycles depends different duration extremely forest forestry forests found growing gums harvest harvesting horticultural intended interventions land logging long machinery maturation moss natural needles nurseries prior processes production products purpose reforestation region require requires resulting scale seedlings short small spanish specialize specialized species timber time tree unique upon use years",
                "children": [
                    {
                        "id": "113110",
                        "text": "Timber Tract Operations",
                        "keywords": "operation operations purpose selling standing timber tract tracts"
                    },
                    {
                        "id": "113210",
                        "text": "Forest Nurseries and Gathering of Forest Products",
                        "keywords": "different forest growing nurseries processes production products purpose reforestation trees"
                    },
                    {
                        "id": "1133",
                        "text": "Logging",
                        "keywords": "chips cutting forest hewn logging primary producing riven rough round timber transporting wood",
                        "children": [
                            {
                                "id": "113311",
                                "text": "Logging (except Contract)",
                                "keywords": "basis chips contract cutting forest hewn logging own-account primary producing riven rough round timber transporting wood"
                            },
                            {
                                "id": "113312",
                                "text": "Contract Logging",
                                "keywords": "basis chips contract cutting fee forest hewn logging primary producing riven rough round timber transporting wood"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "114",
                "text": "Fishing, Hunting and Trapping",
                "keywords": "activity animals availability because configuration conservation constraints continued dependent economic equipment fish fishing habitat habitats harvesting hunting imposed maintenance natural nature processes production proper requirements requires resource resources size specialized supply these transportation trapping upon utilize variety vessels wide wild",
                "children": [
                    {
                        "id": "1141",
                        "text": "Fishing",
                        "keywords": "animals catching commercial finfish fishing habitats marine natural shellfish",
                        "children": [
                            {
                                "id": "114113",
                                "text": "Salt Water Fishing",
                                "keywords": "catching finfish fishing harvesting products salt sea shellfish trapping types water"
                            },
                            {
                                "id": "114114",
                                "text": "Freshwater fishing",
                                "keywords": "catching finfish fishing freshwater harvesting inland products shellfish species"
                            }
                        ]
                    },
                    {
                        "id": "1142",
                        "text": "Hunting and Trapping",
                        "keywords": "commercial game hunting managing operating preserves trapping",
                        "children": [
                            {
                                "id": "114210",
                                "text": "Hunting and Trapping",
                                "keywords": "commercial game hunting managing operating preserves trapping"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "115",
                "text": "Support Activities for Agriculture and Forestry",
                "keywords": "agricultural agriculture essential forestry production providing services support",
                "children": [
                    {
                        "id": "115110",
                        "text": "Support Activities for Crop Production",
                        "keywords": "crop crops growing production providing support"
                    },
                    {
                        "id": "115210",
                        "text": "Support Activities for Animal Production",
                        "keywords": "animal animals companion livestock production providing raising support"
                    },
                    {
                        "id": "115310",
                        "text": "Support Activities for Forestry",
                        "keywords": "forestry harvesting performing support timber"
                    }
                ]
            }
        ]
    },
    {
        "id": "21",
        "text": "Mining, Quarrying, and Oil and Gas Extraction",
        "keywords": "activity basis broad coal contract crude crushing development exploration extracting extraction fee flotation gas gases liquids milling mine mineral minerals mining natural occurring oil operations ores performing petroleum preparation properties quarrying screening sense site solids term these used washing well",
        "children": [
            {
                "id": "2111",
                "text": "Oil and Gas Extraction",
                "keywords": "breakers coal completing crude desilting drilling emulsion equipment equipping exploration extraction field gas gasification hydrocarbon lines liquefaction liquids mine mining natural oil operating petroleum point preparation producing production properties property pyrolysis sands separators shale shipment site wells",
                "children": [
                    {
                        "id": "211110",
                        "text": "Oil and Gas Extraction (except Oil Sands)",
                        "keywords": "coal gasification pyrolysis mine site crude oil conventional extraction fractionating natural gas liquids liquefied petroleum gases LPG production mining butane ethane isobutane propane cleaning preparation plants recovering exploration shale crude drilling completing equipping wells operating separators emulsion breakers desilting equipment field gathering lines shipment producing property tank battery industry shales hydrocarbon liquefaction pyrolysis coal"
                    },
                    {
                        "id": "211141",
                        "text": "In-situ Oil Sands Extraction",
                        "keywords": "bitumen production in situ extraction crude oil tar bituminous sands in-situ extracting heavy solution gas drive recovering thermal petroleum sand synthetic"
                    },
                    {
                        "id": "211142",
                        "text": "Mined Oil Sands Extraction",
                        "keywords": "bitumen production extraction mining bituminous sand digging crude oil tar sands extracting synthetic"
                    }
                ]
            },
            {
                "id": "212",
                "text": "Mining and Quarrying (except Oil and Gas)",
                "keywords": "coal gas metallic minerals mining non-metallic oil preparing quarrying",
                "children": [
                    {
                        "id": "2121",
                        "text": "Coal Mining",
                        "keywords": "anthracite auger bank bituminous cleaning coal conjunction culm known lignite mine mining operated operations plants preparation sites strip surface underground washeries whether",
                        "children": [
                            {
                                "id": "212114",
                                "text": "Bituminous Coal Mining",
                                "keywords": "bituminous cleaning coal conjunction known mine mining operated operations plants preparation sites washeries whether"
                            },
                            {
                                "id": "212115",
                                "text": "Subbituminous Coal Mining",
                                "keywords": "cleaning coal conjunction known mine mining operated operations plants preparation sites subbituminous washeries whether"
                            },
                            {
                                "id": "212116",
                                "text": "Lignite Coal Mining",
                                "keywords": "cleaning coal conjunction known lignite mine mining operated operations plants preparation sites washeries whether"
                            }
                        ]
                    },
                    {
                        "id": "2122",
                        "text": "Metal Ore Mining",
                        "keywords": "calcine conjunction crush custom dressing dry flotation gravity grind leach metal metallic mills minerals mines mining operated operations ore ores perform performed separately separation served sinter these wash whether",
                        "children": [
                            {
                                "id": "212210",
                                "text": "Iron Ore Mining",
                                "keywords": "agglomerates blast content furnace iron manganiferous mining operations ore ores preparing production sinter valued"
                            },
                            {
                                "id": "212220",
                                "text": "Gold and Silver Ore Mining",
                                "keywords": "content gold mining ore ores preparing silver valued"
                            },
                            {
                                "id": "212231",
                                "text": "Lead-Zinc Ore Mining",
                                "keywords": "lead lead-zinc mining ore ores preparing zinc"
                            },
                            {
                                "id": "212232",
                                "text": "Nickel-Copper Ore Mining",
                                "keywords": "mining nickel nickel-copper ore ores preparing"
                            },
                            {
                                "id": "212233",
                                "text": "Copper-Zinc Ore Mining",
                                "keywords": "concentrates copper copper-zinc leaching mining ore ores precipitation preparing recovery"
                            },
                            {
                                "id": "212291",
                                "text": "Uranium Ore Mining",
                                "keywords": "mining ore ores preparing uranium uranium-radium-vanadium"
                            },
                            {
                                "id": "212299",
                                "text": "All Other Metal Ore Mining",
                                "keywords": "metal metallic mining ore ores preparing"
                            }
                        ]
                    },
                    {
                        "id": "2123",
                        "text": "Non-Metallic Mineral Mining and Quarrying",
                        "keywords": "coal crushing grinding mineral minerals mining non-metallic plants preparation primary quarrying washing",
                        "children": [
                            {
                                "id": "212314",
                                "text": "Granite Mining and Quarrying",
                                "keywords": "blocks broken crushed dimension granite mining quarrying rocks rough slabs"
                            },
                            {
                                "id": "212315",
                                "text": "Limestone Mining and Quarrying",
                                "keywords": "blocks broken crushed dimension grinding limestone mining pulverizing quarrying rocks rough slabs"
                            },
                            {
                                "id": "212316",
                                "text": "Marble Mining and Quarrying",
                                "keywords": "blocks broken crushed dimension marble mining quarrying rough slabs slate"
                            },
                            {
                                "id": "212317",
                                "text": "Sandstone Mining and Quarrying",
                                "keywords": "blocks broken crushed dimension mining quarrying rough sandstone slabs"
                            },
                            {
                                "id": "212323",
                                "text": "Sand and Gravel Mining and Quarrying",
                                "keywords": "dredging gravel mining operating pits preparing quarrying sand screening washing"
                            },
                            {
                                "id": "212326",
                                "text": "Shale, Clay and Refractory Mineral Mining and Quarrying",
                                "keywords": "ball brick cement clay clays conjunction kaolin manufacture mineral minerals mines mining operated plants pottery preparing products quarrying refractory reports separate shale structural"
                            },
                            {
                                "id": "212392",
                                "text": "Diamond Mining",
                                "keywords": "diamond diamonds gem industrial mining quality"
                            },
                            {
                                "id": "212393",
                                "text": "Salt Mining",
                                "keywords": "brine mining recovery rock salt wells"
                            },
                            {
                                "id": "212394",
                                "text": "Asbestos Mining",
                                "keywords": "asbestos mining preparing"
                            },
                            {
                                "id": "212395",
                                "text": "Gypsum Mining",
                                "keywords": "gypsum mining preparing"
                            },
                            {
                                "id": "212396",
                                "text": "Potash Mining",
                                "keywords": "mining potash preparing"
                            },
                            {
                                "id": "212397",
                                "text": "Peat Extraction",
                                "keywords": "extracting extraction peat processing"
                            },
                            {
                                "id": "212398",
                                "text": "All Other Non-Metallic Mineral Mining and Quarrying",
                                "keywords": "mineral minerals mining non-metallic preparing quarrying"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "2131",
                "text": "Support activities for mining, and oil and gas extraction",
                "keywords": "basis contract exploration extraction fee gas geological methods minerals mining observations oil ore prospecting prospective providing quarrying required samples services sites support traditional",
                "children": [
                    {
                        "id": "213111",
                        "text": "Oil and Gas Contract Drilling",
                        "keywords": "basis contract drilling fee field gas oil operations wells"
                    },
                    {
                        "id": "213117",
                        "text": "Contract Drilling (except Oil and Gas)",
                        "keywords": "contract diamond drilling gas minerals oil prospect test types"
                    },
                    {
                        "id": "213118",
                        "text": "Services to Oil and Gas Extraction",
                        "keywords": "basis contract drilling extraction fee field gas oil performing services"
                    },
                    {
                        "id": "213119",
                        "text": "Other Support Activities for Mining",
                        "keywords": "accomplished basis businesses contract core drilling exploration fee minerals mining obtain performing purchased samples services specialty support"
                    }
                ]
            }
        ]
    },
    {
        "id": "22",
        "text": "Utilities",
        "keywords": "control distribute electric facilities gas generate infrastructure lines natural operate operating permanent pipes power processing provide services sewage sewer systems these transmit treat treatment utilities water",
        "children": [
            {
                "id": "2211",
                "text": "Electric Power Generation, Transmission and Distribution",
                "keywords": "bulk centres distribution electric end facilities generating generation power transmission users",
                "children": [
                    {
                        "id": "221111",
                        "text": "Hydro-Electric Power Generation",
                        "keywords": "electricity generation hydro hydro-electric power processes pumped storage use"
                    },
                    {
                        "id": "221112",
                        "text": "Fossil-Fuel Electric Power Generation",
                        "keywords": "coal combustion combustion-turbine conventional electric electricity fossil fossil-fuel fuels gas generation internal oil power processes steam"
                    },
                    {
                        "id": "221113",
                        "text": "Nuclear Electric Power Generation",
                        "keywords": "electric generating generation nuclear nuclear-powered plants power"
                    },
                    {
                        "id": "221119",
                        "text": "Other Electric Power Generation",
                        "keywords": "electric electricity generation power solar tidal wind"
                    },
                    {
                        "id": "221121",
                        "text": "Electric Bulk Power Transmission and Control",
                        "keywords": "among arranging between bulk centre control co-ordinating distribution electric facilitating generating integral lines power source stations system transformer transmission utilities"
                    },
                    {
                        "id": "221122",
                        "text": "Electric Power Distribution",
                        "keywords": "agents arrange brokers consumer dedicated distribution electric electricity generating individual integral lines operated power sale stations system systems transformer user well"
                    }
                ]
            },
            {
                "id": "221210",
                "text": "Natural Gas Distribution",
                "keywords": "arrange brokers consumers distribution gas mains marketers natural operated sale synthetic system systems ultimate"
            },
            {
                "id": "2213",
                "text": "Water, Sewage and Other Systems",
                "keywords": "operating sewage systems water",
                "children": [
                    {
                        "id": "221310",
                        "text": "Water Supply and Irrigation Systems",
                        "keywords": "collection distribution domestic industrial irrigation needs operating supply systems treatment water"
                    },
                    {
                        "id": "221320",
                        "text": "Sewage Treatment Facilities",
                        "keywords": "collect dispose facilities operating sewage sewer systems treat treatment waste"
                    },
                    {
                        "id": "221330",
                        "text": "Steam and Air-Conditioning Supply",
                        "keywords": "air air-conditioning cooled distribution heated production steam supply"
                    }
                ]
            }
        ]
    },
    {
        "id": "23",
        "text": "Construction",
        "keywords": "accepted activity actual agency amount architectural arranging assembly assume at-risk between bidding build builder builders building buildings business businesses civil client complete conform constructed constructing construction contract contracting contractor contractors degree depending depends design designation designations design-build design-builder design-builders designs developing development differences different distinctions distinguish distinguished divided during electrical employees engineering enterprise enterprises enterprises' entire equipment especially estate exist existing feasibility financing force former functions hand heavy highlight however initially inputs integrated involved joint just known labour land large made makes management manager managers masonry merchant most needed new operate operative order oversight own owner owners painting parts performed primary process produce production project projects property provide providing real referred renovating renovation renovations repair repairing repairs require required residential responsibility responsible risk road sale scheduling scope selection separate service services several signed significant single skills sometimes specialize specialized specialty speculative structure structures studies subcontract subcontracting subdividing subsectors substantial tasks themselves therefore these they together trade trades turnkey-type types underlying undertake unless upon use variations variety ventures well whether will work works",
        "children": [
            {
                "id": "236",
                "text": "Construction of Buildings",
                "keywords": "additions alterations assembly buildings commercial construction contractors distinguished existing function industrial maintenance new on-site panellized precast prefabricated primary produce production repairs residential responsibility specialty structures subcontracted temporary trade undertake work",
                "children": [
                    {
                        "id": "236110",
                        "text": "Residential Building Construction",
                        "keywords": "builders building buildings construction contractors design-build firms housing management multi-family operative project remodellers remodelling renovation residential single-family structures"
                    },
                    {
                        "id": "236210",
                        "text": "Industrial Building and Structure Construction",
                        "keywords": "additional additions alterations blast builders building buildings cement construction contractors design-build eg firms furnaces incinerators industrial major management new non-building operative plants processes production selected structure structures warehouses whose work"
                    },
                    {
                        "id": "236220",
                        "text": "Commercial and Institutional Building Construction",
                        "keywords": "additions alterations assembly builders building buildings commercial construction contractors design-build elevators firms grain indoor institutional major management modular new on-site operative pools prefabricated responsible stadiums structures swimming work"
                    }
                ]
            },
            {
                "id": "237",
                "text": "Heavy and Civil Engineering Construction",
                "keywords": "activity additional additions alterations applications based building buildings civil component construct construction contractors dams drainage dredging eg electrical engineering entire equipment existing heavy highways improvement individual installation land line lines lots maintenance much needed new normally open paint parks perform performed primary produce production projects provide repairs resources road services signal site-improvement skills space specialized specialty specific structures subdivision therefore they trade traffic trails types undertake used uses utility various water while whose work works",
                "children": [
                    {
                        "id": "237110",
                        "text": "Water and Sewer Line and Related Structures Construction",
                        "keywords": "buildings construction eg integral line lines mains networks new parts performed plants pumping reconstruction rehabilitation repairs sewage sewer specialized stations storage structures tanks trade treatment water work"
                    },
                    {
                        "id": "237120",
                        "text": "Oil and Gas Pipeline and Related Structures Construction",
                        "keywords": "buildings construction eg gas integral lines mains networks new oil parts performed pipeline pumping reconstruction refineries rehabilitation repairs specialized stations storage structures tanks trade work"
                    },
                    {
                        "id": "237130",
                        "text": "Power and Communication Line and Related Structures Construction",
                        "keywords": "buildings communication construction eg facilities generating hydroelectric integral line lines networks new parts performed plants power radio reconstruction rehabilitation repairs specialized structures substations telecommunications television towers trade transmitting transmittingreceiving work"
                    },
                    {
                        "id": "237210",
                        "text": "Land Subdivision",
                        "keywords": "activity builders building clearing commercial created entails excavation extent improvement improvements industrial installation land legal lines lots parks perform physical precedes project property raw real residential roads sale servicing sites subdividing subdivision subsequent tracts utility varies while work"
                    },
                    {
                        "id": "237310",
                        "text": "Highway, Street and Bridge Construction",
                        "keywords": "airport bridge bridges construction eg elevated guardrails highway highways installing new performed public reconstruction rehabilitation repairs roads runways sidewalks specialized street streets trade work"
                    },
                    {
                        "id": "237990",
                        "text": "Other Heavy and Civil Engineering Construction",
                        "keywords": "civil constructing construction development drainage dredging driving eg engineering facilities heavy land marine new open parks performed pile projects reconstruction recreational rehabilitation repairs resources space specialized these trade trails water work works"
                    }
                ]
            },
            {
                "id": "238",
                "text": "Specialty Trade Contractors",
                "keywords": "- accepted additions alterations boilers builders building buildings businesses carried carry civil component components concrete conform construction contract contractors distinctions electrical elevators engineering equipment especially even finishing foundations goods heavy however initial install installation involved job-specific made maintenance manufacture manufacturing masonry most needed new operate operative order out overall owner painting performed pre-cast prefabrication preparation project property range renovation repair repairs shops site specialized specialty steel structural structures systems themselves these they trade types work",
                "children": [
                    {
                        "id": "2381",
                        "text": "Foundation, Structure, and Building Exterior Contractors",
                        "keywords": "additions alterations basic building buildings complete contractors exterior foundation frame ie maintenance needed new performed repairs shell specialty structure trades work",
                        "children": [
                            {
                                "id": "238110",
                                "text": "Poured Concrete Foundation and Structure Contractors",
                                "keywords": "additions alterations concrete contractors elements finishing foundation foundations grout maintenance new performed performing poured pouring repairs shotcrete structural structure work"
                            },
                            {
                                "id": "238120",
                                "text": "Structural Steel and Precast Concrete Contractors",
                                "keywords": "additions alterations assembling bars beams cages components concrete construction contractors eg erecting installing made maintenance mesh new parts performed poured-in-place precast products rebar reinforce repairs rods steel structural work"
                            },
                            {
                                "id": "238130",
                                "text": "Framing Contractors",
                                "keywords": "additions alterations concrete contractors framing maintenance materials new performed repairs sheathing steel structural work"
                            },
                            {
                                "id": "238140",
                                "text": "Masonry Contractors",
                                "keywords": "additions alterations brick contractors laying maintenance masonry new performed repairs setting stone work"
                            },
                            {
                                "id": "238150",
                                "text": "Glass and Glazing Contractors",
                                "keywords": "additions alterations buildings contractors glass glazing ie installing maintenance new openings panes performed prepared repairs work"
                            },
                            {
                                "id": "238170",
                                "text": "Siding Contractors",
                                "keywords": "additions alterations aluminium brick contractors curtain downspouts eavestroughs exterior finish gutters installing maintenance material new performed repairs siding stone stucco vinyl wall wood work"
                            },
                            {
                                "id": "238160",
                                "text": "Roofing Contractors",
                                "keywords": "additions alterations coating contractors ie installing maintenance new painting performed repairs roofing roofs skylights spraying treating work"
                            },
                            {
                                "id": "238190",
                                "text": "Other Foundation, Structure and Building Exterior Contractors",
                                "keywords": "additions alterations building contractors exterior foundation maintenance new performed repairs structure trades work"
                            }
                        ]
                    },
                    {
                        "id": "2382",
                        "text": "Building Equipment Contractors",
                        "keywords": "additions alterations building central cleaning contractors cooling eg electricity elevators equipment escalators forms heating installing maintenance mechanical new performed repairs service servicing specialized station system systems vacuum water work",
                        "children": [
                            {
                                "id": "238210",
                                "text": "Electrical Contractors and Other Wiring Installation Contractors",
                                "keywords": "additions alterations contractors electrical equipment installation installing labour maintenance new parts perform performing repairs servicing wiring work"
                            },
                            {
                                "id": "238291",
                                "text": "Elevator and Escalator Installation Contractors",
                                "keywords": "additions alterations buildings contractors conveying elevator elevators equipment escalator escalators installation installing maintenance moving new performed repairs servicing sidewalks work"
                            },
                            {
                                "id": "238220",
                                "text": "Plumbing, Heating and Air-Conditioning Contractors",
                                "keywords": "additions air-conditioning alterations contractors equipment heating installing labour maintenance new parts performed performing plumbing provide repairs servicing work"
                            },
                            {
                                "id": "238299",
                                "text": "All Other Building Equipment Contractors",
                                "keywords": "additions alterations boiler building built-in cleaning contractors dismantling equipment important installation installing large-scale machinery maintenance new performed pipe repairs servicing systems these vacuum work"
                            }
                        ]
                    },
                    {
                        "id": "2383",
                        "text": "Building Finishing Contractors",
                        "keywords": "additions alterations building buildings contractors finish finishing maintenance needed new performed repairs specialty trades work",
                        "children": [
                            {
                                "id": "238310",
                                "text": "Drywall and Insulation Contractors",
                                "keywords": "additions alterations applying building contractors drywall installation insulation lath maintenance new ornamental performed plain plaster receive repairs work"
                            },
                            {
                                "id": "238320",
                                "text": "Painting and Wall Covering Contractors",
                                "keywords": "additions alterations buildings contractors covering decorating engineering heavy incidental maintenance new paint painting paper paperhanging performed preparation repairs sandblasting stripping structures surface wall work"
                            },
                            {
                                "id": "238330",
                                "text": "Flooring Contractors",
                                "keywords": "additions alterations carpeting contractors floor flooring hardwood installation linoleum maintenance new performed repairs resilient tile work"
                            },
                            {
                                "id": "238340",
                                "text": "Tile and Terrazzo Contractors",
                                "keywords": "additions alterations cement ceramic contractors installing interior job maintenance marble mixing mosaic new particles performed repairs setting site stone terrazzo tile work"
                            },
                            {
                                "id": "238350",
                                "text": "Finish Carpentry Contractors",
                                "keywords": "additions alterations carpentry contractors finish maintenance new performed repairs work"
                            },
                            {
                                "id": "238390",
                                "text": "Other Building Finishing Contractors",
                                "keywords": "additions alterations building contractors finishing maintenance new performed repairs trade work"
                            }
                        ]
                    },
                    {
                        "id": "2389",
                        "text": "Other Specialty Trade Contractors",
                        "keywords": "additions alterations building contractors crane exteriors fence installation maintenance new operator performed preparation rental repairs sandblasting site specialized specialty steeplejack trade work",
                        "children": [
                            {
                                "id": "238910",
                                "text": "Site Preparation Contractors",
                                "keywords": "buildings clearing construction contractors cranes demolition earth equipment excavating grading installation land mine moving operator overburden preparation removal rental septic site sites structures system types"
                            },
                            {
                                "id": "238990",
                                "text": "All Other Specialty Trade Contractors",
                                "keywords": "additions alterations construction contractors maintenance new performed repairs specialized specialty trade trades work"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "id": "31-33",
        "text": "Manufacturing",
        "keywords": "agricultural assembly becoming bicycles blending certain chemical component computers conducted construction consumed crop cutting designations drying dyeing factories finished finishing goods hand heat-treating homes known logging machinery manufactured manufacturing material materials meat mills mineral new operations ores own owned parts physical place plants plating post-harvest production products raw ready retailers sectors semi-finished sense structures substances take these they tools trade transform transformation treated use used variety various workers'",
        "children": [
            {
                "id": "311",
                "text": "Food Manufacturing",
                "keywords": "animal consumption food human manufacturing producing",
                "children": [
                    {
                        "id": "3111",
                        "text": "Animal Food Manufacturing",
                        "keywords": "animal animals feed food manufacturing pets",
                        "children": [
                            {
                                "id": "311111",
                                "text": "Dog and Cat Food Manufacturing",
                                "keywords": "cat dog food manufacturing"
                            },
                            {
                                "id": "311119",
                                "text": "Other Animal Food Manufacturing",
                                "keywords": "animal food manufacturing"
                            }
                        ]
                    },
                    {
                        "id": "3112",
                        "text": "Grain and Oilseed Milling",
                        "keywords": "blending breakfast cereal fats grain grains milling oils oilseed oilseeds products refining",
                        "children": [
                            {
                                "id": "311221",
                                "text": "Wet Corn Milling",
                                "keywords": "corn manufacturing milling starch vegetables wet wet-milling"
                            },
                            {
                                "id": "311224",
                                "text": "Oilseed Processing",
                                "keywords": "crushing edible extracting inedible nuts oils oilseed oilseeds processing produced products tree"
                            },
                            {
                                "id": "311225",
                                "text": "Fat and Oil Refining and Blending",
                                "keywords": "animal blending crude deodorize edible fat fats inedible manufacturing oil oils partially processing produced products purchased refined refining used vegetable"
                            },
                            {
                                "id": "311230",
                                "text": "Breakfast Cereal Manufacturing",
                                "keywords": "breakfast cereal foods manufacturing"
                            },
                            {
                                "id": "311211",
                                "text": "Flour Milling",
                                "keywords": "doughs flour fruits grain grains grind grinding integrated milling mills mixes prepared process products rice vegetables"
                            },
                            {
                                "id": "311214",
                                "text": "Rice Milling and Malt Manufacturing",
                                "keywords": "barley cleaning flour grains malt manufacturing meal milling polishing rice rye"
                            }
                        ]
                    },
                    {
                        "id": "3113",
                        "text": "Sugar and Confectionery Product Manufacturing",
                        "keywords": "confectionery manufacturing product products sugar",
                        "children": [
                            {
                                "id": "311310",
                                "text": "Sugar Manufacturing",
                                "keywords": "beets cane manufacturing raw refined sugar syrup"
                            },
                            {
                                "id": "311340",
                                "text": "Non-Chocolate Confectionery Manufacturing",
                                "keywords": "confectionery manufacturing non-chocolate"
                            },
                            {
                                "id": "311351",
                                "text": "Chocolate and Confectionery Manufacturing from Cacao Beans",
                                "keywords": "beans cacao chocolate confectionery grinding manufacturing products roasting shelling"
                            },
                            {
                                "id": "311352",
                                "text": "Confectionery Manufacturing from Purchased Chocolate",
                                "keywords": "chocolate confectionery manufacturing purchased"
                            }
                        ]
                    },
                    {
                        "id": "3114",
                        "text": "Fruit and Vegetable Preserving and Specialty Food Manufacturing",
                        "keywords": "canning dehydrating dishes entrées food frozen fruit fruits ingredients manufacturing pickling preserved preserving processes seafood several side specialty vegetable vegetables",
                        "children": [
                            {
                                "id": "311420",
                                "text": "Fruit and Vegetable Canning, Pickling and Drying",
                                "keywords": "brining canning dehydrate dehydrating dressing dried drying freeze-drying fruit fruits heat ingredients least manufacturing mixes mixtures pickling preserving provided salad salt solutions soup sterilization they uses vegetable vegetables vinegar asparagus"
                            },
                            {
                                "id": "311410",
                                "text": "Frozen Food Manufacturing",
                                "keywords": "dinners dishes food frozen fruits ingredients manufacturing seafood several side vegetables"
                            }
                        ]
                    },
                    {
                        "id": "3115",
                        "text": "Dairy Product Manufacturing",
                        "keywords": "dairy manufacturing product products substitute",
                        "children": [
                            {
                                "id": "311511",
                                "text": "Fluid Milk Manufacturing",
                                "keywords": "fluid manufacturing milk processed products substitute"
                            },
                            {
                                "id": "311515",
                                "text": "Butter, Cheese, and Dry and Condensed Dairy Product Manufacturing",
                                "keywords": "butter cheese condensed dairy dry manufacturing product products substitute"
                            },
                            {
                                "id": "311520",
                                "text": "Ice Cream and Frozen Dessert Manufacturing",
                                "keywords": "cream dessert desserts frozen ice manufacturing"
                            }
                        ]
                    },
                    {
                        "id": "3116",
                        "text": "Meat Product Manufacturing",
                        "keywords": "manufacturing meat product products",
                        "children": [
                            {
                                "id": "311611",
                                "text": "Animal (except Poultry) Slaughtering",
                                "keywords": "animal animals game meat poultry prepare products slaughter slaughtering small"
                            },
                            {
                                "id": "311614",
                                "text": "Rendering and Meat Processing from Carcasses",
                                "keywords": "animal assembly-line bones boxed by-products carcasses cutting fat known meat packing plants preparing processing purchased rendering scraps"
                            },
                            {
                                "id": "311615",
                                "text": "Poultry Processing",
                                "keywords": "by-products game meat poultry preparing processed processing slaughtering small"
                            }
                        ]
                    },
                    {
                        "id": "3117",
                        "text": "Seafood Product Preparation and Packaging",
                        "keywords": "bones canning drying entrails factory fats fins fish floating freezing fresh heads known marine oils packaging packing preparation preparing processing product removing salting scales seafood shellfish shipboard ships shucking smoking soup",
                        "children": [
                            {
                                "id": "311710",
                                "text": "Seafood Product Preparation and Packaging",
                                "keywords": "bones canning drying entrails factory fats fins fish floating freezing fresh heads known marine oils packaging packing preparation preparing processing product removing salting scales seafood shellfish shipboard ships shucking smoking soup"
                            }
                        ]
                    },
                    {
                        "id": "3118",
                        "text": "Bakeries and Tortilla Manufacturing",
                        "keywords": "baked bakeries bakery consumption goods immediate manufacturing products retail sale tortilla",
                        "children": [
                            {
                                "id": "311811",
                                "text": "Retail Bakeries",
                                "keywords": "bakeries bakery consumption doughs flour immediate manufacturing prepared products retail sale"
                            },
                            {
                                "id": "311814",
                                "text": "Commercial Bakeries and Frozen Bakery Product Manufacturing",
                                "keywords": "baked bakeries bakery commercial frozen manufacturing product products retail sale"
                            },
                            {
                                "id": "311821",
                                "text": "Cookie and Cracker Manufacturing",
                                "keywords": "biscuits cookie cookies cracker crackers manufacturing products"
                            },
                            {
                                "id": "311824",
                                "text": "Flour Mixes, Dough, and Pasta Manufacturing from Purchased Flour",
                                "keywords": "dough flour manufacturing mixes prepared purchased dry manufacturing pasta"
                            },
                            {
                                "id": "311830",
                                "text": "Tortilla Manufacturing",
                                "keywords": "manufacturing tortilla tortillas"
                            }
                        ]
                    },
                    {
                        "id": "3119",
                        "text": "Other Food Manufacturing",
                        "keywords": "food manufacturing",
                        "children": [
                            {
                                "id": "311911",
                                "text": "Roasted Nut and Peanut Butter Manufacturing",
                                "keywords": "butter canning cooking drying grains manufacturing nut nuts peanut processing roasted roasting salting seeds snacks"
                            },
                            {
                                "id": "311919",
                                "text": "Other Snack Food Manufacturing",
                                "keywords": "food foods manufacturing snack"
                            },
                            {
                                "id": "311920",
                                "text": "Coffee and Tea Manufacturing",
                                "keywords": "blending coffee concentrates dried extracts freeze herbal instant manufacturing roasting substitutes tea"
                            },
                            {
                                "id": "311930",
                                "text": "Flavouring Syrup and Concentrate Manufacturing",
                                "keywords": "concentrate concentrates drink drinks flavouring fountain manufacturing products soda soft syrup use"
                            },
                            {
                                "id": "311940",
                                "text": "Seasoning and Dressing Manufacturing",
                                "keywords": "dressing dressings manufacturing seasoning seasonings"
                            },
                            {
                                "id": "311990",
                                "text": "All Other Food Manufacturing",
                                "keywords": "cut food foods fresh individual manufacturing packaging pasta peeled perishable pizza prepared resale salads vegetables"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "312",
                "text": "Beverage and Tobacco Product Manufacturing",
                "keywords": "beverage beverages manufacturing product products tobacco",
                "children": [
                    {
                        "id": "3121",
                        "text": "Beverage Manufacturing",
                        "keywords": "beverage beverages manufacturing",
                        "children": [
                            {
                                "id": "312110",
                                "text": "Soft Drink and Ice Manufacturing",
                                "keywords": "before bottled bottling carbonated drink drinks ice manufacturing purify soft water water-bottling"
                            },
                            {
                                "id": "312120",
                                "text": "Breweries",
                                "keywords": "ale beer breweries brewing liquors malt non-alcoholic"
                            },
                            {
                                "id": "312130",
                                "text": "Wineries",
                                "keywords": "blending brandy distilling fruit grapes growing manufacturing purchased wine wineries wines"
                            },
                            {
                                "id": "312140",
                                "text": "Distilleries",
                                "keywords": "blending brandy distilleries distilling ingredients liquor mixing"
                            }
                        ]
                    },
                    {
                        "id": "3122",
                        "text": "Tobacco Manufacturing",
                        "keywords": "manufacturing products tobacco",
                        "children": [
                            {
                                "id": "312210",
                                "text": "Tobacco Stemming and Redrying",
                                "keywords": "age final grading leaf packing perform redrying sorting stemming these they tobacco treating"
                            },
                            
                            {
                                "id": "312220",
                                "text": "Tobacco Product Manufacturing",
                                "keywords": "cigarettes manufacturing product products tobacco"
                            }
                        ]
                    },
                    {
                            "id": "312310",
                            "text": "Cannabis product manufacturing",
                            "keywords": "cannabis cigarette manufacturing edibles cannabis-infused e-liquids and concentrates"
                     
                    }
                ]
            },
            {
                "id": "313",
                "text": "Textile Mills",
                "keywords": "clothing fabrics finishing knitted manufacturing mills products textile yarn",
                "children": [
                    {
                        "id": "3131",
                        "text": "Fibre, Yarn and Thread Mills",
                        "keywords": "crocheting embroidery fibre fibres filaments man-made manufacturing mills purchased sewing spinning tatting texturing thread throwing twisting uses yarn yarns",
                        "children": [
                            {
                                "id": "313110",
                                "text": "Fibre, Yarn and Thread Mills",
                                "keywords": "crocheting embroidery fibre fibres filaments man-made manufacturing mills purchased sewing spinning tatting texturing thread throwing twisting uses yarn yarns"
                            }
                        ]
                    },
                    {
                        "id": "3132",
                        "text": "Fabric Mills",
                        "keywords": "clothing fabric fabrics finish knitted manufacture manufacturing mills products textile they",
                        "children": [
                            {
                                "id": "313240",
                                "text": "Knit Fabric Mills",
                                "keywords": "arachne circular construction double fabric fabrics finish flat-bed interlock knit knits knitting lace machines malimo manufacturing mills processes products single special textile they warp weft"
                            },
                            {
                                "id": "313210",
                                "text": "Broad-Woven Fabric Mills",
                                "keywords": "broad broad-woven fabric fabrics finish made manufacturing mills products textile they weave weaving"
                            },
                            {
                                "id": "313220",
                                "text": "Narrow Fabric Mills and Schiffli Machine Embroidery",
                                "keywords": "braiding cord elastic embroideries embroidery fabric fabric-covered fabrics finish machine machines manufacture manufacturing mills narrow schiffli they thread weaving yarn"
                            },
                            {
                                "id": "313230",
                                "text": "Nonwoven Fabric Mills",
                                "keywords": "bonding chemical combinations fabric fabrics fibres finish interlocking manufacture manufacturing mechanical methods mills nonwoven solvent thereof thermal they used"
                            }
                        ]
                    },
                    {
                        "id": "3133",
                        "text": "Textile and Fabric Finishing and Fabric Coating",
                        "keywords": "carpets clothing coated coating fabric fabrics finishing laminated manufacturing products rugs textile thread yarn",
                        "children": [
                            {
                                "id": "313310",
                                "text": "Textile and Fabric Finishing",
                                "keywords": "bleaching buying calendering carpets chemical clothing contractors converters dyeing fabric fabrics finished finishing fire flock grey having known made mechanical mildew napping operations plisse preshrinking printing products proofing repellency resistance roller rugs screen stone-washing textile thread water yarn"
                            },
                            {
                                "id": "313320",
                                "text": "Fabric Coating",
                                "keywords": "clothing coated coating fabric fabrics finishing laminated laminating manufacturing processes rubberizing textile varnishing waxing"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "314",
                "text": "Textile Product Mills",
                "keywords": "clothing manufacturing mills product products textile",
                "children": [
                    {
                        "id": "3141",
                        "text": "Textile Furnishings Mills",
                        "keywords": "carpets curtains furnishings linens manufacturing mills rugs textile",
                        "children": [
                            {
                                "id": "314110",
                                "text": "Carpet and Rug Mills",
                                "keywords": "carpet carpets finishing manufacturing mills needle-punched rug rugs tufted woven"
                            },
                            {
                                "id": "314120",
                                "text": "Curtain and Linen Mills",
                                "keywords": "curtain curtains draperies furnishings home linen linens manufacturing materials mills purchased"
                            }
                        ]
                    },
                    {
                        "id": "3149",
                        "text": "Other Textile Product Mills",
                        "keywords": "manufacturing mills product products textile",
                        "children": [
                            {
                                "id": "314910",
                                "text": "Textile Bag and Canvas Mills",
                                "keywords": "bag bags canvas industrial manufacturing mills products shipping substitutes tarpaulins tents textile"
                            },
                            {
                                "id": "314990",
                                "text": "All Other Textile Product Mills",
                                "keywords": "basis clothing contract embroidering garneting manufacturing mills product products recycling textile waste whether"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "315",
                "text": "Clothing Manufacturing",
                "keywords": "clothing manufacturing",
                "children": [
                    {
                        "id": "3151",
                        "text": "Clothing Knitting Mills",
                        "keywords": "clothing fabrics finish knit knitting made manufacturing mills they yarn",
                        "children": [
                            {
                                "id": "315110",
                                "text": "Hosiery and Sock Mills",
                                "keywords": "children clothing finish hosiery knit knitting men mills sock they women"
                            },
                            {
                                "id": "315190",
                                "text": "Other Clothing Knitting Mills",
                                "keywords": "clothing finish knit knitting mills they"
                            }
                        ]
                    },
                    {
                        "id": "3152",
                        "text": "Cut and Sew Clothing Manufacturing",
                        "keywords": "clothing cut fabric made manufacturing sew",
                        "children": [
                            {
                                "id": "315210",
                                "text": "Cut and Sew Clothing Contracting",
                                "keywords": "arms bodies clothing commonly contract contracting contractors cut cutting limited manufacturing materials operations owned perform referred sew sewing shirt these"
                            },
                            {
                                "id": "315220",
                                "text": "Men's and Boys' Cut and Sew Clothing Manufacturing",
                                "keywords": "boys' cut fabric manufacturing men's nightwear purchased sew underwear clothing coat coats known overcoat overcoats producing retail sale suit suits tailors important products shirt shirts tailored t-shirts jean jeans slack slacks trouser trousers"
                            },
                            {
                                "id": "315241",
                                "text": "Infants' Cut and Sew Clothing Manufacturing",
                                "keywords": "articles body centimetres children classification clothing cut exceeding fabric height infants' manufacturing purchased purposes refers sew sizes term x young"
                            },
                            {
                                "id": "315249",
                                "text": "Women's and Girls' Cut and Sew Clothing Manufacturing",
                                "keywords": "cut fabric girls' lingerie loungewear manufacturing nightwear purchased sew women's blouse blouses shirt shirts clothing dress dresses dressmakers known producing retail sale coat coats jacket jackets skirt skirts suit suits tailored"
                            },
                            {
                                "id": "315281",
                                "text": "Fur and Leather Clothing Manufacturing",
                                "keywords": "clothing fur leather manufacturing"
                            },
                            {
                                "id": "315289",
                                "text": "All Other Cut and Sew Clothing Manufacturing",
                                "keywords": "clothing cut fabric manufacturing purchased sew"
                            }
                        ]
                    },
                    {
                        "id": "3159",
                        "text": "Clothing Accessories and Other Clothing Manufacturing",
                        "keywords": "accessories clothing manufacturing",
                        "children": [
                            {
                                "id": "315990",
                                "text": "Clothing Accessories and Other Clothing Manufacturing",
                                "keywords": "accessories clothing manufacturing"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "316",
                "text": "Leather and Allied Product Manufacturing",
                "keywords": "allied leather manufacturing product products",
                "children": [
                    {
                        "id": "316110",
                        "text": "Leather and Hide Tanning and Finishing",
                        "keywords": "basis buy colouring contract converters currying dressing dyeing finishing fur hide hides leather processed skins tanning who"
                    },
                    {
                        "id": "316210",
                        "text": "Footwear Manufacturing",
                        "keywords": "footwear manufacturing material"
                    },
                    {
                        "id": "316990",
                        "text": "Other Leather and Allied Product Manufacturing",
                        "keywords": "allied articles billfolds carried cases coin handbag handbags important key leather luggage manufacturing materials metal normally person precious product products purses small"
                    }
                ]
            },
            {
                "id": "321",
                "text": "Wood Product Manufacturing",
                "keywords": "assemblies characteristics comprising diverse engineered groups improve logs lumber manufacturing millwork natural panel plywood preserving product products range reconstituted sawing these veneers wood",
                "children": [
                    {
                        "id": "3211",
                        "text": "Sawmills and Wood Preservation",
                        "keywords": "achieve boards bolts dimension dressed logs lumber machine manufacturing planing poles preservation preserve produce rough sawmills shaped size smoothness these ties timber uniformity wood worked",
                        "children": [
                            {
                                "id": "321111",
                                "text": "Sawmills (except Shingle and Shake Mills)",
                                "keywords": "achieve boards bolts case dimension dressed logs lumber machine manufacturing mills planing poles produce rough sawmills shake shaped shingle siding size smoothness these ties timber uniformity worked"
                            },
                            {
                                "id": "321112",
                                "text": "Shingle and Shake Mills",
                                "keywords": "blocks mills produce sawing shake shakes shingle shingles splitting wood"
                            },
                            {
                                "id": "321114",
                                "text": "Wood Preservation",
                                "keywords": "arsenate chromated common compounds copper creosote cutting decay fire inorganic insects lumber method most pilings plywood poles posts preservation preservatives pressure prevent produced products protect roundwood size treating used water-borne wood"
                            }
                        ]
                    },
                    {
                        "id": "3212",
                        "text": "Veneer, Plywood and Engineered Wood Product Manufacturing",
                        "keywords": "according adhesives alternate assembling binders components compressing criteria crosswise design engineered engineering gluing grain hardwood joining laid laminated laminating layers logs lumber made manufacturing materials members panel peeling plywood pressure processes produced product products reconstituted sheet sheets slicing softwood specified structural thickness thin together uniform veneer wood",
                        "children": [
                            {
                                "id": "321217",
                                "text": "Waferboard Mills",
                                "keywords": "aspen binder bonded combined heat made manufacturing mills oriented osb pine poplar pressure products southern strandboard strands these together waferboard wafers waterproof wood yellow"
                            },
                            {
                                "id": "321212",
                                "text": "Softwood Veneer and Plywood Mills",
                                "keywords": "manufacturing mills plywood softwood veneer"
                            },
                            {
                                "id": "321211",
                                "text": "Hardwood Veneer and Plywood Mills",
                                "keywords": "hardwood manufacturing mills plywood veneer"
                            },
                            {
                                "id": "321215",
                                "text": "Structural Wood Product Manufacturing",
                                "keywords": "dimension lumber manufacturing members product solid structural timber wood"
                            },
                            {
                                "id": "321216",
                                "text": "Particle Board and Fibreboard Mills",
                                "keywords": "binder board bonded combined completely fibreboard fibres heat lignin made manufacturing mills operations partially particle particles pressure processing residue resistant together water wood"
                            }
                        ]
                    },
                    {
                        "id": "3219",
                        "text": "Other Wood Product Manufacturing",
                        "keywords": "manufacturing product products wood",
                        "children": [
                            {
                                "id": "321911",
                                "text": "Wood Window and Door Manufacturing",
                                "keywords": "covered door doors frames manufacturing metal plastic units window wood"
                            },
                            {
                                "id": "321919",
                                "text": "Other Millwork",
                                "keywords": "covered jointers lathes lumber machinery material millwork planers planing plastic products purchased routers seasoning shape these use wood woodworking"
                            },
                            {
                                "id": "321920",
                                "text": "Wood Container and Pallet Manufacturing",
                                "keywords": "assembly container containers cooper's manufacturing pallet pallets parts products ready shook wood"
                            },
                            {
                                "id": "321991",
                                "text": "Manufactured (Mobile) Home Manufacturing",
                                "keywords": "buildings built chassis connected continuous designed equipped home homes manufactured manufacturing mobile movement multiple non-residential portable sewage structures these units utilities water wheels"
                            },
                            {
                                "id": "321992",
                                "text": "Prefabricated Wood Building Manufacturing",
                                "keywords": "away building buildings cabins complete components construction erection houses log made manufacturing on-site panels pre-cut prefabricated sections site units wood"
                            },
                            {
                                "id": "321999",
                                "text": "All Other Miscellaneous Wood Product Manufacturing",
                                "keywords": "manufacturing miscellaneous product products wood"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "327",
                "text": "Non-Metallic Mineral Product Manufacturing",
                "keywords": "additives bricks cement ceramic chemicals cut finish glass granite grind heat limestone manufacturing marble mineral minerals mix non-metallic preparations product products refractories shape slate stone these",
                "children": [
                    {
                        "id": "3273",
                        "text": "Cement and Concrete Product Manufacturing",
                        "keywords": "blocks bricks cement concrete hydraulic manufacturing pipes product products ready-mix",
                        "children": [
                            {
                                "id": "327390",
                                "text": "Other Concrete Product Manufacturing",
                                "keywords": "concrete manufacturing product products"
                            },
                            {
                                "id": "327320",
                                "text": "Ready-Mix Concrete Manufacturing",
                                "keywords": "cement concrete crushed delivering gravel manufacturing mixing plastic purchaser ready-mix sand state stone together unhardened water"
                            },
                            {
                                "id": "327310",
                                "text": "Cement Manufacturing",
                                "keywords": "cement clinker dry grinding manufacturing processes production subsequent wet"
                            },
                            {
                                "id": "327330",
                                "text": "Concrete Pipe, Brick and Block Manufacturing",
                                "keywords": "aggregate block brick cement concrete manufacturing mixture pipe water"
                            }
                        ]
                    },
                    {
                        "id": "327120",
                        "text": "Clay Building Material and Refractory Manufacturing",
                        "keywords": "baking building burning clay hardening made manufacturing material materials moulding products properties refractories refractory shaping these"
                    },
                    {
                        "id": "327110",
                        "text": "Pottery, Ceramics and Plumbing Fixture Manufacturing",
                        "keywords": "ceramics china clay decorate fire firing fixture fixtures glazing made manufacturing materials moulding plumbing pottery products properties shaping these trade white whiteware"
                    },
                    {
                        "id": "327215",
                        "text": "Glass Product Manufacturing from Purchased Glass",
                        "keywords": "blowing glass hand manufacturing pressing product purchased remelting shaping"
                    },
                    {
                        "id": "327214",
                        "text": "Glass Manufacturing",
                        "keywords": "bundles cables cullet fibres glass made manufacturing optical products sand these unsheathed"
                    },
                    {
                        "id": "327990",
                        "text": "All Other Non-Metallic Mineral Product Manufacturing",
                        "keywords": "manufacturing mineral non-metallic product products"
                    },
                    {
                        "id": "327910",
                        "text": "Abrasive Product Manufacturing",
                        "keywords": "abrasive abrasive-coated grinding manufacturing materials product products wheels"
                    },
                    {
                        "id": "327420",
                        "text": "Gypsum Product Manufacturing",
                        "keywords": "composed gypsum manufacturing product products wholly"
                    },
                    {
                        "id": "327410",
                        "text": "Lime Manufacturing",
                        "keywords": "calcium carbonate crushing dead-burned dolomite hydrated lime limestone manufacturing quicklime roasting screening shells sources"
                    }
                ]
            },
            {
                "id": "322",
                "text": "Paper Manufacturing",
                "keywords": "cellulose converted cutting fibre fibres impurities involves manufacture manufacturing materials matting paper produced products pulp separating shaping sheet sources techniques these used various wood",
                "children": [
                    {
                        "id": "3221",
                        "text": "Pulp, Paper and Paperboard Mills",
                        "keywords": "alone converting manufacture manufacturing mills paper paperboard pulp",
                        "children": [
                            {
                                "id": "322111",
                                "text": "Mechanical Pulp Mills",
                                "keywords": "called groundwood important manufacturing material mechanical methods mills products pulp semi-chemical sometimes thermo-mechanical tmp"
                            },
                            {
                                "id": "322121",
                                "text": "Paper (except Newsprint) Mills",
                                "keywords": "converting manufacture manufacturing mills newsprint paper paperboard pulp"
                            },
                            {
                                "id": "322130",
                                "text": "Paperboard Mills",
                                "keywords": "converting manufacture manufacturing mills paperboard pulp"
                            },
                            {
                                "id": "322122",
                                "text": "Newsprint Mills",
                                "keywords": "groundwood manufacture manufacturing mills newsprint paper printing pulp"
                            },
                            {
                                "id": "322112",
                                "text": "Chemical Pulp Mills",
                                "keywords": "chemical kraft manufacturing material methods mills obtained paper process processes pulp soda sulphate waste"
                            }
                        ]
                    },
                    {
                        "id": "3222",
                        "text": "Converted Paper Product Manufacturing",
                        "keywords": "converted manufacturing paper paperboard product products purchased",
                        "children": [
                            {
                                "id": "322212",
                                "text": "Folding Paperboard Box Manufacturing",
                                "keywords": "box boxes folding manufacturing paperboard purchased"
                            },
                            {
                                "id": "322219",
                                "text": "Other Paperboard Container Manufacturing",
                                "keywords": "boxes cans container containers drums fibre food manufacturing paperboard purchased sanitary setup"
                            },
                            {
                                "id": "322220",
                                "text": "Paper Bag and Coated and Treated Paper Manufacturing",
                                "keywords": "aluminum bag bags coated film flexible foil laminated layer layers made manufacturing materials paper paperboard plastic produced products purchased several single together treated"
                            },
                            {
                                "id": "322299",
                                "text": "All Other Converted Paper Product Manufacturing",
                                "keywords": "cartons converted egg manufacturing moulded paper product products pulp purchased"
                            },
                            {
                                "id": "322211",
                                "text": "Corrugated and Solid Fibre Box Manufacturing",
                                "keywords": "box boxes corrugated fibre manufacturing paperboard products purchased sheets solid"
                            },
                            {
                                "id": "322230",
                                "text": "Stationery Product Manufacturing",
                                "keywords": "applications filing manufacturing paper product products stationery used writing"
                            },
                            {
                                "id": "322291",
                                "text": "Sanitary Paper Product Manufacturing",
                                "keywords": "converted disposable manufacturing materials paper product products purchased sanitary stock tampons textile"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "323",
                "text": "Printing and Related Support Activities",
                "keywords": "printing providing support",
                "children": [
                    {
                        "id": "323115",
                        "text": "Digital Printing",
                        "keywords": "colour-separation computer computer-controlled digital digitized documents electrostatic equipment extensive file graphical high-resolution image ink input itself jet nature non-impact operations pre-press print printed printer printing scanned scanners simply specialized spray these use"
                    },
                    {
                        "id": "323116",
                        "text": "Manifold Business Forms Printing",
                        "keywords": "business forms manifold printing"
                    },
                    {
                        "id": "323113",
                        "text": "Commercial Screen Printing",
                        "keywords": "capability clothing commercial cut documents equipment graphical large-format lettering nature paper pictures pre-press print printing produce screen sign-type silk-screen stencils these"
                    },
                    {
                        "id": "323114",
                        "text": "Quick Printing",
                        "keywords": "capability commercial non-impact offset pre-press printers printing quick small"
                    },
                    {
                        "id": "323119",
                        "text": "Other Printing",
                        "keywords": "printing"
                    },
                    {
                        "id": "323120",
                        "text": "Support Activities for Printing",
                        "keywords": "bindery commercial pre-press printers printing providing services support work"
                    }
                ]
            },
            {
                "id": "324",
                "text": "Petroleum and Coal Product Manufacturing",
                "keywords": "coal components cracking crude distillation dominant end fractions intermediate manufacturing petroleum process product products refining separates techniques transforming",
                "children": [
                    {
                        "id": "324122",
                        "text": "Asphalt Shingle and Coating Material Manufacturing",
                        "keywords": "asphalt bituminous cements coating coatings felts manufacturing material materials mats purchased rolls roofing saturating sheets shingle shingles"
                    },
                    {
                        "id": "324190",
                        "text": "Other Petroleum and Coal Product Manufacturing",
                        "keywords": "coal manufacturing petroleum product products re-refining used"
                    },
                    {
                        "id": "324121",
                        "text": "Asphalt Paving Mixture and Block Manufacturing",
                        "keywords": "asphalt bituminous block blocks coal manufacturing materials mixture mixtures paving purchased tar"
                    },
                    {
                        "id": "324110",
                        "text": "Petroleum Refineries",
                        "keywords": "cracking crude distillation involves oil petroleum processes refineries refining transformation"
                    }
                ]
            },
            {
                "id": "325",
                "text": "Chemical Manufacturing",
                "keywords": "chemical chemicals inorganic manufacturing materials organic preparations raw",
                "children": [
                    {
                        "id": "3251",
                        "text": "Basic Chemical Manufacturing",
                        "keywords": "basic chemical chemically-defined chemicals compounds cracking distillation elements manufacturing processes produced separate thermal",
                        "children": [
                            {
                                "id": "325190",
                                "text": "Other Basic Organic Chemical Manufacturing",
                                "keywords": "acids alcohol alicyclic basic chemical chemicals chloride class coal distillation esters ethanol ethyl ethylene fatty glycol hydrocarbon main manufacture manufacturing methanol non-beverage organic products tar use vinyl wood"
                            },
                            {
                                "id": "325189",
                                "text": "All Other Basic Inorganic Chemical Manufacturing",
                                "keywords": "basic chemical chemicals inorganic manufacturing"
                            },
                            {
                                "id": "325181",
                                "text": "Alkali and Chlorine Manufacturing",
                                "keywords": "alkali alkalies chlorine manufacturing"
                            },
                            {
                                "id": "325130",
                                "text": "Synthetic Dye and Pigment Manufacturing",
                                "keywords": "dye dyes inorganic lakes manufacturing organic pigment pigments synthetic toners"
                            },
                            {
                                "id": "325120",
                                "text": "Industrial Gas Manufacturing",
                                "keywords": "compressed forms gas gases industrial inorganic liquid manufacturing organic solid"
                            },
                            {
                                "id": "325110",
                                "text": "Petrochemical Manufacturing",
                                "keywords": "acyclic aliphatic aromatic converting cracking cyclic defining derived feedstocks gas hydrocarbons important liquids manufacturing natural petrochemical petrochemicals petroleum processes purpose reforming steam used"
                            }
                        ]
                    },
                    {
                        "id": "3252",
                        "text": "Resin, Synthetic Rubber, and Artificial and Synthetic Fibres and Filaments Manufacturing",
                        "keywords": "artificial basic fibres filaments manufacturing monomers polymerization polymers polystyrene process resin resins rubber styrene synthetic textile",
                        "children": [
                            {
                                "id": "325220",
                                "text": "Artificial and Synthetic Fibres and Filaments Manufacturing",
                                "keywords": "artificial cellulose derived fibres filament filaments form made mainly manufacture manufacturing materials monofilament natural organic petrochemicals polymers raw staple synthetic texture tow yarn"
                            },
                            {
                                "id": "325210",
                                "text": "Resin and Synthetic Rubber Manufacturing",
                                "keywords": "basic chemicals manufacturing materials organic plastics resin resins rubber synthetic"
                            }
                        ]
                    },
                    {
                        "id": "3253",
                        "text": "Pesticide, Fertilizer and Other Agricultural Chemical Manufacturing",
                        "keywords": "agricultural chemical chemicals control fertilizer fertilizers household manufacturing materials mixed nitrogenous pest pesticide phosphoric",
                        "children": [
                            {
                                "id": "325320",
                                "text": "Pesticide and Other Agricultural Chemical Manufacturing",
                                "keywords": "agricultural chemical chemicals control fertilizers household manufacturing pest pesticide products"
                            },
                            {
                                "id": "325313",
                                "text": "Chemical Fertilizer (except Potash) Manufacturing",
                                "keywords": "acid ammonia chemical compost fertilizer fertilizers ingredients manufacture manufacturing material materials mixing mixtures natural nitric nitrogenous organic phosphoric potash producing these urea use whether"
                            },
                            {
                                "id": "325314",
                                "text": "Mixed Fertilizer Manufacturing",
                                "keywords": "elsewhere fertilizer fertilizers ingredients manufacturing mixed mixing produced"
                            }
                        ]
                    },
                    {
                        "id": "3254",
                        "text": "Pharmaceutical and Medicine Manufacturing",
                        "keywords": "ampoules animal basic chemical distillation drugs external extraction fermentation forms grading grinding human internal manufacturing medicine medicines milling ointments packaging pharmaceutical processes products several solvent synthesis tablets undertake use vials",
                        "children": [
                            {
                                "id": "325410",
                                "text": "Pharmaceutical and Medicine Manufacturing",
                                "keywords": "ampoules animal basic chemical distillation drugs external extraction fermentation forms grading grinding human internal manufacturing medicine medicines milling ointments packaging pharmaceutical processes products several solvent synthesis tablets undertake use vials"
                            }
                        ]
                    },
                    {
                        "id": "3255",
                        "text": "Paint, Coating and Adhesive Manufacturing",
                        "keywords": "adhesive adhesives coating coatings manufacturing paint paints",
                        "children": [
                            {
                                "id": "325520",
                                "text": "Adhesive Manufacturing",
                                "keywords": "adhesive adhesives glue manufacturing products"
                            },
                            {
                                "id": "325510",
                                "text": "Paint and Coating Manufacturing",
                                "keywords": "binders coating coatings manufacturing mixing paint paints pigments products solvents stains"
                            }
                        ]
                    },
                    {
                        "id": "3256",
                        "text": "Soap, Cleaning Compound and Toilet Preparation Manufacturing",
                        "keywords": "cleaning compound compounds manufacturing preparation preparations soap toilet",
                        "children": [
                            {
                                "id": "325620",
                                "text": "Toilet Preparation Manufacturing",
                                "keywords": "blending compounding manufacturing preparation preparations preparing toilet"
                            },
                            {
                                "id": "325610",
                                "text": "Soap and Cleaning Compound Manufacturing",
                                "keywords": "cleaning compound compounds manufacturing soap"
                            }
                        ]
                    },
                    {
                        "id": "3259",
                        "text": "Other Chemical Product Manufacturing",
                        "keywords": "chemical manufacturing product products",
                        "children": [
                            {
                                "id": "325999",
                                "text": "All Other Miscellaneous Chemical Product Manufacturing",
                                "keywords": "chemical manufacturing miscellaneous product products"
                            },
                            {
                                "id": "325920",
                                "text": "Explosives Manufacturing",
                                "keywords": "ammunition detonators devices explosive explosives manufacturing preparations"
                            },
                            {
                                "id": "325991",
                                "text": "Custom Compounding of Purchased Resins",
                                "keywords": "blending compounding custom mixing plastics products purchased recycled resins"
                            },
                            {
                                "id": "325910",
                                "text": "Printing Ink Manufacturing",
                                "keywords": "black cartridges coloured ink inks jet manufacture manufacturing printing whether"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "326",
                "text": "Plastics and Rubber Products Manufacturing",
                "keywords": "because combined exception goods just made major manufacture manufacturing material materials plastics plastics-based polymers processing products properties raw rubber rubber- technical these tire",
                "children": [
                    {
                        "id": "3261",
                        "text": "Plastic Product Manufacturing",
                        "keywords": "blow casting compression extrusion final injection intermediate manufacturing most moulding new plastic plastics process processes produced product production products recycled resins these used variety wide",
                        "children": [
                            {
                                "id": "326111",
                                "text": "Plastic Bag and Pouch Manufacturing",
                                "keywords": "bag bags cellulose coat converting films form laminate manufacture manufacturing plastic plastics pouch print resins sheets unsupported"
                            },
                            {
                                "id": "326150",
                                "text": "Urethane and Other Foam Product (except Polystyrene) Manufacturing",
                                "keywords": "converting foam manufacturing plastics polystyrene product products resins urethane"
                            },
                            {
                                "id": "326130",
                                "text": "Laminated Plastic Plate or Sheet (except Packaging) and Shape Manufacturing",
                                "keywords": "bonding compressing heat impregnating involves laminated laminating lamination manufacturing packaging plastic plastics plate plates process profile profiles resins rods shape shapes sheet sheets"
                            },
                            {
                                "id": "326196",
                                "text": "Plastic Window and Door Manufacturing",
                                "keywords": "door doors manufacturing plastic window windows"
                            },
                            {
                                "id": "326198",
                                "text": "All Other Plastic Product Manufacturing",
                                "keywords": "manufacturing plastic product products"
                            },
                            {
                                "id": "326191",
                                "text": "Plastic Plumbing Fixture Manufacturing",
                                "keywords": "fixture fixtures manufacturing plastic plumbing"
                            },
                            {
                                "id": "326193",
                                "text": "Motor Vehicle Plastic Parts Manufacturing",
                                "keywords": "assembly basic extrusion fabrication manufacturing motor moulding parts plastic plastics processes produced these vehicle vehicles without"
                            },
                            {
                                "id": "326160",
                                "text": "Plastic Bottle Manufacturing",
                                "keywords": "blow bottle bottles casting manufacturing moulding plastic"
                            },
                            {
                                "id": "326140",
                                "text": "Polystyrene Foam Product Manufacturing",
                                "keywords": "converting foam manufacturing polystyrene product products resins"
                            },
                            {
                                "id": "326121",
                                "text": "Unlaminated Plastic Profile Shape Manufacturing",
                                "keywords": "bags converting films manufacturing plastic plastics profile resins shape shapes sheets unlaminated unsupported"
                            },
                            {
                                "id": "326122",
                                "text": "Plastic Pipe and Pipe Fitting Manufacturing",
                                "keywords": "converting fitting fittings manufacturing pipe pipes plastic plastics resins"
                            },
                            {
                                "id": "326114",
                                "text": "Plastic Film and Sheet Manufacturing",
                                "keywords": "converting film manufacturing plastic plastics resins sheet unsupported"
                            }
                        ]
                    },
                    {
                        "id": "3262",
                        "text": "Rubber Product Manufacturing",
                        "keywords": "cementing extruding final intermediate lathe-cutting manufacturing materials moulding natural processes processing product products reclaimed rubber synthetic vulcanizing",
                        "children": [
                            {
                                "id": "326290",
                                "text": "Other Rubber Product Manufacturing",
                                "keywords": "manufacturing product products rubber"
                            },
                            {
                                "id": "326220",
                                "text": "Rubber and Plastic Hose and Belting Manufacturing",
                                "keywords": "belting hose manufacturing natural plastic plastics reinforced resins rubber synthetic"
                            },
                            {
                                "id": "326210",
                                "text": "Tire Manufacturing",
                                "keywords": "inner manufacturing natural rebuilding retreading rubber synthetic tire tires tubes"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "331",
                "text": "Primary Metal Manufacturing",
                "keywords": "alloys bars basic blast castings chemical drawing electric elements ferrous form furnaces ingot introduction made manufacturing metal metals molten non-ferrous operations ore output pig primary produce products refining rods rolling scrap sheet smelting strip used wire",
                "children": [
                    {
                        "id": "3311",
                        "text": "Iron and Steel Mills and Ferro-Alloy Manufacturing",
                        "keywords": "arc bars basic carbon cast combustion converting electric fabricated ferro-alloy ferro-alloys form furnace furnaces ingots iron manufacturing mills mini-mills molten ore pig plates produce producing products removal rods scrap shapes sheets smelting solid steel strips these",
                        "children": [
                            {
                                "id": "331110",
                                "text": "Iron and Steel Mills and Ferro-Alloy Manufacturing",
                                "keywords": "arc bars basic carbon cast combustion converting electric fabricated ferro-alloy ferro-alloys form furnace furnaces ingots iron manufacturing mills mini-mills molten ore pig plates produce producing products removal rods scrap shapes sheets smelting solid steel strips these"
                            }
                        ]
                    },
                    {
                        "id": "3312",
                        "text": "Steel Product Manufacturing from Purchased Steel",
                        "keywords": "drawing iron manufacturing pipe product purchased rolling shapes steel tube wire",
                        "children": [
                            {
                                "id": "331210",
                                "text": "Iron and Steel Pipes and Tubes Manufacturing from Purchased Steel",
                                "keywords": "heavy iron manufacturing pipes production purchased rivetted seamless steel tubes welded"
                            },
                            {
                                "id": "331222",
                                "text": "Steel Wire Drawing",
                                "keywords": "bars die drawing iron manufacturing produce products purchased rods steel wire"
                            },
                            {
                                "id": "331221",
                                "text": "Cold-Rolled Steel Shape Manufacturing",
                                "keywords": "bars cold-rolled cold-rolling hot-rolling manufacturing purchased re-heating shape shapes sheets steel strips"
                            }
                        ]
                    },
                    {
                        "id": "3313",
                        "text": "Alumina and Aluminum Production and Processing",
                        "keywords": "alloy alloying alumina aluminum aluminum-based basic bauxite casting drawing extracting extruding ore process processing producing production refining rolling shapes",
                        "children": [
                            {
                                "id": "331313",
                                "text": "Primary Production of Alumina and Aluminum",
                                "keywords": "alumina aluminum basic bauxite casting drawing extracting extruding primary produced producing production rolling secondary shapes"
                            },
                            {
                                "id": "331317",
                                "text": "Aluminum Rolling, Drawing, Extruding and Alloying",
                                "keywords": "alloying alloys aluminum basic beverage cans cold-rolling drawing extruding foil hot- ingots insulating operations plate produce products purchased re-alloying recovering rolling scrap shapes sheet whether wire works"
                            }
                        ]
                    },
                    {
                        "id": "3314",
                        "text": "Non-Ferrous Metal (except Aluminum) Production and Processing",
                        "keywords": "alloying aluminum drawing extruding metal non-ferrous processing production refining rolling smelting",
                        "children": [
                            {
                                "id": "331410",
                                "text": "Non-Ferrous Metal (except Aluminum) Smelting and Refining",
                                "keywords": "aluminum basic electrolytic extruding metal metals non-ferrous ores processes produced refining rolling secondary shapes smelting these"
                            },
                            {
                                "id": "331420",
                                "text": "Copper Rolling, Drawing, Extruding and Alloying",
                                "keywords": "alloying alloys bars brass bronze copper copper-based drawing extruding insulating operations plates produce products re-alloying recovering rolling scrap sheets specialty strips tubing whether wire works"
                            },
                            {
                                "id": "331490",
                                "text": "Non-Ferrous Metal (except Copper and Aluminum) Rolling, Drawing, Extruding and Alloying",
                                "keywords": "alloying alloys aluminum bars copper drawing extruding insulating metal metals non-ferrous operations plates produce products re-alloying recovering rolling scrap sheets specialty strips these tubing whether wire works"
                            }
                        ]
                    },
                    {
                        "id": "3315",
                        "text": "Foundries",
                        "keywords": "castings dies form foundries metal molten moulds pouring",
                        "children": [
                            {
                                "id": "331529",
                                "text": "Non-Ferrous Foundries (except Die-Casting)",
                                "keywords": "aluminum castings copper die-casting foundries high manufacture metal molten moulds non-ferrous pouring pressure without zinc"
                            },
                            {
                                "id": "331511",
                                "text": "Iron Foundries",
                                "keywords": "alloy castings foundries iron irons manufacture molten moulds pig pouring"
                            },
                            {
                                "id": "331514",
                                "text": "Steel Foundries",
                                "keywords": "castings foundries full investment manufacture molten moulds pouring steel"
                            },
                            {
                                "id": "331523",
                                "text": "Non-Ferrous Die-Casting Foundries",
                                "keywords": "aluminum castings copper die die-casting foundries high introducing manufacture metal molten mould non-ferrous pressure zinc"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "332",
                "text": "Fabricated Metal Product Manufacturing",
                "keywords": "architectural boilers bolts containers cutlery fabricated ferrous forging forming hand hardware joining manufacturing metal non-ferrous nuts processes produce product products screws shipping spring stamping structural tanks tools turned turning wire",
                "children": [
                    {
                        "id": "3321",
                        "text": "Forging and Stamping",
                        "keywords": "basis cutting deburring final forging forgings form grinding hot inter-plant job manufacturing metal near operate order pressing process produce produced sale shape shaping sheet size stamping stampings stock surface-finish these they transfer",
                        "children": [
                            {
                                "id": "332113",
                                "text": "Forging",
                                "keywords": "cavity create cross deburring dies draw drop forge forging forgings forming grinding hammer hammers hot hydraulic increase involves length metal out parts piercing press presses process produced reduce roll section squeezing surface-finish techniques these they upset use"
                            },
                            {
                                "id": "332118",
                                "text": "Stamping",
                                "keywords": "bend closing closings completed custom cut deburred die dies essentially features form formed holes involved mated metal motion multiple notches operation operations press profiles roll-forming rolls rotary series several sheet-metal single size slots stamping stock various"
                            }
                        ]
                    },
                    {
                        "id": "3322",
                        "text": "Cutlery and Hand Tool Manufacturing",
                        "keywords": "cutlery edge files hand maintenance manufacturing metalworking tool tools woodworking",
                        "children": [
                            {
                                "id": "332210",
                                "text": "Cutlery and Hand Tool Manufacturing",
                                "keywords": "cutlery edge files hand maintenance manufacturing metalworking tool tools woodworking"
                            }
                        ]
                    },
                    {
                        "id": "3323",
                        "text": "Architectural and Structural Metals Manufacturing",
                        "keywords": "architectural fabricating manufacturing metal metals products purposes structural",
                        "children": [
                            {
                                "id": "332311",
                                "text": "Prefabricated Metal Building and Component Manufacturing",
                                "keywords": "building buildings component manufacturing metal pre-engineered prefabricated"
                            },
                            {
                                "id": "332314",
                                "text": "Concrete Reinforcing Bar Manufacturing",
                                "keywords": "assemblies bar bars bending concrete cutting deformed fabrications manufacturing purchased reinforcing shaping"
                            },
                            {
                                "id": "332319",
                                "text": "Other Plate Work and Fabricated Structural Product Manufacturing",
                                "keywords": "according assembly bending custom cutting design engage fabricated fabricating fabrication factory field installation manufacturing plate product products punching purchased shaping standard steel structural these welding work"
                            },
                            {
                                "id": "332321",
                                "text": "Metal Window and Door Manufacturing",
                                "keywords": "aluminum door doors frames manufacturing metal moulding sash screens steel trim window windows"
                            },
                            {
                                "id": "332329",
                                "text": "Other Ornamental and Architectural Metal Product Manufacturing",
                                "keywords": "architectural manufacturing metal ornamental product products"
                            }
                        ]
                    },
                    {
                        "id": "3324",
                        "text": "Boiler, Tank and Shipping Container Manufacturing",
                        "keywords": "boiler boilers boxes cans container containers cutting exchangers forming gauge heat heavy joining light manufacture manufacturing metal power products shipping tank tanks",
                        "children": [
                            {
                                "id": "332420",
                                "text": "Metal Tank (Heavy Gauge) Manufacturing",
                                "keywords": "assembled cutting erecting fabricating forming gauge heavy joining large manufacture manufacturing metal must site steel storage tank tanks"
                            },
                            {
                                "id": "332431",
                                "text": "Metal Can Manufacturing",
                                "keywords": "aluminum cans chrome containers manufacturing metal oxide-coated purchased sheet steel"
                            },
                            {
                                "id": "332439",
                                "text": "Other Metal Container Manufacturing",
                                "keywords": "container containers gauge light manufacturing metal sheet"
                            },
                            {
                                "id": "332410",
                                "text": "Power Boiler and Heat Exchanger Manufacturing",
                                "keywords": "assembly bars boiler boilers custom cutting design engage exchanger exchangers fabrication factory field forming generated heat industrial installation joining manufacturing metal mill nuclear parts pipe plates power process products sheets standard steam these tubing"
                            }
                        ]
                    },
                    {
                        "id": "3325",
                        "text": "Hardware Manufacturing",
                        "keywords": "hardware manufacturing metal",
                        "children": [
                            {
                                "id": "332510",
                                "text": "Hardware Manufacturing",
                                "keywords": "hardware manufacturing metal"
                            }
                        ]
                    },
                    {
                        "id": "3326",
                        "text": "Spring and Wire Product Manufacturing",
                        "keywords": "made manufacturing product products purchased spring wire",
                        "children": [
                            {
                                "id": "332611",
                                "text": "Spring (Heavy Gauge) Manufacturing",
                                "keywords": "equipment gauge heavy machinery manufacturing motor spring springs these transportation used vehicles"
                            },
                            {
                                "id": "332619",
                                "text": "Other Fabricated Wire Product Manufacturing",
                                "keywords": "fabricated manufacturing product products purchased wire"
                            }
                        ]
                    },
                    {
                        "id": "3327",
                        "text": "Machine Shops, Turned Product, and Screw, Nut and Bolt Manufacturing",
                        "keywords": "automatic bolt bolts boring complete fasteners industrial lathes machine machines manufacture manufacturing metal nut nuts operating parts product production runs screw screws set shaping shops threading tools trade turned turning use",
                        "children": [
                            {
                                "id": "332710",
                                "text": "Machine Shops",
                                "keywords": "automatic boring complete computer controlled custom equipment grinding lathes machine machines metal milling numerically operating parts produce providing repair screw services shops tools trade working"
                            },
                            {
                                "id": "332720",
                                "text": "Turned Product and Screw, Nut and Bolt Manufacturing",
                                "keywords": "bolt bolts boring cutting facing fasteners forming knurling lathes machine machine-held manufacture manufacturing metal nut nuts parting precision product products rivets screw threading tools turned turning washers"
                            }
                        ]
                    },
                    {
                        "id": "3328",
                        "text": "Coating, engraving, cold and heat treating and allied activities",
                        "keywords": "addition allied brazing coating colouring electroplating engraving harden hardening heat heating involve materials metal metals perform plastics plating polishing precious processes processing products purpose re-chroming sand-blasting similarly tempering these trade treating well",
                        "children": [
                            {
                                "id": "332810",
                                "text": "Coating, engraving, cold and heat treating and allied activities",
                                "keywords": "addition allied brazing coating colouring electroplating engraving harden hardening heat heating involve materials metal metals perform plastics plating polishing precious processes processing products purpose re-chroming sand-blasting similarly tempering these trade treating well"
                            }
                        ]
                    },
                    {
                        "id": "3329",
                        "text": "Other Fabricated Metal Product Manufacturing",
                        "keywords": "fabricated fabricating manufacturing metal product products",
                        "children": [
                            {
                                "id": "332910",
                                "text": "Metal Valve Manufacturing",
                                "keywords": "assemblies casting fittings fixtures flow fluids gases hydraulic liquids machining manufacturing metal pipe pneumatic regulate tube used valve valves"
                            },
                            {
                                "id": "332991",
                                "text": "Ball and Roller Bearing Manufacturing",
                                "keywords": "ball bearing bearings manufacturing parts races roller"
                            },
                            {
                                "id": "332999",
                                "text": "All Other Miscellaneous Fabricated Metal Product Manufacturing",
                                "keywords": "fabricated fabricating manufacturing metal miscellaneous product products"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "333",
                "text": "Machinery Manufacturing",
                "keywords": "agriculture applications assemble between broad commercial complete components designed distinction exists general-purpose groups industrial machine machinery machines machining manufacturing metal-working new parts principally printing processes produce producing pumping purchase rebuilding reflected remaining solely specialize special-purpose specified structure subassemblies tend themselves these they unless use used variety",
                "children": [
                    {
                        "id": "3331",
                        "text": "Agricultural, Construction and Mining Machinery Manufacturing",
                        "keywords": "agricultural agriculture construction designed machinery manufacturing mining use",
                        "children": [
                            {
                                "id": "333110",
                                "text": "Agricultural Implement Manufacturing",
                                "keywords": "agricultural care crops farm field harvesting horticultural implement lawn machinery maintenance manufacturing market operations performing planting preparation preparing residential snowblowers soil spraying threshing use"
                            },
                            {
                                "id": "333120",
                                "text": "Construction Machinery Manufacturing",
                                "keywords": "attachments blade bulldozer concrete construction cranes crawler equipment forestry front-end handling harvesting heavy loaders machinery manufacturing mining mixers pavers power ripper rubber-tired shovels tooth tractors treated tree used"
                            },
                            {
                                "id": "333130",
                                "text": "Mining and Oil and Gas Field Machinery Manufacturing",
                                "keywords": "equipment field gas machinery manufacturing mining oil"
                            }
                        ]
                    },
                    {
                        "id": "3332",
                        "text": "Industrial Machinery Manufacturing",
                        "keywords": "designed industrial machinery manufacturing specific use",
                        "children": [
                            {
                                "id": "333245",
                                "text": "Sawmill and Woodworking Machinery Manufacturing",
                                "keywords": "logs lumber machinery manufacturing processing sawmill used woodworking"
                            },
                            {
                                "id": "333246",
                                "text": "Rubber and Plastics Industry Machinery Manufacturing",
                                "keywords": "machinery manufacturing materials plastics processing rubber used"
                            },
                            {
                                "id": "333247",
                                "text": "Paper Industry Machinery Manufacturing",
                                "keywords": "machinery manufacturing paper paper-making"
                            },
                            {
                                "id": "333248",
                                "text": "All Other Industrial Machinery Manufacturing",
                                "keywords": "industrial machinery manufacturing"
                            }
                        ]
                    },
                    {
                        "id": "3333",
                        "text": "Commercial and Service Industry Machinery Manufacturing",
                        "keywords": "commercial machinery manufacturing service use",
                        "children": [
                            {
                                "id": "333310",
                                "text": "Commercial and Service Industry Machinery Manufacturing",
                                "keywords": "commercial machinery manufacturing service use"
                            }
                        ]
                    },
                    {
                        "id": "3334",
                        "text": "Ventilation, Heating, Air-Conditioning and Commercial Refrigeration Equipment Manufacturing",
                        "keywords": "air-conditioning commercial equipment heating manufacturing refrigeration ventilation",
                        "children": [
                            {
                                "id": "333413",
                                "text": "Industrial and Commercial Fan and Blower and Air Purification Equipment Manufacturing",
                                "keywords": "air blower blowers commercial equipment fan industrial manufacturing purification"
                            },
                            {
                                "id": "333416",
                                "text": "Heating Equipment and Commercial Refrigeration Equipment Manufacturing",
                                "keywords": "commercial electric equipment heating industrial manufacturing non-electric refrigeration"
                            }
                        ]
                    },
                    {
                        "id": "3335",
                        "text": "Metalworking Machinery Manufacturing",
                        "keywords": "accessories attachments cutting dies fixtures forming hand hands industrial jigs machine machinery manufacturing metal metalworking moulds operator products rolls supported tool tools use",
                        "children": [
                            {
                                "id": "333511",
                                "text": "Industrial Mould Manufacturing",
                                "keywords": "casting industrial machining manufacturing metal mould moulds"
                            },
                            {
                                "id": "333519",
                                "text": "Other Metalworking Machinery Manufacturing",
                                "keywords": "accessories attachments cutting dies fixtures forming hand hands industrial jigs machine machinery manufacturing metal metalworking moulds operator products rolls supported tool tools use"
                            }
                        ]
                    },
                    {
                        "id": "3336",
                        "text": "Engine, Turbine and Power Transmission Equipment Manufacturing",
                        "keywords": "aircraft automotive changers combustion drives electric engine engines equipment gasoline gears generating generator generators high-speed industrial internal manufacturing power sets solar-powered speed transmission turbine turbines wind- windmills",
                        "children": [
                            {
                                "id": "333619",
                                "text": "Other Engine and Power Transmission Equipment Manufacturing",
                                "keywords": "engine equipment manufacturing power transmission"
                            },
                            {
                                "id": "333611",
                                "text": "Turbine and Turbine Generator Set Unit Manufacturing",
                                "keywords": "generator manufacturing set sets turbine turbines unit"
                            }
                        ]
                    },
                    {
                        "id": "3339",
                        "text": "Other General-Purpose Machinery Manufacturing",
                        "keywords": "designed general-purpose machinery manufacturing specific use",
                        "children": [
                            {
                                "id": "333990",
                                "text": "All Other General-Purpose Machinery Manufacturing",
                                "keywords": "designed general-purpose machinery manufacturing specific use"
                            },
                            {
                                "id": "333910",
                                "text": "Pump and Compressor Manufacturing",
                                "keywords": "compressor compressors equipment manufacturing pump pumping pumps use"
                            },
                            {
                                "id": "333920",
                                "text": "Material Handling Equipment Manufacturing",
                                "keywords": "equipment handling manufacturing material"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "334",
                "text": "Computer and Electronic Product Manufacturing",
                "keywords": "application characterized circuits communications components computer computers design electronic employ equipment highly integrated manufacturing miniaturization peripheral processes product production products specialized technologies use well",
                "children": [
                    {
                        "id": "3341",
                        "text": "Computer and Peripheral Equipment Manufacturing",
                        "keywords": "accordance analogue arithmetical assembled assemblies atm's automated bar board capable cd-rom circuit classification code common complete components comprise computations computer computers computer's control data decision designed devices digital disk drives dumb during elements equipment execute execution following freely housing human hybrid immediately important input-output inside installed intervention joysticks keyboards kits least loaded logical machines manufacturing mathematical mice models modify monitors most must necessary outside perform peripheral peripherals point-of-sale pos printers processing program programmed programming programs purchaser purposes readers requirements requires run scanners self-contained simulating sold specified storage store teller terminals treated types use user without",
                        "children": [
                            {
                                "id": "334110",
                                "text": "Computer and Peripheral Equipment Manufacturing",
                                "keywords": "accordance analogue arithmetical assembled assemblies atm's automated bar board capable cd-rom circuit classification code common complete components comprise computations computer computers computer's control data decision designed devices digital disk drives dumb during elements equipment execute execution following freely housing human hybrid immediately important input-output inside installed intervention joysticks keyboards kits least loaded logical machines manufacturing mathematical mice models modify monitors most must necessary outside perform peripheral peripherals point-of-sale pos printers processing program programmed programming programs purchaser purposes readers requirements requires run scanners self-contained simulating sold specified storage store teller terminals treated types use user without"
                            }
                        ]
                    },
                    {
                        "id": "3342",
                        "text": "Communications Equipment Manufacturing",
                        "keywords": "air apparatus broadcast communications electronically equipment manufacturing move radio satellite signals telephone television used wires",
                        "children": [
                            {
                                "id": "334210",
                                "text": "Telephone Apparatus Manufacturing",
                                "keywords": "apparatus board-level communications components data equipment larger manufacturing products stand-alone system telephone these wired"
                            },
                            {
                                "id": "334220",
                                "text": "Radio and Television Broadcasting and Wireless Communications Equipment Manufacturing",
                                "keywords": "broadcast broadcasting communication communications equipment manufacturing radio television wireless"
                            },
                            {
                                "id": "334290",
                                "text": "Other Communications Equipment Manufacturing",
                                "keywords": "communications equipment manufacturing"
                            }
                        ]
                    },
                    {
                        "id": "3343",
                        "text": "Audio and Video Equipment Manufacturing",
                        "keywords": "audio electronic equipment manufacturing video",
                        "children": [
                            {
                                "id": "334310",
                                "text": "Audio and Video Equipment Manufacturing",
                                "keywords": "audio electronic equipment manufacturing video"
                            }
                        ]
                    },
                    {
                        "id": "3344",
                        "text": "Semiconductor and Other Electronic Component Manufacturing",
                        "keywords": "bare boards circuit component components electronic flexible following laminate loading manufacture manufacturing material mounted onto printed production rigid semiconductor semiconductors undertaken without",
                        "children": [
                            {
                                "id": "334410",
                                "text": "Semiconductor and Other Electronic Component Manufacturing",
                                "keywords": "bare boards circuit component components electronic flexible following laminate loading manufacture manufacturing material mounted onto printed production rigid semiconductor semiconductors undertaken without"
                            }
                        ]
                    },
                    {
                        "id": "3345",
                        "text": "Navigational, Measuring, Medical and Control Instruments Manufacturing",
                        "keywords": "control controlling devices instruments manufacturing measuring medical navigational",
                        "children": [
                            {
                                "id": "334512",
                                "text": "Measuring, Medical and Controlling Devices Manufacturing",
                                "keywords": "controlling devices manufacturing measuring medical"
                            },
                            {
                                "id": "334511",
                                "text": "Navigational and Guidance Instruments Manufacturing",
                                "keywords": "equipment guidance instruments manufacturing navigational"
                            }
                        ]
                    },
                    {
                        "id": "3346",
                        "text": "Manufacturing and Reproducing Magnetic and Optical Media",
                        "keywords": "audio blank cd-roms disk diskettes hard magnetic manufacturing mass media multimedia optical products recorded recordings reproducing reproduction shrink-wrapped software tapes these video",
                        "children": [
                            {
                                "id": "334610",
                                "text": "Manufacturing and Reproducing Magnetic and Optical Media",
                                "keywords": "audio blank cd-roms disk diskettes hard magnetic manufacturing mass media multimedia optical products recorded recordings reproducing reproduction shrink-wrapped software tapes these video"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "335",
                "text": "Electrical Equipment, Appliance and Component Manufacturing",
                "keywords": "appliance component distribute electrical equipment generate manufacturing power products use",
                "children": [
                    {
                        "id": "3351",
                        "text": "Electric Lighting Equipment Manufacturing",
                        "keywords": "bulbs electric equipment fixtures lamp lighting manufacturing tubes",
                        "children": [
                            {
                                "id": "335110",
                                "text": "Electric Lamp Bulb and Parts Manufacturing",
                                "keywords": "bulb bulbs electric lamp lamps manufacturing parts tubes types"
                            },
                            {
                                "id": "335120",
                                "text": "Lighting Fixture Manufacturing",
                                "keywords": "fixture fixtures lamps lighting manufacturing"
                            }
                        ]
                    },
                    {
                        "id": "3352",
                        "text": "Household Appliance Manufacturing",
                        "keywords": "appliance appliances bathroom household kitchen manufacturing",
                        "children": [
                            {
                                "id": "335210",
                                "text": "Small Electrical Appliance Manufacturing",
                                "keywords": "appliance appliances commercial electrical household manufacturing small"
                            },
                            {
                                "id": "335223",
                                "text": "Major Kitchen Appliance Manufacturing",
                                "keywords": "appliance appliances electric equipment kitchen major manufacturing non-electric"
                            },
                            {
                                "id": "335229",
                                "text": "Other Major Appliance Manufacturing",
                                "keywords": "appliance appliances electric equipment household major manufacturing non-electric"
                            }
                        ]
                    },
                    {
                        "id": "3353",
                        "text": "Electrical Equipment Manufacturing",
                        "keywords": "distributes electrical equipment generates manufacturing power",
                        "children": [
                            {
                                "id": "335311",
                                "text": "Power, Distribution and Specialty Transformers Manufacturing",
                                "keywords": "distribution instrument manufacturing power specialty transformers"
                            },
                            {
                                "id": "335312",
                                "text": "Motor and Generator Manufacturing",
                                "keywords": "electric generator generators manufacturing motor motors"
                            },
                            {
                                "id": "335315",
                                "text": "Switchgear and Switchboard, and Relay and Industrial Control Apparatus Manufacturing",
                                "keywords": "apparatus control electrical equipment industrial manufacturing protective relay switchboard switchgear"
                            }
                        ]
                    },
                    {
                        "id": "3359",
                        "text": "Other Electrical Equipment and Component Manufacturing",
                        "keywords": "accessories carrying component current devices electrical equipment manufacturing power storage transmission",
                        "children": [
                            {
                                "id": "335930",
                                "text": "Wiring Device Manufacturing",
                                "keywords": "carrying current device devices manufacturing non-current wiring"
                            },
                            {
                                "id": "335990",
                                "text": "All Other Electrical Equipment and Component Manufacturing",
                                "keywords": "component components electrical equipment manufacturing"
                            },
                            {
                                "id": "335910",
                                "text": "Battery Manufacturing",
                                "keywords": "accumulator batteries battery manufacturing parts primary secondary storage thereof"
                            },
                            {
                                "id": "335920",
                                "text": "Communication and Energy Wire and Cable Manufacturing",
                                "keywords": "cable communication communications energy fibres insulating made manufacturing non-ferrous optical purchased wire"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "336",
                "text": "Transportation Equipment Manufacturing",
                "keywords": "- air based body complete equipment goods groups manufacture manufacturing modes new parts people products rail rebuilding road trailer transport transportation transporting various vehicles water",
                "children": [
                    {
                        "id": "3361",
                        "text": "Motor Vehicle Manufacturing",
                        "keywords": "assemble assemblies cab chassis complete manufacture manufacturing motor truck vehicle vehicles",
                        "children": [
                            {
                                "id": "336110",
                                "text": "Automobile and Light-Duty Motor Vehicle Manufacturing",
                                "keywords": "automobile cars chassis electric highway light-duty manufacture manufacturing motor use vehicle vehicles"
                            },
                            {
                                "id": "336120",
                                "text": "Heavy-Duty Truck Manufacturing",
                                "keywords": "chassis heavy-duty highway manufacturing truck use vehicle vehicles"
                            }
                        ]
                    },
                    {
                        "id": "3362",
                        "text": "Motor Vehicle Body and Trailer Manufacturing",
                        "keywords": "assembled bodies body cabs chassis manufacturing motor non-commercial purchased sold trailer trailers truck vehicle",
                        "children": [
                            {
                                "id": "336211",
                                "text": "Motor Vehicle Body Manufacturing",
                                "keywords": "ambulances bodies body bus cabs cars chassis completing fire-fighting heavy-duty kit light-duty limousines made manufacture manufactured manufacturing motor purchase purchased rest sale semi-complete separately specialty street-sweepers stretch thereby these truck vehicle vehicles"
                            },
                            {
                                "id": "336212",
                                "text": "Truck Trailer Manufacturing",
                                "keywords": "chassis manufacturing trailer trailers truck"
                            },
                            {
                                "id": "336215",
                                "text": "Motor Home, Travel Trailer and Camper Manufacturing",
                                "keywords": "camper home manufacturing motor non-commercial trailer trailers travel"
                            }
                        ]
                    },
                    {
                        "id": "3363",
                        "text": "Motor Vehicle Parts Manufacturing",
                        "keywords": "engines manufacture manufacturing motor new parts rebuild vehicle",
                        "children": [
                            {
                                "id": "336370",
                                "text": "Motor Vehicle Metal Stamping",
                                "keywords": "burrs defects final incidental manufacturing metal motor operation operations perform product removing stamping stampings vehicle work"
                            },
                            {
                                "id": "336390",
                                "text": "Other Motor Vehicle Parts Manufacturing",
                                "keywords": "accessories manufacturing motor parts vehicle"
                            },
                            {
                                "id": "336310",
                                "text": "Motor Vehicle Gasoline Engine and Engine Parts Manufacturing",
                                "keywords": "engine engines gasoline manufacturing motor parts rebuilding use vehicle vehicular whether"
                            },
                            {
                                "id": "336320",
                                "text": "Motor Vehicle Electrical and Electronic Equipment Manufacturing",
                                "keywords": "combustion electrical electronic engines equipment internal manufacturing motor rebuilding vehicle vehicles"
                            },
                            {
                                "id": "336330",
                                "text": "Motor Vehicle Steering and Suspension Components (except Spring) Manufacturing",
                                "keywords": "assemblies basis components factory manufacturing mechanisms motor pinion rack rebuilding spring springs steering suspension vehicle"
                            },
                            {
                                "id": "336340",
                                "text": "Motor Vehicle Brake System Manufacturing",
                                "keywords": "brake components manufacturing motor system systems vehicle"
                            },
                            {
                                "id": "336350",
                                "text": "Motor Vehicle Transmission and Power Train Parts Manufacturing",
                                "keywords": "manufacturing motor parts power rebuilding train transmission vehicle"
                            },
                            {
                                "id": "336360",
                                "text": "Motor Vehicle Seating and Interior Trim Manufacturing",
                                "keywords": "accessories belts equipment fabric interior kinds manufacturing motor safety seat seating seats straps transportation trim trimmings vehicle"
                            }
                        ]
                    },
                    {
                        "id": "3364",
                        "text": "Aerospace Product and Parts Manufacturing",
                        "keywords": "aerospace aircraft auxiliary conversion development engines equipment factory manufacturing missiles overhaul parts product production propulsion prototypes space systems thereof units vehicles",
                        "children": [
                            {
                                "id": "336410",
                                "text": "Aerospace Product and Parts Manufacturing",
                                "keywords": "aerospace aircraft auxiliary conversion development engines equipment factory manufacturing missiles overhaul parts product production propulsion prototypes space systems thereof units vehicles"
                            }
                        ]
                    },
                    {
                        "id": "3365",
                        "text": "Railroad Rolling Stock Manufacturing",
                        "keywords": "ballast cars distributors equipment frames gauge layers locomotives maintenance manufacture manufacturing parts rail railroad rail-tamping railway rapid rebuilding rolling self-propelled special-purpose stock track transit",
                        "children": [
                            {
                                "id": "336510",
                                "text": "Railroad Rolling Stock Manufacturing",
                                "keywords": "ballast cars distributors equipment frames gauge layers locomotives maintenance manufacture manufacturing parts rail railroad rail-tamping railway rapid rebuilding rolling self-propelled special-purpose stock track transit"
                            }
                        ]
                    },
                    {
                        "id": "3366",
                        "text": "Ship and Boat Building",
                        "keywords": "alteration barge boat boats building capable construction conversion docks dry equipment fabrication facilities fixed intended manufacturing operating performed personal prefabricated production recreational repair scaling sections services ship ships shipyard shipyards specialized use water-craft",
                        "children": [
                            {
                                "id": "336611",
                                "text": "Ship Building and Repairing",
                                "keywords": "alteration barge building capable construction conversion docks dry equipment fabrication facilities fixed intended operating performed personal prefabricated production recreational repair repairing scaling sections services ship ships shipyard shipyards specialized use water-craft"
                            },
                            {
                                "id": "336612",
                                "text": "Boat Building",
                                "keywords": "boat boats building intended manufacturing personal recreational use water-craft"
                            }
                        ]
                    },
                    {
                        "id": "3369",
                        "text": "Other Transportation Equipment Manufacturing",
                        "keywords": "equipment manufacturing parts transportation",
                        "children": [
                            {
                                "id": "336990",
                                "text": "Other Transportation Equipment Manufacturing",
                                "keywords": "equipment manufacturing parts transportation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "337",
                "text": "Furniture and Related Product Manufacturing",
                "keywords": "according aesthetic although application article aspect assembled assembling based basis component components custom cutting design designed designers establishment's force forming frame frames functional furniture hotels household important industrial knock-down laminating made manufacture manufacturing material materials methods moulding no offices own parts performed process processes produced product production products purchased qualities regard services shipped sofa standard stock treated unassembled upholstered used without work",
                "children": [
                    {
                        "id": "3371",
                        "text": "Household and Institutional Furniture and Kitchen Cabinet Manufacturing",
                        "keywords": "bathroom buildings cabinet cabinets churches counters designed furniture household households institutional institutions kitchen manufacturing public restaurants schools use vanities wood",
                        "children": [
                            {
                                "id": "337121",
                                "text": "Upholstered Household Furniture Manufacturing",
                                "keywords": "furniture household manufacturing upholstered"
                            },
                            {
                                "id": "337123",
                                "text": "Other Wood Household Furniture Manufacturing",
                                "keywords": "buildings designed dwellings furniture hotel household manufacturing private rooms upholstered use used wood"
                            },
                            {
                                "id": "337126",
                                "text": "Household Furniture (except Wood and Upholstered) Manufacturing",
                                "keywords": "furniture household manufacturing upholstered wood"
                            },
                            {
                                "id": "337127",
                                "text": "Institutional Furniture Manufacturing",
                                "keywords": "benches buildings churches designed factory furniture institutional institutions manufacturing public restaurants schools stands tool use work"
                            },
                            {
                                "id": "337110",
                                "text": "Wood Kitchen Cabinet and Counter Top Manufacturing",
                                "keywords": "bathroom cabinet cabinets counter counters designed installation kitchen manufacturing permanent top vanities wood"
                            }
                        ]
                    },
                    {
                        "id": "3372",
                        "text": "Office Furniture (including Fixtures) Manufacturing",
                        "keywords": "chairs designed desks fixtures frames furniture manufacturing office parts showcases store types use",
                        "children": [
                            {
                                "id": "337213",
                                "text": "Wood Office Furniture, including Custom Architectural Woodwork, Manufacturing",
                                "keywords": "architectural chairs consisting custom designed desks fixtures furniture interiors manufacturing office use utilizing wood woodwork"
                            },
                            {
                                "id": "337214",
                                "text": "Office Furniture (except Wood) Manufacturing",
                                "keywords": "chairs designed desks furniture manufacturing non-wood office use wood"
                            },
                            {
                                "id": "337215",
                                "text": "Showcase, Partition, Shelving and Locker Manufacturing",
                                "keywords": "applications cases display fixtures frames furniture locker lockers manufacturing office partition parts shelving showcase store types"
                            }
                        ]
                    },
                    {
                        "id": "3379",
                        "text": "Other Furniture-Related Product Manufacturing",
                        "keywords": "furniture-related manufacturing product products",
                        "children": [
                            {
                                "id": "337910",
                                "text": "Mattress Manufacturing",
                                "keywords": "manufacturing mattress mattresses products"
                            },
                            {
                                "id": "337920",
                                "text": "Blind and Shade Manufacturing",
                                "keywords": "blind blinds fixtures interior manufacturing shade shades use"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "339",
                "text": "Miscellaneous Manufacturing",
                "keywords": "diverse equipment goods jewellery manufacture manufacturing medical miscellaneous office products range sporting supplies these toys",
                "children": [
                    {
                        "id": "3391",
                        "text": "Medical Equipment and Supplies Manufacturing",
                        "keywords": "basis contact equipment eyeglasses factory grinding hard lenses manufacturing medical prescription supplies",
                        "children": [
                            {
                                "id": "339110",
                                "text": "Medical Equipment and Supplies Manufacturing",
                                "keywords": "basis contact equipment eyeglasses factory grinding hard lenses manufacturing medical prescription supplies"
                            }
                        ]
                    },
                    {
                        "id": "3399",
                        "text": "Other Miscellaneous Manufacturing",
                        "keywords": "manufacturing miscellaneous",
                        "children": [
                            {
                                "id": "339990",
                                "text": "All Other Miscellaneous Manufacturing",
                                "keywords": "manufacturing miscellaneous"
                            },
                            {
                                "id": "339920",
                                "text": "Sporting and Athletic Goods Manufacturing",
                                "keywords": "athletic clothing footwear goods manufacturing sporting"
                            },
                            {
                                "id": "339910",
                                "text": "Jewellery and Silverware Manufacturing",
                                "keywords": "carving chasing coins costume cultured cutting drilling engraving etching faceting flatware gem gems jewellery manufacturing metal novelties pearls peeling pewter plated polishing precious recutting repolishing sawing semiprecious setting silverware slabbing stamping stones tumbling ware"
                            },
                            {
                                "id": "339930",
                                "text": "Doll, Toy and Game Manufacturing",
                                "keywords": "doll dolls game games manufacturing toy toys"
                            },
                            {
                                "id": "339950",
                                "text": "Sign Manufacturing",
                                "keywords": "displays manufacturing materials paper paperboard sign signs"
                            },
                            {
                                "id": "339940",
                                "text": "Office Supplies (except Paper) Manufacturing",
                                "keywords": "manufacturing office paper supplies"
                            }
                        ]
                    }
                ]
            }
        ]
    },
 
   
    {
        "id": "41",
        "text": "Wholesale Trade",
        "keywords": "addition agents arrange banner based basis brokers business buy buying capital category claims client clients commission comprise co-op cooperatives customers dealer-owned dealers depending designations distribution distributors drop eight employ equipment fall farm fee final goods grouping groups handling heavy-duty however import-export institutional in-store intermediate inventory known labelling large line lines location locations logistics machinery main management manufacturer's marketing merchandise merchants method non-consumer office operate organized own owned packaging process product promotions provide providing provision quantities rack-jobbers recognizes relationship representatives retailers sale sell services ship shipment shippers shipping single step subsectors supplied supplier suppliers supply support take therefore these they title trade training trucks types units users variety warehouse warranty wholesale wholesaler wholesalers wholesaling within",
        "children": [
            {
                "id": "411",
                "text": "Farm Product Merchant wholesalers",
                "keywords": "farm grain livestock product products wholesaler-distributors wholesaling",
                "children": [
                    {
                        "id": "411110",
                        "text": "Live animal merchant wholesalers",
                        "keywords": "animal animals live wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "411120",
                        "text": "Oilseed and grain merchant wholesalers",
                        "keywords": "elevators grain grains oilseed oilseeds operating primary storage wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "411130",
                        "text": "Nursery stock and plant merchant wholesalers",
                        "keywords": "nursery plant plants stock wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "411190",
                        "text": "Other farm product merchant wholesalers",
                        "keywords": "crude farm product products unprocessed wholesaler-distributors wholesaling"
                    }
                ]
            },
            {
                "id": "412",
                "text": "Petroleum and petroleum products merchant wholesalers",
                "keywords": "crude gases heating liquefied oil petroleum product products refined wholesaler-distributors wholesaling",
                "children": [
                    {
                        "id": "412110",
                        "text": "Petroleum and petroleum products merchant wholesalers",
                        "keywords": "crude gases heating liquefied oil petroleum product products refined wholesaler-distributors wholesaling"
                    }
                ]
            },
            {
                "id": "413",
                "text": "Food, beverage and tobacco merchant wholesalers",
                "keywords": "beverage beverages food products tobacco wholesaler-distributors wholesaling",
                "children": [
                    {
                        "id": "413190",
                        "text": " Other specialty-line food merchant wholesalers",
                        "keywords": "canned food foods frozen lines packaged specialized specialty-line wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "413210",
                        "text": "Non-alcoholic beverage merchant wholesalers",
                        "keywords": "beverage beverages non-alcoholic wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "413160",
                        "text": "Red meat and meat product merchant wholesalers",
                        "keywords": "cooked cured fresh frozen meat meats packaged product red wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "413110",
                        "text": "General-line food merchant wholesalers",
                        "keywords": "food general-line line products wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "413120",
                        "text": "Dairy and milk products merchant wholesalers",
                        "keywords": "dairy milk processed products wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "413140",
                        "text": "Fish and seafood product merchant wholesalers",
                        "keywords": "cured fish fresh frozen packaged product products seafood wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "413150",
                        "text": "Fresh fruit and vegetable merchant wholesalers",
                        "keywords": "cleaning fresh fruit repackaging retailers sorting supply these vegetable vegetables wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "413130",
                        "text": "Poultry and egg merchant wholesalers",
                        "keywords": "dressed egg eggs poultry wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "413220",
                        "text": "Alcoholic beverage merchant wholesalers",
                        "keywords": "alcoholic beverage beverages wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "413310",
                        "text": "Cigarette and tobacco product merchant wholesalers",
                        "keywords": "cigarette cured product products tobacco wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "413410",
                        "text": "Cannabis merchant wholesalers",
                        "keywords": "cannabis oil merchant wholesalers dried cannabis wholesale"
                    }
                ]
            },
            {
                "id": "414",
                "text": "Personal and household goods merchant wholesalers",
                "keywords": "appliances articles clothing cosmetics entertainment equipment footwear furnishings goods home household personal pharmaceuticals sundries textiles toiletries wholesaler-distributors wholesaling",
                "children": [
                    {
                        "id": "414450",
                        "text": "Video recording merchant wholesalers",
                        "keywords": "cassette cassettes pre-recorded video wholesalers wholesaling"
                    },
                    {
                        "id": "414410",
                        "text": "Jewellery and watch merchant wholesalers",
                        "keywords": "cutlery flatware hollowware jewellery metal precious silverware table watch watches wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "414420",
                        "text": "Book, periodical and newspaper merchant wholesalers",
                        "keywords": "book books dictionaries encyclopaedias newspaper newspapers periodical periodicals textbooks wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "414430",
                        "text": "Photographic equipment and supplies merchant wholesalers",
                        "keywords": "equipment photographic supplies wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "414440",
                        "text": "Sound recording merchant wholesalers",
                        "keywords": "buy-and-sell cassette cassettes cd cds distribution distributors engage format imported known one-stop rack-jobbers recording recordings sound these they wholesalers wholesaling"
                    },
                    {
                        "id": "414460",
                        "text": "Toy and hobby goods merchant wholesalers",
                        "keywords": "goods hobby toy toys wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "414470",
                        "text": "Amusement and sporting goods merchant wholesalers",
                        "keywords": "amusement goods sporting wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "414510",
                        "text": "Pharmaceuticals and pharmacy supplies merchant wholesalers",
                        "keywords": "drugs ethical pharmaceuticals pharmacy proprietary supplies wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "414520",
                        "text": "Toiletries, cosmetics and sundries merchant wholesalers",
                        "keywords": "cosmetics druggists' sundries toiletries wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "414210",
                        "text": "Home entertainment equipment merchant wholesalers",
                        "keywords": "entertainment equipment home new parts wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "414220",
                        "text": "Household appliance merchant wholesalers",
                        "keywords": "appliance appliances electric household large new small wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "414310",
                        "text": "China, glassware, crockery and pottery merchant wholesalers",
                        "keywords": "ceramic china crockery glassware household kitchenware pottery tableware wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "414320",
                        "text": "Floor covering merchant wholesalers",
                        "keywords": "covering coverings floor wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "414330",
                        "text": "Linen, drapery and other textile furnishings merchant wholesalers",
                        "keywords": "bedding draperies drapery furnishings home household linen linens textile wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "414390",
                        "text": "Other home furnishings merchant wholesalers",
                        "keywords": "accessories blinds decorative frames furnishings furniture home mirrors none picture pictures ware wholesaler-distributors wholesaling window"
                    },
                    {
                        "id": "414110",
                        "text": "Clothing and clothing accessories merchant wholesalers",
                        "keywords": "accessories adults children clothing wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "414120",
                        "text": "Footwear merchant wholesalers",
                        "keywords": "footwear wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "414130",
                        "text": "Piece goods, notions and other dry goods merchant wholesalers",
                        "keywords": "dry goods notions piece wholesaler-distributors wholesaling"
                    }
                ]
            },
            {
                "id": "415",
                "text": "Motor vehicle and motor vehicle parts and accessories merchant wholesalers",
                "keywords": "accessories motor parts tires vehicle vehicles wholesaler-distributors wholesaling",
                "children": [
                    {
                        "id": "415310",
                        "text": "Used motor vehicle parts and accessories merchant wholesalers",
                        "keywords": "accessories automobiles automotive dealers dismantled dismantling metal motor parts scrap sell these used vehicle wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "415190",
                        "text": "Recreational and other motor vehicles merchant wholesalers",
                        "keywords": "camper motor recreational trailers vehicles wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "415210",
                        "text": "Tire merchant wholesalers",
                        "keywords": "tire tires tubes vehicles wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "415290",
                        "text": "Other new motor vehicle parts and accessories merchant wholesalers",
                        "keywords": "accessories auto automotive body chemicals motor new parts rebuilt supplies upholsterers' vehicle wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "415120",
                        "text": "Truck, truck tractor and bus merchant wholesalers",
                        "keywords": "bus buses heavy-duty new tractor tractors truck trucks used wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "415110",
                        "text": "New and used automobile and light-duty truck merchant wholesalers",
                        "keywords": "automobile automobiles light-duty mini-vans new sport truck trucks used utility vehicles wholesaler-distributors wholesaling"
                    }
                ]
            },
            {
                "id": "416",
                "text": "Building material and supplies merchant wholesalers",
                "keywords": "air-conditioning building electrical equipment hardware heating lumber material metal millwork plumbing products supplies wholesaler-distributors wholesaling",
                "children": [
                    {
                        "id": "416110",
                        "text": "Electrical wiring and construction supplies merchant wholesalers",
                        "keywords": "construction electrical equipment generation generators material motors powerhouse supplies transformers transmission wholesaler-distributors wholesalers wholesaling wiring"
                    },
                    {
                        "id": "416120",
                        "text": "Plumbing, heating and air-conditioning equipment and supplies merchant wholesalers",
                        "keywords": "air-conditioning equipment heating plumbing supplies wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "416210",
                        "text": "Metal service centres",
                        "keywords": "bend centres customer cut metal metals prepare products service specification these wholesaling"
                    },
                    {
                        "id": "416310",
                        "text": "General-line building supplies merchant wholesalers",
                        "keywords": "broad building construction electrical general-line glass hardware lumber paint plumbing range supplies wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "416320",
                        "text": "Lumber, plywood and millwork merchant wholesalers",
                        "keywords": "dressed lumber millwork plywood products rough wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "416330",
                        "text": "Hardware merchant wholesalers",
                        "keywords": "hardware tools tradesmen's wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "416340",
                        "text": "Paint, glass and wallpaper merchant wholesalers",
                        "keywords": "building decorators' glass paint paints supplies varnishes wallpaper wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "416390",
                        "text": "Other specialty-line building supplies merchant wholesalers",
                        "keywords": "building lines specialized specialty-line supplies wholesaler-distributors wholesaling"
                    }
                ]
            },
            {
                "id": "417",
                "text": "Machinery, equipment and supplies merchant wholesalers",
                "keywords": "communication computers construction equipment farm forestry garden industrial lawn machinery mining supplies wholesaler-distributors wholesaling",
                "children": [
                    {
                        "id": "417110",
                        "text": "Farm, lawn and garden machinery and equipment merchant wholesalers",
                        "keywords": "equipment farm garden lawn machinery new parts used wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "417210",
                        "text": "Construction and forestry machinery, equipment and supplies merchant wholesalers",
                        "keywords": "construction equipment forestry machinery new parts supplies used wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "417220",
                        "text": "Mining and oil and gas well machinery, equipment and supplies merchant wholesalers",
                        "keywords": "equipment gas machinery mining new oil parts petroleum refinery supplies used well wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "417230",
                        "text": "Industrial machinery, equipment and supplies merchant wholesalers",
                        "keywords": "equipment industrial machinery new supplies used wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "417310",
                        "text": "Computer, computer peripheral and pre-packaged software merchant wholesalers",
                        "keywords": "computer computers new peripheral peripherals pre-packaged software used wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "417990",
                        "text": "All other machinery, equipment and supplies merchant wholesalers",
                        "keywords": "aircraft amusement boats engines equipment fishing goods locomotives machinery motor new none non-electronic park playground pleasure supplies used vehicle wholesaler-distributors wholesalers wholesaling"
                    },
                    {
                        "id": "417320",
                        "text": "Electronic components, navigational and communications equipment and supplies merchant wholesalers",
                        "keywords": "address communications components electronic equipment intercoms navigational new pagers public supplies systems telephones used wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "417910",
                        "text": "Office and store machinery and equipment merchant wholesalers",
                        "keywords": "equipment fixtures furniture machinery new office store used wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "417920",
                        "text": "Service establishment machinery, equipment and supplies merchant wholesalers",
                        "keywords": "equipment machinery new service supplies used wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "417930",
                        "text": "Professional machinery, equipment and supplies merchant wholesalers",
                        "keywords": "equipment machinery new professional supplies used wholesaler-distributors wholesaling"
                    }
                ]
            },
            {
                "id": "418",
                "text": "Miscellaneous merchant wholesalers",
                "keywords": "agricultural allied automotive chemicals chips disposable goods logs machinery materials merchandise metals minerals miscellaneous ores paper plastic precious products recyclable second-hand supplies wholesaler-distributors wholesaling wood",
                "children": [
                    {
                        "id": "418990",
                        "text": "All other merchant wholesalers",
                        "keywords": "activity constitute diversified important line merchandise no primary products single sufficiently wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "418410",
                        "text": "Chemical (except agricultural) and allied product merchant wholesalers",
                        "keywords": "agricultural allied basic chemical chemicals cleaning compounds forms gases household industrial plastic plastics preparations product resins shapes wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "418110",
                        "text": "Recyclable metal merchant wholesalers",
                        "keywords": "automobiles breaking buying ferrous metal non-ferrous recyclable scrap selling sorting wholesaler-distributors"
                    },
                    {
                        "id": "418120",
                        "text": "Recyclable paper and paperboard merchant wholesalers",
                        "keywords": "breaking buying newspaper paper paperboard papers recyclable selling sorting used wholesaler-distributors"
                    },
                    {
                        "id": "418190",
                        "text": "Other recyclable material merchant wholesalers",
                        "keywords": "breaking buying glass grinding liquids material materials plastic recyclable selling shredding sludges sorting textiles wholesaler-distributors"
                    },
                    {
                        "id": "418210",
                        "text": "Stationery and office supplies merchant wholesalers",
                        "keywords": "office stationery supplies wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "418220",
                        "text": "Other paper and disposable plastic product merchant wholesalers",
                        "keywords": "containers cups cutlery disposable facial food household napkins none paper plastic plates product products tissues toilet towels trays waxed wholesaler-distributors wholesaling wrap"
                    },
                    {
                        "id": "418310",
                        "text": "Agricultural feed merchant wholesalers",
                        "keywords": "agricultural animal feed food pet wholesaler-distributors wholesalers wholesaling"
                    },
                    {
                        "id": "418390",
                        "text": "Agricultural chemical and other farm supplies merchant wholesalers",
                        "keywords": "agricultural chemical chemicals farm fertilizers goods herbicides none pesticides supplies wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "418320",
                        "text": "Seed merchant wholesalers",
                        "keywords": "crops field flowers garden grass plants seed seeds wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "418910",
                        "text": "Log and wood chip merchant wholesalers",
                        "keywords": "bolts chip chips forest log logs products unprocessed wholesaler-distributors wholesaling wood"
                    },
                    {
                        "id": "418920",
                        "text": "Mineral, ore and precious metal merchant wholesalers",
                        "keywords": "concentrates metal metals mineral minerals ore ores precious wholesaler-distributors wholesaling"
                    },
                    {
                        "id": "418930",
                        "text": "Second-hand goods (except machinery and automotive) merchant wholesalers",
                        "keywords": "automotive goods machinery second-hand wholesaler-distributors wholesaling"
                    }
                ]
            },
            {
                "id": "419",
                "text": "Business-to-business electronic markets, and agents and brokers",
                "keywords": "agents behalf bought bring brokers business-to-business buyers buying commercial commission deal electronic export fee goods import known manufacturers' markets merchants owned principal product products purchasing receiving sellers selling service sold these they title together transactions undertake wholesale without",
                "children": [
                    {
                        "id": "419120",
                        "text": "Wholesale Trade Agents and Brokers",
                        "keywords": "agents basis behalf bought bring brokers buyers buying commercial commission deal export goods import known manufacturers' merchants owned principal product products purchasing sellers selling sold these they title together trade transactions undertake wholesale without"
                    },
                    {
                        "id": "419110",
                        "text": "Business-to-Business Electronic Markets",
                        "keywords": "auction basis bought bringing business-to-business buyers commission electronic facilitate facilitating fee goods internet markets means merchandise new receiving sales sellers service sold title together transactions used wholesale without"
                    }
                ]
            }
        ]
    },
    {
        "id": "44-45",
        "text": "Retail Trade",
        "keywords": "addition advertising after after-sales appliance attract automobile below broadcasting building business catalogue catalogues characteristics clients companies computer consumption contrast courier covering customer customers dealers deliver delivery demonstration described designed differ direct-response displaying displays distribution door-to-door electrical electronic extensive final fixed floor gasoline heating high home household incidental infomercials information in-home installation institutional instrument like located locations machines main market mass-media material merchandise methods mobile musical new newspaper non-store office oil operate organized party payment personal plumbing point-of-sale post process products provide providing provision public publishing purchase quantities reach receive rendering repair retail retailer retailers retailing rule sale sales sell selling serve service services showrooms small software solicitation stalls stations step store stores supplies technologies temporary therefore these they time trade traditional transaction transformation treated treatment types use vary vending volume walk-in while window without",
        "children": [
            {
                "id": "441",
                "text": "Motor Vehicle and Parts Dealers",
                "keywords": "accessories complementary dealers motor parts providing retailing services specialized types vehicle vehicles",
                "children": [
                    {
                        "id": "441210",
                        "text": "Recreational Vehicle Dealers",
                        "keywords": "accessories campers dealers homes motor new parts provide recreational repair replacement retail retailing rvs services these trailers used vehicle"
                    },
                    {
                        "id": "441220",
                        "text": "Motorcycle, Boat and Other Motor Vehicle Dealers",
                        "keywords": "accessories aircraft all-terrain boat dealers motor motorcycle motorcycles new off-road parts provide repair replacement retail retailing services snowmobiles these trailers used utility vehicle vehicles watercraft"
                    },
                    {
                        "id": "441310",
                        "text": "Automotive Parts and Accessories Stores",
                        "keywords": "accessories automobiles automotive installation new parts rebuilt repairing require retailing stores used"
                    },
                    {
                        "id": "441320",
                        "text": "Tire Dealers",
                        "keywords": "aligning balancing complementary dealers mounting provide retailing services these tire tires tubes wheel"
                    },
                    {
                        "id": "441110",
                        "text": "New Car Dealers",
                        "keywords": "accessories automobile automobiles car cars consumers dealers final lessors light-duty mini-vans new parts provide repair replacement retail retailing services sport these trucks used utility vans vehicles"
                    },
                    {
                        "id": "441120",
                        "text": "Used Car Dealers",
                        "keywords": "automobiles car dealers light-duty mini-vans retailing sport trucks used utility vans vehicles"
                    }
                ]
            },
            {
                "id": "442",
                "text": "Furniture and Home Furnishings Stores",
                "keywords": "addition decorating furnishings furniture home interior new offer operate products retailing sale services showrooms stores these",
                "children": [
                    {
                        "id": "442110",
                        "text": "Furniture Stores",
                        "keywords": "appliances coverings decorating electronics floor furnishings furniture home household interior major new office provide retail retailing services stores these"
                    },
                    {
                        "id": "442210",
                        "text": "Floor Covering Stores",
                        "keywords": "carpets ceramic covering coverings floor installation new provide repair retailing rugs services stores these tiles vinyl wood"
                    },
                    {
                        "id": "442291",
                        "text": "Window Treatment Stores",
                        "keywords": "blinds custom draperies ready-made retailing shades stores treatment window"
                    },
                    {
                        "id": "442292",
                        "text": "Print and Picture Frame Stores",
                        "keywords": "art custom frame frames framing laminating limited mounting number original picture posters print prints ready-made retail retailing stores these works"
                    },
                    {
                        "id": "442298",
                        "text": "All Other Home Furnishings Stores",
                        "keywords": "furnishings home new retailing stores"
                    }
                ]
            },
            {
                "id": "443",
                "text": "Electronics and Appliance Stores",
                "keywords": "appliance appliances audio cameras computers electronics equipment goods home household parts provide repair replacement retail retailing services stores these video",
                "children": [
                    {
                        "id": "443143",
                        "text": "Appliance, Television and Other Electronics Stores",
                        "keywords": "appliance appliances audio computer computers electronic electronics equipment home household new products provide repair retail retailing services software stores television these used video"
                    },
                    {
                        "id": "443144",
                        "text": "Computer and Software Stores",
                        "keywords": "accessories computer computers equipment game new parts peripherals pre-packaged products provide repair replacement retail retailing services software stores these used"
                    },
                    {
                        "id": "443145",
                        "text": "Camera and Photographic Supplies Stores",
                        "keywords": "accessories camera cameras developing equipment film new parts photographic provide repair replacement retail retailing services stores supplies these used"
                    },
                    {
                        "id": "443146",
                        "text": "Audio and Video Recordings Stores",
                        "keywords": "audio compact disc formatmedium new pre-recorded record recordings retailing stores tape video"
                    }
                ]
            },
            {
                "id": "444",
                "text": "Building Material and Garden Equipment and Supplies Dealers",
                "keywords": "building dealers equipment garden home improvement lawn line material materials nursery outdoor power products retailing specialized supplies",
                "children": [
                    {
                        "id": "444110",
                        "text": "Home Centres",
                        "keywords": "arranged centres coverings doors electrical equipment floor garden goods hardware home housewares improvement installation lawn line lines lumber materials merchandise normally paint plumbing provide repair retail retailing sections separate services supplies these they tools wallpaper windows"
                    },
                    {
                        "id": "444120",
                        "text": "Paint and Wallpaper Stores",
                        "keywords": "paint retailing stores supplies wallpaper"
                    },
                    {
                        "id": "444130",
                        "text": "Hardware Stores",
                        "keywords": "additional arranged basic builders' departments garden hardware housewares items known line lines normally paint product retailing sell separate stores supplies these tools"
                    },
                    {
                        "id": "444190",
                        "text": "Other Building Material Dealers",
                        "keywords": "addition building dealers installation lines material materials provide retailing services specialized these"
                    },
                    {
                        "id": "444210",
                        "text": "Outdoor Power Equipment Stores",
                        "keywords": "equipment outdoor parts power provide repair replacement retail retailing services stores these"
                    },
                    {
                        "id": "444220",
                        "text": "Nursery Stores and Garden Centres",
                        "keywords": "bulbs centres elsewhere garden grown landscaping nursery plants products provide retailing seeds services shrubs sod stores these trees"
                    }
                ]
            },
            {
                "id": "445",
                "text": "Food and Beverage Stores",
                "keywords": "beverage food line products retailing specialized stores",
                "children": [
                    {
                        "id": "445120",
                        "text": "Convenience Stores",
                        "keywords": "alcoholic beverages bread canned cleaning convenience dairy drinks goods household items known limited line lottery magazines milk newspapers paper products provide rental retail retailing sales services snacks soft stores these ticket tobacco video well"
                    },
                    {
                        "id": "445210",
                        "text": "Meat Markets",
                        "keywords": "cured delicatessens fresh frozen markets meat meats poultry retailing"
                    },
                    {
                        "id": "445220",
                        "text": "Fish and Seafood Markets",
                        "keywords": "cured fish fresh frozen markets products retailing seafood"
                    },
                    {
                        "id": "445230",
                        "text": "Fruit and Vegetable Markets",
                        "keywords": "fresh fruit fruits markets retailing vegetable vegetables"
                    },
                    {
                        "id": "445291",
                        "text": "Baked Goods Stores",
                        "keywords": "baked consumption goods immediate premises retailing stores"
                    },
                    {
                        "id": "445292",
                        "text": "Confectionery and Nut Stores",
                        "keywords": "candy confectionery confections nut nuts popcorn retailing stores"
                    },
                    {
                        "id": "445299",
                        "text": "All Other Specialty Food Stores",
                        "keywords": "food foods retailing specialty stores"
                    },
                    {
                        "id": "445310",
                        "text": "Beer, Wine and Liquor Stores",
                        "keywords": "alcoholic beer beverages liquor packaged retailing stores wine"
                    },
                    {
                        "id": "445110",
                        "text": "Supermarkets and Other Grocery (except Convenience) Stores",
                        "keywords": "baked canned convenience dairy drugs dry fish food foods fresh frozen fruits grocery household known line meats non-food non-prescription paper poultry prepared products range retail retailing snack stores supermarkets these toiletries vegetables"
                    }
                ]
            },
            {
                "id": "446",
                "text": "Health and Personal Care Stores",
                "keywords": "appliance beauty care cosmetics drug food goods health optical perfume personal pharmacies products retailing stores supplement supplies",
                "children": [
                    {
                        "id": "446199",
                        "text": "All Other Health and Personal Care Stores",
                        "keywords": "addition care fitting health lines merchandise personal provide retailing services specialized stores these"
                    },
                    {
                        "id": "446110",
                        "text": "Pharmacies and Drug Stores",
                        "keywords": "aids cameras cards confectionery cosmetics drug drugs giftware greeting health hygiene known medicines non-prescription novelties personal pharmacies photographic prescription products retail retailing snacks stationery stores supplies these tobacco"
                    },
                    {
                        "id": "446120",
                        "text": "Cosmetics, Beauty Supplies and Perfume Stores",
                        "keywords": "beauty cosmetics grooming perfume perfumes personal products retailing stores supplies toiletries"
                    },
                    {
                        "id": "446130",
                        "text": "Optical Goods Stores",
                        "keywords": "contact eyeglasses fitting goods grind lenses non-prescription optical order premises prescription retailing stores sunglasses these"
                    },
                    {
                        "id": "446191",
                        "text": "Food (Health) Supplement Stores",
                        "keywords": "body enhancing food health limited line nutrition products retail retailing stores supplement supplements these vitamins"
                    }
                ]
            },
            {
                "id": "447",
                "text": "Gasoline Stations",
                "keywords": "behalf commission conjunction convenience fuels garage gasoline motor operate operated operation owners receive repair restaurant retailing sale station stations store whether",
                "children": [
                    {
                        "id": "447110",
                        "text": "Gasoline Stations with Convenience Stores",
                        "keywords": "automotive behalf bread combined convenience drinks fuels gasoline limited line merchandise milk operate owners retail retailing sale setting snacks soft stations store stores"
                    },
                    {
                        "id": "447190",
                        "text": "Other Gasoline Stations",
                        "keywords": "automotive behalf conjunction diesel fuel garage gasoline oils operate operated operation owners repair restaurant retailing station stations whether"
                    }
                ]
            },
            {
                "id": "448",
                "text": "Clothing and Clothing Accessories Stores",
                "keywords": "accessories clothing retailing stores",
                "children": [
                    {
                        "id": "448150",
                        "text": "Clothing Accessories Stores",
                        "keywords": "accessories clothing line new retailing single stores"
                    },
                    {
                        "id": "448110",
                        "text": "Men's Clothing Stores",
                        "keywords": "alterations boys' clothing garments line men's new provide ready-to-wear retailing sell stores these they"
                    },
                    {
                        "id": "448120",
                        "text": "Women's Clothing Stores",
                        "keywords": "clothing line maternity new ready-to-wear retailing stores wear women's"
                    },
                    {
                        "id": "448130",
                        "text": "Children's and Infants' Clothing Stores",
                        "keywords": "children's clothing infants' line new ready-to-wear retailing stores"
                    },
                    {
                        "id": "448140",
                        "text": "Family Clothing Stores",
                        "keywords": "age children clothing family gender individual line men new ready-to-wear retailing sales specializing stores without women"
                    },
                    {
                        "id": "448191",
                        "text": "Fur Stores",
                        "keywords": "apparel custom-made fur ready-to-wear retailing stores"
                    },
                    {
                        "id": "448199",
                        "text": "All Other Clothing Stores",
                        "keywords": "clothing lines new retailing specialized stores"
                    },
                    {
                        "id": "448210",
                        "text": "Shoe Stores",
                        "keywords": "footwear new products retail retailing shoe shoe-care stores these types"
                    },
                    {
                        "id": "448310",
                        "text": "Jewellery Stores",
                        "keywords": "clocks cutting jewellery mounting plated provide repair retailing services silverware sterling stones stores these watches"
                    },
                    {
                        "id": "448320",
                        "text": "Luggage and Leather Goods Stores",
                        "keywords": "briefcases goods items leather line luggage products retailing stores trunks"
                    }
                ]
            },
            {
                "id": "451",
                "text": "Sporting Goods, Hobby, Book and Music Stores",
                "keywords": "accessories audio book books fabrics games goods hobby instruments materials music musical needlework patterns reading recordings retailing sewing sporting stores supplies toys video yarns",
                "children": [
                    {
                        "id": "451111",
                        "text": "Golf Equipment and Supplies Specialty Stores",
                        "keywords": "golf equipment supplies specialty stores goods retail professionals operating"
                    },
                    {
                        "id": "451112",
                        "text": "Ski Equipment and Supplies Specialty Stores",
                        "keywords": "ski equipment supply specialty stores skiing retail"
                    },
                    {
                        "id": "451113",
                        "text": "Cycling Equipment and Supplies Specialty Stores",
                        "keywords": "bicycle parts dealers retail accessories sales repairs cycling equipment supplies specialty stores new bicycles combined repair primary source receipts"
                    },
                    {
                        "id": "451119",
                        "text": "All Other Sporting Goods Stores",
                        "keywords": "archery equipment retail athletic uniforms backpacking hiking mountaineering bait tackle shops baseball bowling supplies camping firearms ammunition fishing worms minnows sports fitness football gymnasium hockey hunting playground pool billiard table stores riding goods sails tents skin diving scuba soccer softball tack tennis tent track field"
                    },
                    {
                        "id": "451120",
                        "text": "Hobby, Toy and Game Stores",
                        "keywords": "craft game games hobby new retailing stores supplies toy toys"
                    },
                    {
                        "id": "451130",
                        "text": "Sewing, Needlework and Piece Goods Stores",
                        "keywords": "accessories fabrics goods machines needlework new patterns piece retail retailing sewing stores supplies these yarns"
                    },
                    {
                        "id": "451140",
                        "text": "Musical Instrument and Supplies Stores",
                        "keywords": "instrument instruments music musical new rent repair retailing sheet stores supplies these"
                    },
                    {
                        "id": "451310",
                        "text": "Book Stores and News Dealers",
                        "keywords": "book books dealers magazines new news newspapers periodicals retailing stores"
                    }
                ]
            },
            {
                "id": "452",
                "text": "General Merchandise Stores",
                "keywords": "grocery items line merchandise retailing stores",
                "children": [
                    {
                        "id": "452110",
                        "text": "Department Stores",
                        "keywords": "basis concession constituting department departments each known line merchandise operated products range retailing selected separate store stores wide within"
                    },
                    {
                        "id": "452910",
                        "text": "Warehouse clubs",
                        "keywords": "clubs formats grocery items known larger line non-grocery retailing selling supercentres superstores warehouse"
                    },
                    {
                        "id": "452991",
                        "text": "Home and Auto Supplies Stores",
                        "keywords": "accessories along appliances auto batteries equipment garden goods hardware home housewares lawn line parts retailing small sporting stores supplies tires"
                    },
                    {
                        "id": "452999",
                        "text": "All Other Miscellaneous General Merchandise Stores",
                        "keywords": "line merchandise miscellaneous new retailing stores"
                    }
                ]
            },
            {
                "id": "453",
                "text": "Miscellaneous Store Retailers",
                "keywords": "art dealers florists gift home line manufactured merchandise miscellaneous mobile novelty office pet retailers retailing souvenir specialized specialty stationery store stores supplies types used",
                "children": [
                    {
                        "id": "453110",
                        "text": "Florists",
                        "keywords": "arrangements cut floral florists flowers plants potted prepare purchased retailing sell these they"
                    },
                    {
                        "id": "453210",
                        "text": "Office Supplies and Stationery Stores",
                        "keywords": "equipment furniture office retailing school stationery stores supplies"
                    },
                    {
                        "id": "453220",
                        "text": "Gift, Novelty and Souvenir Stores",
                        "keywords": "cards curios decorations gift gifts greeting holiday merchandise new novelty retail retailing seasonal souvenir souvenirs stationery stores these"
                    },
                    {
                        "id": "453310",
                        "text": "Used Merchandise Stores",
                        "keywords": "antiques merchandise retailing stores used"
                    },
                    {
                        "id": "453910",
                        "text": "Pet and Pet Supplies Stores",
                        "keywords": "food grooming pet pets provide retailing services stores supplies these"
                    },
                    {
                        "id": "453920",
                        "text": "Art Dealers",
                        "keywords": "art carvings dealers edition exhibition limited native original retail retailing sale works"
                    },
                    {
                        "id": "453930",
                        "text": "Mobile Home Dealers",
                        "keywords": "addition dealers equipment home homes installation mobile new parts provide retailing services these used"
                    },
                    {
                        "id": "453992",
                        "text": "Beer and Wine-Making Supplies Stores",
                        "keywords": "access beer equipment on-premise provide retailing stores supplies these wine-making"
                    },
                    {
                        "id": "453993",
                        "text": "Cannabis stores",
                        "keywords": "cannabis oil retail product dried seed"
                    },
                    {
                        "id": "453999",
                        "text": "All Other Miscellaneous Store Retailers (except Beer and Wine-Making Supplies Stores)",
                        "keywords": "auction basis beer line lines merchandise miscellaneous new retailers retailing specialized store stores supplies used wine-making"
                    }
                ]
            },
            {
                "id": "454",
                "text": "Non-Store Retailers",
                "keywords": "advertising broadcasting catalogues customers delivery demonstration direct direct-response displaying distribution door-to-door electronic employ fuels heating home ie infomercials in-home internet machines market merchandise methods newspaper non-store products publishing reach retail retailers retailing sale solicitation stalls stands temporary traditional vending",
                "children": [
                    {
                        "id": "454110",
                        "text": "Electronic Shopping and Mail-order Houses",
                        "keywords": "audio video content downloading retail sales sites books magazines mail order catalog taking offices houses cheese combined Internet computer peripheral equipment software department store catalogue office direct mailers e-commerce electronic shopping mail-order e-tailing retailing fruit home television institutional pharmacies off-site auctions jewellery stores merchandise music downloading websites novelty prerecorded tape compact disc record"
                    },
                    {
                        "id": "454210",
                        "text": "Vending Machine Operators",
                        "keywords": "designed machine machines merchandise operators owning retail servicing stocking vending"
                    },
                    {
                        "id": "454311",
                        "text": "Heating Oil Dealers",
                        "keywords": "activity addition businesses commercial consumer dealers delivering direct final furnace heating households maintenance oil primary provide repair retailing selling services via"
                    },
                    {
                        "id": "454312",
                        "text": "Liquefied Petroleum Gas (Bottled Gas) Dealers",
                        "keywords": "bottled dealers direct gas liquefied lpg petroleum retailing selling via"
                    },
                    {
                        "id": "454319",
                        "text": "Other Fuel Dealers",
                        "keywords": "dealers direct fuel fuels gas heating liquefied listed none oil petroleum previously retailing selling via"
                    },
                    {
                        "id": "454390",
                        "text": "Other Direct Selling Establishments",
                        "keywords": "customers demonstration direct displaying door-to-door in-home market merchandise methods non-store reach retailing selling solicitation stalls temporary these use"
                    }
                ]
            }
        ]
    },
   
    {
        "id": "48-49",
        "text": "Transportation and Warehousing",
        "keywords": "according air area businesses courier distributed each extensive facilities facility geographic goods ground mode modes national networks office operated organize passenger passengers physical pipeline post providing rail road service services storage storing structured subdivided these transit transport transportation transporting trucking warehousing water way workers",
        "children": [
            {
                "id": "481",
                "text": "Air Transportation",
                "keywords": "air aircraft airplanes common-carrier for-hire goods helicopters people transportation",
                "children": [
                    {
                        "id": "481110",
                        "text": "Scheduled Air Transportation",
                        "keywords": "air aircraft airports characteristics choice factors flexibility goods hours load non-scheduled operation operational passengers regular respect routes scheduled schedules transportation transporting"
                    },
                    {
                        "id": "481214",
                        "text": "Non-Scheduled Chartered Air Transportation",
                        "keywords": "air aircraft charter chartered goods hour mile non-scheduled passengers per toll transportation"
                    },
                    {
                        "id": "481215",
                        "text": "Non-Scheduled Specialty Flying Services",
                        "keywords": "advertising aerial air aircraft ambulance banners crop fighting fires flying forest general-purpose goods no non-scheduled passengers performed photography providing reporting service services single skywriting small specialized specialty spraying these towing traffic transportation use"
                    }
                ]
            },
            {
                "id": "482",
                "text": "Rail Transportation",
                "keywords": "long-haul mainline operating operation passenger rail railways short-haul transportation",
                "children": [
                    {
                        "id": "482112",
                        "text": "Short-Haul Freight Rail Transportation",
                        "keywords": "comprise freight goods larger line mainline mode network onto operating point points rail railway railways short-haul takes transport transportation trans-shipment"
                    },
                    {
                        "id": "482114",
                        "text": "Passenger Rail Transportation",
                        "keywords": "passenger passengers rail railway transport transportation"
                    },
                    {
                        "id": "482113",
                        "text": "Mainline Freight Rail Transportation",
                        "keywords": "branch feed freight goods lines mainline network operating rail railways separate short-haul system transport transportation trunk"
                    }
                ]
            },
            {
                "id": "483",
                "text": "Water Transportation",
                "keywords": "designed equipment goods passengers purposes transportation water",
                "children": [
                    {
                        "id": "483214",
                        "text": "Inland Water Transportation by Ferries",
                        "keywords": "ferries harbours inland operated operating transportation water"
                    },
                    {
                        "id": "483116",
                        "text": "Deep Sea, Coastal and Great Lakes Water Transportation by Ferries",
                        "keywords": "coastal contained deep ferries freight great lakes motorized operating passengers sea self-propelled transport transportation vehicles water waters"
                    },
                    {
                        "id": "483115",
                        "text": "Deep Sea, Coastal and Great Lakes Water Transportation (except by Ferries)",
                        "keywords": "coastal considered cruise deep ferries freight great lakes lawrence ocean-going operate passengers sea seaway ships st system transportation water"
                    },
                    {
                        "id": "483213",
                        "text": "Inland Water Transportation (except by Ferries)",
                        "keywords": "ferries freight inland passengers transportation water"
                    }
                ]
            },
            {
                "id": "484",
                "text": "Truck Transportation",
                "keywords": "area areas because between carry characteristics distances equipment freight goods hinterland inherent locally long metropolitan operate require shape size specialized these transportation truck weight within",
                "children": [
                    {
                        "id": "484110",
                        "text": "General Freight Trucking, Local",
                        "keywords": "area freight hinterland local metropolitan provide services these trucking within"
                    },
                    {
                        "id": "484121",
                        "text": "General Freight Trucking, Long Distance, Truck-Load",
                        "keywords": "complete destination devoted distance freight goods long origin point points shipment shipper single taken trucking truck-load truck-loads"
                    },
                    {
                        "id": "484122",
                        "text": "General Freight Trucking, Long Distance, Less Than Truck-Load",
                        "keywords": "assembly between carriers characterized complete consolidate delivery disassembly distance freight haulage less-than-truck-load load long re-routed several shipments shippers single sorted terminal terminals truck trucking truck-load truck-loads use"
                    },
                    {
                        "id": "484210",
                        "text": "Used Household and Office Goods Moving",
                        "keywords": "carried distance equipment furniture goods household incidental institutional local long moving new office out storage these transportation trucking used whether"
                    },
                    {
                        "id": "484222",
                        "text": "Dry Bulk Materials Trucking, Local",
                        "keywords": "bulk chemicals dry dump goods gravel hopper local materials ores sand snow tank these trailers transport trucking trucks use vehicles"
                    },
                    {
                        "id": "484223",
                        "text": "Forest Products Trucking, Local",
                        "keywords": "chips forest local logs lumber products trucking wood"
                    },
                    {
                        "id": "484221",
                        "text": "Bulk Liquids Trucking, Local",
                        "keywords": "bulk chemicals goods liquids local milk petroleum products refrigerated tank these transport trucking trucks use water"
                    },
                    {
                        "id": "484229",
                        "text": "Other Specialized Freight (except Used Goods) Trucking, Local",
                        "keywords": "equipment freight goods local providing services specialized trucking used"
                    },
                    {
                        "id": "484231",
                        "text": "Bulk Liquids Trucking, Long Distance",
                        "keywords": "bulk chemicals distance goods liquids long petroleum products refrigerated tank these transport trucking trucks use"
                    },
                    {
                        "id": "484232",
                        "text": "Dry Bulk Materials Trucking, Long Distance",
                        "keywords": "bulk chemicals distance dry dump goods gravel hopper long materials ores sand tank these trailers transport trucking trucks use vehicles"
                    },
                    {
                        "id": "484233",
                        "text": "Forest Products Trucking, Long Distance",
                        "keywords": "chips distance forest logs long lumber products trucking wood"
                    },
                    {
                        "id": "484239",
                        "text": "Other Specialized Freight (except Used Goods) Trucking, Long Distance",
                        "keywords": "distance equipment freight goods haulers important long motor providing refrigerated services specialized these truck trucking types used vans vehicle"
                    }
                ]
            },
            {
                "id": "485",
                "text": "Transit and Ground Passenger Transportation",
                "keywords": "based basis charged designed distinguished equipment factors fixed ground passenger per-seat per-vehicle process purposes routes run scheduled these transit transportation variety whether",
                "children": [
                    {
                        "id": "485110",
                        "text": "Urban Transit Systems",
                        "keywords": "allow basis buses fixed involve light local mass methods modes monthly operate operating passenger passengers passes pay payment per-trip rail routes schedules streetcars suburban subways systems these they transit transport transportation urban use well whether"
                    },
                    {
                        "id": "485510",
                        "text": "Charter Bus Industry",
                        "keywords": "bus charter entire fixed individual operate providing rent routes schedules seats services these vehicle"
                    },
                    {
                        "id": "485990",
                        "text": "Other Transit and Ground Passenger Transportation",
                        "keywords": "airports buses carriers conventional converted elderly facilities fixed ground handicapped hotels infirm means needs passenger provide providing routes service services shuttle special specially they transit transport transportation travel use vans vehicles"
                    },
                    {
                        "id": "485310",
                        "text": "Taxi Service",
                        "keywords": "automobiles cabs compensated dispatch drivers fleet hired limousines operated organizations owner-operated owners passenger provide providing regardless regular rent routes schedules service services taxi taxicab taxicabs transportation whether"
                    },
                    {
                        "id": "485210",
                        "text": "Interurban and Rural Bus Transportation",
                        "keywords": "areas bus charge fee fixed interurban municipality operate outside passenger per-trip principally providing routes rural schedules single suburban these transportation"
                    },
                    {
                        "id": "485320",
                        "text": "Limousine Service",
                        "keywords": "limousine passenger providing service transportation"
                    },
                    {
                        "id": "485410",
                        "text": "School and Employee Bus Transportation",
                        "keywords": "bus buses charge employee employees fee fixed motor operate operating per-trip pupils routes schedules school these transport transportation vehicles work"
                    }
                ]
            },
            {
                "id": "486",
                "text": "Pipeline Transportation",
                "keywords": "ancillary comprising crude designed facilities gas incidental integrated natural oil petroleum pipeline pipelines product products pumping refined specifications stations storage systems transport transportation types various",
                "children": [
                    {
                        "id": "486110",
                        "text": "Pipeline Transportation of Crude Oil",
                        "keywords": "crude oil pipeline transportation"
                    },
                    {
                        "id": "486210",
                        "text": "Pipeline Transportation of Natural Gas",
                        "keywords": "distribution fields gas local natural pipeline plants processing systems transportation"
                    },
                    {
                        "id": "486910",
                        "text": "Pipeline Transportation of Refined Petroleum Products",
                        "keywords": "petroleum pipeline products refined transportation"
                    },
                    {
                        "id": "486990",
                        "text": "All Other Pipeline Transportation",
                        "keywords": "operation pipeline pipelines slurry transportation"
                    }
                ]
            },
            {
                "id": "487",
                "text": "Scenic and Sightseeing Transportation",
                "keywords": "air-boat balloon charter cruises dinner equipment excursions fishing horse-drawn hot-air local nature provide provided providing recreational return rides same-day scenic services sightseeing specialized steam these train transportation use vintage",
                "children": [
                    {
                        "id": "487110",
                        "text": "Scenic and Sightseeing Transportation, Land",
                        "keywords": "excursions horse-drawn land providing rides scenic sightseeing steam train transportation"
                    },
                    {
                        "id": "487210",
                        "text": "Scenic and Sightseeing Transportation, Water",
                        "keywords": "air-boat charter cruises dinner equipment fishing local nature provide provided providing return rides same-day scenic services sightseeing specialized these transportation use vintage water"
                    },
                    {
                        "id": "487990",
                        "text": "Scenic and Sightseeing Transportation, Other",
                        "keywords": "balloon helicopter hot-air providing rides scenic services sightseeing these transportation"
                    }
                ]
            },
            {
                "id": "488",
                "text": "Support Activities for Transportation",
                "keywords": "mode multi-modal providing services specific support these they transportation",
                "children": [
                    {
                        "id": "488190",
                        "text": "Other Support Activities for Air Transportation",
                        "keywords": "air aircraft basis factory important inspecting maintaining providing repairing services servicing specialized support testing transport transportation"
                    },
                    {
                        "id": "488119",
                        "text": "Other Airport Operations",
                        "keywords": "airport airports civil operating operations"
                    },
                    {
                        "id": "488111",
                        "text": "Air Traffic Control",
                        "keywords": "air control expeditious flow operating orderly promote safe services traffic"
                    },
                    {
                        "id": "488210",
                        "text": "Support Activities for Rail Transportation",
                        "keywords": "maintenance operation providing rail railway rights-of-way services specialized stations structures support terminals transport transportation"
                    },
                    {
                        "id": "488310",
                        "text": "Port and Harbour Operations",
                        "keywords": "facilities harbour lighthouses operating operation operations port services"
                    },
                    {
                        "id": "488320",
                        "text": "Marine Cargo Handling",
                        "keywords": "cargo handling marine providing services stevedoring"
                    },
                    {
                        "id": "488331",
                        "text": "Marine Salvage Services",
                        "keywords": "cargoes marine raising rescue rescuing salvage salvaging services ships situations strandings sunken towing vessels"
                    },
                    {
                        "id": "488519",
                        "text": "Other Freight Transportation Arrangement",
                        "keywords": "acting arrangement between brokers carriers customs forwarders freight intermediaries modes offer referred services shippers spanning these they transportation"
                    },
                    {
                        "id": "488511",
                        "text": "Marine Shipping Agencies",
                        "keywords": "agencies arranging behalf business cargo charterers lines marine owners performing port representing ship shipping transactions"
                    },
                    {
                        "id": "488990",
                        "text": "Other Support Activities for Transportation",
                        "keywords": "crating goods packing preparing providing services specialized support transportation"
                    },
                    {
                        "id": "488339",
                        "text": "Other Navigational Services to Shipping",
                        "keywords": "navigational providing services shipping"
                    },
                    {
                        "id": "488332",
                        "text": "Ship Piloting Services",
                        "keywords": "areas entering essential harbours law leaving marine pilot pilotage piloting providing referred required service services ship ships waters"
                    },
                    {
                        "id": "488390",
                        "text": "Other Support Activities for Water Transportation",
                        "keywords": "lighter maintenance operations providing repair services ship shipyard support transportation water"
                    },
                    {
                        "id": "488410",
                        "text": "Motor Vehicle Towing",
                        "keywords": "battery boosting commercial distance emergency heavy incidental light local long motor offer public repair road sectors services these tire towing transportation vehicle vehicles"
                    },
                    {
                        "id": "488490",
                        "text": "Other Support Activities for Road Transportation",
                        "keywords": "bridges bus connected inspection network operation operators providing road roads services support terminals toll transportation truck trucking tunnels weighing"
                    }
                ]
            },
            {
                "id": "491",
                "text": "Postal Service",
                "keywords": "basis bulk carry contract courier delivery functions mail office operating post postal providing service services well",
                "children": [
                    {
                        "id": "491110",
                        "text": "Postal Service",
                        "keywords": "basis bulk carry contract courier delivery functions mail office operating post postal providing service services well"
                    }
                ]
            },
            {
                "id": "492",
                "text": "Couriers and Messengers",
                "keywords": "area courier couriers delivery messenger messengers parcels providing services single small urban within",
                "children": [
                    {
                        "id": "492210",
                        "text": "Local Messengers and Local Delivery",
                        "keywords": "alcoholic area basis beverages bicycle delivery documents fee foot groceries legal letters local meals messenger messengers parcels providing restaurant services single small take-out truck urban van within"
                    },
                    {
                        "id": "492110",
                        "text": "Couriers",
                        "keywords": "air combined courier couriers delivery office post providing services surface"
                    }
                ]
            },
            {
                "id": "493",
                "text": "Warehousing and Storage",
                "keywords": "addition always arrangement assembly bonded breaking bulk contract control credit customers customer's days dedicated distribution entry facilities free fulfillment furthermore goods handle however incidental inventory involves keeping labelling light located logistical logistics longer-term management marking merchandise must operating order pack packaging performance pick price provide provides provision public range referred refrigerated responsibility secure service services short-term storage store storing take these they thirty ticketing title trade transportation warehouses warehousing zones",
                "children": [
                    {
                        "id": "493110",
                        "text": "General Warehousing and Storage",
                        "keywords": "barrels boxes containers contract drums equipment facilities fork good goods handle handling lifts merchandise operating pallets public racks specialized storage these they warehousing"
                    },
                    {
                        "id": "493120",
                        "text": "Refrigerated Warehousing and Storage",
                        "keywords": "addition atmosphere blast contract designed equipment facilities freezing frozen furs goods keep modified operating provide provided public refrigerated services storage tempering these trade warehouse warehousing"
                    },
                    {
                        "id": "493190",
                        "text": "Other Warehousing and Storage",
                        "keywords": "automobile caverns dead designed equipment facilities good handle operate operating petroleum storage these warehousing whisky"
                    },
                    {
                        "id": "493130",
                        "text": "Farm Product Warehousing and Storage",
                        "keywords": "elevators facilities farm grain operating product refrigerated storage warehousing"
                    }
                ]
            }
        ]
    },

    {
        "id": "51",
        "text": "Information and Cultural Industries",
        "keywords": "access accessible acquiring addition aired allows alter authorized below board bought broadcast broadcasting bulletin cable carriers characteristics components content copyright costs cultural culture-related data demand distinguish distribute distributed distributing distribution downloaded educational electronic embedded entertainment equipment exclusively expertise format forms goods-producing ie important improve improvements inclusion increasingly information intangible internet involved involves laws lies listed local main means methods most motion movie multi-media naics nature newspaper newsstand on-line outlets picture play portals possessing processes processing producing production products protected providers providing public publishing purchased radio received record recording reflects rented reproduce reproduction reselling retail revolutionizing rights role satellite search sectors services services-producing shown significant software sold sound store technology telecommunications telephony television theatre these they transmit unique unlawful value various video voip web wholesale works",
        "children": [
            {
                "id": "511",
                "text": "Publishing Industries (except Internet)",
                "keywords": "access arrange books cards carry cd-rom characterized children's compile contract copies copyright create created creativity databases development digital direct disk distribute distribution dvd electronic form formats functions greeting in-house intellectual interactive internet multimedia musical newspapers offer on-line originally out periodicals print products protected published publishers publishing purchase reference reproduce required software themselves these they traditional video were works",
                "children": [
                    {
                        "id": "511110",
                        "text": "Newspaper Publishers",
                        "keywords": "advertisements carrying columns distributing editorials electronic feature form known necessary news newspaper newspapers operations out preparing print producing publish publishers selling stories these writing"
                    },
                    {
                        "id": "511120",
                        "text": "Periodical Publishers",
                        "keywords": "advertisements articles basis carrying distributing editing electronic form intervals known magazine magazines monthly necessary operations out periodical periodicals preparing printed producing published publishers quarterly regular selling soliciting these weekly writing"
                    },
                    {
                        "id": "511130",
                        "text": "Book Publishers",
                        "keywords": "audio book books carrying design distributing editing electronic form kinds known market marketing mass necessary out paperback print producing professional published publishers scientific technical text these various"
                    },
                    {
                        "id": "511140",
                        "text": "Directory and Mailing List Publishers",
                        "keywords": "arrangement collections compilations customers directory electronic facilitate facts form formats information list logically mailing offered on-line organized party presentation print products protected provided published publishers publishing selection services these use vendors versions"
                    },
                    {
                        "id": "511190",
                        "text": "Other Publishers",
                        "keywords": "books calendars cards colouring greeting posters publishers publishing works"
                    },
                    {
                        "id": "511211",
                        "text": "Software Publishers (except Video Game Publishers)",
                        "keywords": "applications software computer publishing designing developing packaged publishers games operating systems programming languages compilers reproducing integrated facilities utility"
                    },
                    {
                        "id": "511212",
                        "text": "Video Game Publishers",
                        "keywords": "video game designing developing publishing software"
                    }
                ]
            },
            {
                "id": "512",
                "text": "Motion Picture and Sound Recording Industries",
                "keywords": "audio developing distributing exhibition motion picture post-production processing producing providing recording recordings services sound studios video",
                "children": [
                    {
                        "id": "512110",
                        "text": "Motion Picture and Video Production",
                        "keywords": "commercials distributing motion picture pictures producing production programs television video videos"
                    },
                    {
                        "id": "512120",
                        "text": "Motion Picture and Video Distribution",
                        "keywords": "acquiring distributing distribution exhibitors film motion networks picture productions rights stations television theatres video"
                    },
                    {
                        "id": "512130",
                        "text": "Motion Picture and Video Exhibition",
                        "keywords": "during exhibiting exhibition festivals film motion occasional picture pictures provided providing services video"
                    },
                    {
                        "id": "512190",
                        "text": "Post-Production and Other Motion Picture and Video Industries",
                        "keywords": "animation captioning closed computer creating credits developing dubbing editing effects films filmtape graphics motion picture post-production processing producing providing services special specialized subtitling transferring video well"
                    },
                    {
                        "id": "512230",
                        "text": "Music Publishers",
                        "keywords": "accordance acquiring act administrator agreements authorizing behalf compositions copyright copyrights generating interests law licensing live media motion multimedia music musical own owners performances pictures print promoting publishers radio recordings registering represent revenues songwriters television these use works"
                    },
                    {
                        "id": "512240",
                        "text": "Sound Recording Studios",
                        "keywords": "audio expertise facilities film master musical performances post-production producing production productions provide providing recording recordings services sound studios technical television video"
                    },
                    {
                        "id": "512250",
                        "text": "Record Production and Distribution",
                        "keywords": "holding copyright master recording deriving revenues selling leasing licensing audio recordings integrated manufacture release distribution musical masters record companies production publishing reproducing materials facilities producing release promotion musical sound reproduction"
                    },
                    {
                        "id": "512290",
                        "text": "Other Sound Recording Industries",
                        "keywords": "providing recording services sound"
                    }
                ]
            },
            {
                "id": "515",
                "text": "Broadcasting (except Internet)",
                "keywords": "broadcasting facilities internet operating radio studios television",
                "children": [
                    {
                        "id": "515110",
                        "text": "Radio Broadcasting",
                        "keywords": "affiliates broadcasting broadcasts entertainment facilities news operating production programs public radio shows studios talk transmission"
                    },
                    {
                        "id": "515120",
                        "text": "Television Broadcasting",
                        "keywords": "affiliated broadcasting external facilities network operating originate over-the-air own production programming programs public sources studios television transmission variety"
                    },
                    {
                        "id": "515210",
                        "text": "Pay and Specialty Television",
                        "keywords": "acquire broadcasting cable delivered distribution educational external family feature films format health limited music news operators own pay produce programming programs religion satellite sources specialty sports studios subscribers systems television these they travel weather youth-oriented"
                    }
                ]
            },
            {
                "id": "517",
                "text": "Telecommunications",
                "keywords": "basis business client-supplied connections deliver employ entertainment facilities-based fixed grouped high internet leased mobile model nature network networks own provided providing resale services speed telecommunications they used video wireless wireline",
                "children": [
                    {
                        "id": "517310",
                        "text": "Telecommunications Carriers (except Satellite)",
                        "keywords": "cable satellite television wireless operators operating co-axial distribution based network satellite-based networks fixed wireless-based primarily serving residential market telephone companies incumbent local exchange carriers ILECs facilities-based competitive service providers providing full range telecommunication services business wholesale customers cellular telephone plans direct-to-home DTH carrier Internet provider ISP long-distance mobile"
                    },
                    {
                        "id": "517410",
                        "text": "Satellite Telecommunications",
                        "keywords": "beyond broadcasters business carriers clientele customers distributing eg facilities fixed high individual internet mobile network networks operated operators private provide providing reach satellite serve services speed telecommunication telecommunications terrestrial"
                    },
                    {
                        "id": "517911",
                        "text": "Telecommunications Resellers",
                        "keywords": "long distance telecommunication resellers microwave communications non-facilities based Internet service provider ISP reselling dial-up broadband services voice over protocol VoIP access-independent non-managed"
                    },
                    {
                        "id": "517919",
                        "text": "All Other Telecommunications",
                        "keywords": "radar station operation satellite earth stations facilities operators missile tracking operated contract basis terminal stations telemetry system fee missiles photography"
                    }
                ]
            },
            {
                "id": "518",
                "text": "Data Processing, Hosting, and Related Services",
                "keywords": "data hosting infrastructure processing providing services",
                "children": [
                    {
                        "id": "518210",
                        "text": "Data Processing, Hosting, and Related Services",
                        "keywords": "application audio automated basis clients complete customer data entry facilities hosting hourly mainframe preparation processing provide providing provisioning reports resources service services specialized streaming supplied they time-share time-sharing video web"
                    }
                ]
            },
            {
                "id": "519",
                "text": "Other Information Services",
                "keywords": "archives basis broadcasting components contract information internet libraries main news portals providing publishing search services syndicates web",
                "children": [
                    {
                        "id": "519122",
                        "text": "Archives",
                        "keywords": "accessible acquiring archival archives audio audio-visual cinematheques documents film historical interest maps material materials original photographs preservation primary public purpose researching storing video videotheques whose"
                    },
                    {
                        "id": "519110",
                        "text": "News Syndicates",
                        "keywords": "articles features information media news pictures reports supplying syndicates"
                    },
                    {
                        "id": "519121",
                        "text": "Libraries",
                        "keywords": "characteristics collections documents educational facilitating form informational libraries maintaining meet needs physical recreational regardless required research use users"
                    },
                    {
                        "id": "519130",
                        "text": "Internet Publishing and Broadcasting, and Web Search Portals",
                        "keywords": "additional addresses auctions audio base broadcast broadcasting connections content databases easily e-mail engine exclusively extensive format generate home interest internet known limited maintain news non-internet operating portals provide publish publishing search searchable serve services sites specific textual these they traditional use users versions video web"
                    },
                    {
                        "id": "519190",
                        "text": "All Other Information Services",
                        "keywords": "basis contract information providing recordings search services telephone-based"
                    }
                ]
            }
        ]
    },
    {
        "id": "52",
        "text": "Finance and Insurance",
        "keywords": "- acquire addition annuities annuity assets authorities based benefit borrowers build change channel charged collect considerations contractual control creation deposits employee expected facilitate facilitating fees finance financial funds incidence incur insurance insured intermediation invest investment issuing lenders liabilities liquidation loans maturity monetary ownership payments pooling premiums process programs providing purchasing putting raise repackage reserves respect return risk scale securities services specialized support themselves they transactions transform underwriting use",
        "children": [
            {
                "id": "521",
                "text": "Monetary Authorities - Central Bank",
                "keywords": "- acting agent among arrangements authorities bank banking banks branches canada central clearing conducting countries currency deposits differ federal fiscal functions government holding institutional institutions international issuing managing mexico monetary money nation's overseeing paper payment performed performing policy represent reserve reserves settlement states supply systems these united",
                "children": [
                    {
                        "id": "521110",
                        "text": "Monetary Authorities - Central Bank",
                        "keywords": "- acting agent authorities bank banking banks central clearing currency deposits federal fiscal functions government holding institutions international issuing managing monetary money nation's overseeing paper payment performing represent reserves settlement supply systems"
                    }
                ]
            },
            {
                "id": "522",
                "text": "Credit Intermediation and Related Activities",
                "keywords": "brokerage cheque-cashing clearinghouse credit debt depositors engaging facilitate funds intermediation issuance issuing lending loan mortgage raised reserve services",
                "children": [
                    {
                        "id": "522210",
                        "text": "Credit Card Issuing",
                        "keywords": "balance basis business card consumers credit entities full funds installment issuing payment payments providing required retailers return sales services"
                    },
                    {
                        "id": "522390",
                        "text": "Other Activities Related to Credit Intermediation",
                        "keywords": "cheque cheque-cashing credit facilitating intermediation issuance loans money order originated servicing traveller's"
                    },
                    {
                        "id": "522299",
                        "text": "All Other Non-Depository Credit Intermediation",
                        "keywords": "agencies agricultural capital companies credit direct estate extend factoring financing government intermediation international inventory loans mortgage non-depository pawnshops providing real short-term trade working"
                    },
                    {
                        "id": "522329",
                        "text": "Other Financial Transactions Processing and Clearing House Activities",
                        "keywords": "automated card cheque clearing credit electronic financial house houses instrument payment processing providing services transactions"
                    },
                    {
                        "id": "522220",
                        "text": "Sales Financing",
                        "keywords": "acceptance agreement arrangements businesses card companies consumers contractual created credit dealers equipment financial financing goods heavy individuals installment leases lend manufacturers money motor operating products providing purchase receivables result retail sales services they vehicle"
                    },
                    {
                        "id": "522291",
                        "text": "Consumer Lending",
                        "keywords": "case cash chattel companies consumer consumers default enabling finance however lender lending loan loans mortgage personal possession providing secured small take unsecured"
                    },
                    {
                        "id": "522190",
                        "text": "Other Depository Credit Intermediation",
                        "keywords": "accepting channel credit customers depository deposits government intermediation lending loans provincial savings"
                    },
                    {
                        "id": "522321",
                        "text": "Central Credit Unions",
                        "keywords": "accepting advances card central centrals cheque clearing credit deposits electronic federations financial house instrument issuing leagues loans members overnight payment processing providing regionals reserve services transaction unions"
                    },
                    {
                        "id": "522310",
                        "text": "Mortgage and Non-mortgage Loan Brokers",
                        "keywords": "arranging basis borrower brokers commission continuing fee lender loan loans mortgage non-mortgage ordinarily relationship these"
                    },
                    {
                        "id": "522130",
                        "text": "Local Credit Unions",
                        "keywords": "acceptance accepting caisses credit deposits funds issuing loans local members populaires raise sale shares unions"
                    },
                    {
                        "id": "522111",
                        "text": "Personal and Commercial Banking Industry",
                        "keywords": "accepting banking banks businesses chartered commercial companies deposit-accepting deposits issuing loans medium-sized mortgage personal persons small- these trust"
                    },
                    {
                        "id": "522112",
                        "text": "Corporate and Institutional Banking Industry",
                        "keywords": "above-mentioned banking banks businesses chartered clients commercial corporate deposit funds governments institutional issuing large loans obtained personal provide services"
                    }
                ]
            },
            {
                "id": "523",
                "text": "Securities, Commodity Contracts, and Other Financial Investment and Related Activities",
                "keywords": "acting advice asset between bonds buyers buying capital commodities commodity contracts custody exchange facilitating facilities fiduciary financial furnishing intermediaries investment issues management managing marketing marketplaces markets options portfolios process providing purpose putting risk securities sellers selling services space stock stocks trust underwriting",
                "children": [
                    {
                        "id": "523210",
                        "text": "Securities and Commodity Exchanges",
                        "keywords": "bonds buy buying commodities commodity contracts exchanges facilitating marketplaces mechanisms options own prices providing purpose securities sell selling set stock stocks traded"
                    },
                    {
                        "id": "523990",
                        "text": "All Other Financial Investment Activities",
                        "keywords": "basis contract fee financial investment miscellaneous providing services"
                    },
                    {
                        "id": "523930",
                        "text": "Investment Advice",
                        "keywords": "advice authority basis clients communicate counseling electronic execute fee financial investment media planning printed provided providing research service subscription they trades via"
                    },
                    {
                        "id": "523920",
                        "text": "Portfolio Management",
                        "keywords": "assets authority based basis commission decisions fee fees fund investment management managers managing mutual overall pension performance portfolio size these"
                    },
                    {
                        "id": "523910",
                        "text": "Miscellaneous Intermediation",
                        "keywords": "acting basis buy buying commodity contracts financial intermediation investors miscellaneous own principals securities sell selling spread"
                    },
                    {
                        "id": "523140",
                        "text": "Commodity Contracts Brokerage",
                        "keywords": "basis brokerage buying commission commodity contracts futures selling"
                    },
                    {
                        "id": "523130",
                        "text": "Commodity Contracts Dealing",
                        "keywords": "buying commodities commodity contracts currency dealing foreign future futures options selling spot"
                    },
                    {
                        "id": "523120",
                        "text": "Securities Brokerage",
                        "keywords": "basis brokerage buying commission securities selling"
                    },
                    {
                        "id": "523110",
                        "text": "Investment Banking and Securities Dealing",
                        "keywords": "acting banking basis businesses buy dealing distributing governments institutions investment investors issues markets originating own principals securities sell spread trading underwriting who"
                    }
                ]
            },
            {
                "id": "524",
                "text": "Insurance Carriers and Related Activities",
                "keywords": "actuarial age annuities assets based basis build calculations carriers claims contributions damage death disability due employment expected experience factors financial future holders insurance insured invest investment loss payouts policies policy pool portfolio premiums probable property provision reinsurance reserves retailing returns risk services set tables terms underwriting used",
                "children": [
                    {
                        "id": "524122",
                        "text": "Direct, Private, Automobile Insurance Carriers",
                        "keywords": "automobile carriers claims commercial damage derived direct income insurance investment liability loss measured output package percent policyholders premiums private provided underwriting vehicle vehicles"
                    },
                    {
                        "id": "524111",
                        "text": "Direct Individual Life, Health and Medical Insurance Carriers",
                        "keywords": "accidental annuities carriers death dental direct disability dismemberment health hospital income individual insurance life medical policyholders services underwriting vision"
                    },
                    {
                        "id": "524112",
                        "text": "Direct Group Life, Health and Medical Insurance Carriers",
                        "keywords": "accidental annuities carriers death dental direct disability dismemberment health hospital income insurance life medical policyholders services underwriting vision"
                    },
                    {
                        "id": "524210",
                        "text": "Insurance Agencies and Brokerages",
                        "keywords": "agencies brokerages carriers employed insurance pension products represent selling staff these they"
                    },
                    {
                        "id": "524135",
                        "text": "Liability Reinsurance Carriers",
                        "keywords": "arise assuming carriers carrying cent claims course damage death derived directors' income injury insurance investment legal liability malpractice measured occupational originally out output per personal policies premiums product professional property protection provides reinsurance risk underwritten"
                    },
                    {
                        "id": "524139",
                        "text": "General and Other Reinsurance Carriers",
                        "keywords": "assuming carriers insurance originally policies reinsurance risk underwritten"
                    },
                    {
                        "id": "524134",
                        "text": "Property Reinsurance Carriers",
                        "keywords": "assuming buildings carriers claims contents derived income insurance investment losses measured originally output percent policies premiums property protection provides reinsurance risk underwritten"
                    },
                    {
                        "id": "524132",
                        "text": "Accident and Sickness Reinsurance Carriers",
                        "keywords": "accident assuming carriers claims dental derived health hospital income insurance investment measured medical originally output percent policies premiums reinsurance risk services sickness underwritten vision"
                    },
                    {
                        "id": "524133",
                        "text": "Automobile Reinsurance Carriers",
                        "keywords": "assuming automobile carriers claims derived income insurance investment measured originally output percent policies premiums reinsurance risk underwritten"
                    },
                    {
                        "id": "524131",
                        "text": "Life Reinsurance Carriers",
                        "keywords": "accidental annuities assuming carriers claims death derived disability dismemberment income individual insurance investment life measured originally output percent policies premiums reinsurance risk underwritten"
                    },
                    {
                        "id": "524129",
                        "text": "Other Direct Insurance (except Life, Health and Medical) Carriers",
                        "keywords": "acts aircraft boiler bonds buildings cargo carriers company compensation complete damage depository deposits direct dishonest employees equipment faulty fidelity fraudulent guaranteeing guarantees has health individual institutions insurance insured insuring liability life loans losses machinery malfunctioning marine medical organizations passengers policyholders promised protect protection provides providing resulting shares surety surrounding title underwriting vessels well will work workers'"
                    },
                    {
                        "id": "524125",
                        "text": "Direct Liability Insurance Carriers",
                        "keywords": "arise carriers carrying claims course damage death derived direct directors' income injury insurance investment legal liability malpractice measured occupational out output percent personal policyholders premiums product professional property protection provides underwriting"
                    },
                    {
                        "id": "524124",
                        "text": "Direct Property Insurance Carriers",
                        "keywords": "accommodation buildings business-interruption carriers cent claims commercial contents costs derived direct homeowners income insurance investment liability losses measured output package per personal policyholders premiums property protection provided provides temporary tenants types underwriting"
                    },
                    {
                        "id": "524123",
                        "text": "Direct, Public, Automobile Insurance Carriers",
                        "keywords": "automobile carriers direct government-owned insurance policyholders public underwriting"
                    },
                    {
                        "id": "524121",
                        "text": "Direct General Property and Casualty Insurance Carriers",
                        "keywords": "accounting automobile carriers casualty claims direct income insurance investment liability measured no output percent policyholders premiums property types underwriting"
                    },
                    {
                        "id": "524291",
                        "text": "Claims Adjusters",
                        "keywords": "adjusters appraising basis claims contract fee insurance investigating settling"
                    },
                    {
                        "id": "524299",
                        "text": "All Other Insurance Related Activities",
                        "keywords": "adjusting administrative basis benefit carriers claims contract employee fee funds insurance plans processing providing review self-insurance services utilization"
                    }
                ]
            },
            {
                "id": "526",
                "text": "Funds and Other Financial Vehicles",
                "keywords": "assets beneficiaries benefit dividends earn employment entities financial funds hold holders income interest investors little no organized pension portfolio property revenue sale services these trusts unit vehicles",
                "children": [
                    {
                        "id": "526981",
                        "text": "Securitization Vehicles",
                        "keywords": "acquisition asset-backed automobile broadly businesses card class commercial credit equipment financial fixed-income issuance leases loans made marketable mortgages organized persons pools purpose receivables referred residential securities securitization special these vehicles"
                    },
                    {
                        "id": "526989",
                        "text": "All Other Miscellaneous Funds and Financial Vehicles",
                        "keywords": "class closed-end financial funds miscellaneous purpose special trusts vehicles"
                    },
                    {
                        "id": "526911",
                        "text": "Equity Funds - Canadian",
                        "keywords": "- appreciation class common companies equity funds growth investing investment objective shares"
                    },
                    {
                        "id": "526112",
                        "text": "Non-Trusteed Pension Funds",
                        "keywords": "administered arrangement authorized benefits canada class company contract contributions corporate fund funded funds government governments insurance life non-trusteed pension provide provincial society"
                    },
                    {
                        "id": "526111",
                        "text": "Trusteed Pension Funds",
                        "keywords": "accordance agreement assets benefit benefits class company contributions deposited disbursement fiduciary fund funds hold individuals investment least members pension plan provide receipt relationship responsible title trust trustee trusteed who written"
                    },
                    {
                        "id": "526915",
                        "text": "Bond and Income / Dividend Funds - Canadian",
                        "keywords": "- bond class common companies debt dividend funds income interest investing issues objective portfolio preferred shares"
                    },
                    {
                        "id": "526912",
                        "text": "Equity Funds - Foreign",
                        "keywords": "- appreciation class common companies equity foreign funds growth investing investment objective shares"
                    },
                    {
                        "id": "526914",
                        "text": "Money Market Funds",
                        "keywords": "bills change class commercial debt foreign funds government guaranteed income instruments interest investing investment investments market money objective paper rates short term treasury"
                    },
                    {
                        "id": "526913",
                        "text": "Mortgage Funds",
                        "keywords": "class funds income interest investing mortgage mortgages objective property"
                    },
                    {
                        "id": "526919",
                        "text": "Other Open-Ended Funds",
                        "keywords": "class classes funds futures hedge invest metals open-end open-ended precious"
                    },
                    {
                        "id": "526916",
                        "text": "Bond and Income / Dividend Funds - Foreign",
                        "keywords": "- bond class common companies debt dividend foreign funds income interest investing issues objective portfolio preferred shares"
                    },
                    {
                        "id": "526930",
                        "text": "Segregated (except Pension) Funds",
                        "keywords": "accounts act allows british class companies contained corresponding effect established foreign funds insurance insurers insurers' invest investment life pension policyholders portfolio provincial provisions restriction sections segregated separate setting subject these"
                    },
                    {
                        "id": "526917",
                        "text": "Balanced Funds / Asset Allocation Funds",
                        "keywords": "allocation appreciation asset balance balanced blend bond capital class depend equity fixed fund funds income investing investments market money objective portfolio securities stock trends well will"
                    }
                ]
            }
        ]
    },
    {
        "id": "53",
        "text": "Real Estate and Rental and Leasing",
        "keywords": "allowing appraising assets buying estate intangible leasing managing real rental renting selling tangible use",
        "children": [
            {
                "id": "531",
                "text": "Real Estate",
                "keywords": "acting appraising estate intermediaries leasing managing real rental renting sale",
                "children": [
                    {
                        "id": "531320",
                        "text": "Offices of Real Estate Appraisers",
                        "keywords": "appraisal appraisers appraising auctioneers buyers companies courts creditors estate insurance offices preparing real reports sellers value"
                    },
                    {
                        "id": "531111",
                        "text": "Lessors of Residential Buildings and Dwellings (except Social Housing Projects)",
                        "keywords": "additional administer buildings dwellings housing lease leasing lessors maintain maintenance operate operation own parking party projects properties provide removal renting residential security services snow social subcontract these they trash"
                    },
                    {
                        "id": "531390",
                        "text": "Other Activities Related to Real Estate",
                        "keywords": "estate providing real services"
                    },
                    {
                        "id": "531310",
                        "text": "Real Estate Property Managers",
                        "keywords": "accounting administration administrative agreements approval basis behalf cleaning collection contract contracts co-ordination estate fee lease maintenance managers managing negotiation owners payments preparation properties property real rental security services statements these"
                    },
                    {
                        "id": "531211",
                        "text": "Real Estate Agents",
                        "keywords": "acting advertising agents assist associate associates basis behalf brokers buyers buying capacity category clients commission conducting contract estate fee houses identified independent known lease licensed listing names obligated offers open participate persons properties prospective purchase real rent represent representatives sales selecting selling these they various vendors visiting"
                    },
                    {
                        "id": "531212",
                        "text": "Offices of Real Estate Brokers",
                        "keywords": "activity advertising assist basis brokers buyers buying commission conducting estate fee houses licensed listing offers offices open primary properties prospective purchase real registered renting selecting selling vendors visiting"
                    },
                    {
                        "id": "531190",
                        "text": "Lessors of Other Real Estate Property",
                        "keywords": "buildings estate leasing lessors property real renting"
                    },
                    {
                        "id": "531130",
                        "text": "Self-Storage Mini-Warehouses",
                        "keywords": "clients compartments containers goods leasing lockers mini-warehouses outdoor provide renting retrieve rooms secure self-storage space store these"
                    },
                    {
                        "id": "531112",
                        "text": "Lessors of Social Housing Projects",
                        "keywords": "buildings corporations dwellings earners entities funded government housing leasing lessors low-income non-profit operated private projects provided renting residential social these they"
                    },
                    {
                        "id": "531120",
                        "text": "Lessors of Non-Residential Buildings (except Mini-Warehouses)",
                        "keywords": "additional administer buildings lease lessors maintain maintenance mini-warehouses non-residential operate operating operation own owning parking party properties provide removal security services snow subcontract these they trash"
                    }
                ]
            },
            {
                "id": "532",
                "text": "Rental and Leasing Services",
                "keywords": "acquire arrangements arranging automobiles basis business clients computers consumer contracts customers dealers enable equipment expertise facility financial financing find goods industrial inventories latter lease leased leases leasing lessors locations longer-term machinery main maintain maintains marketing meet needs offers operate operates operating operations payment periodic periods previously provide providing remarketing rental rented renting retail-like return services short specialized store-front structure support tangible these they time types use used users vendors work",
                "children": [
                    {
                        "id": "532111",
                        "text": "Passenger Car Rental",
                        "keywords": "car cars drivers passenger periods rental renting short time without"
                    },
                    {
                        "id": "532112",
                        "text": "Passenger Car Leasing",
                        "keywords": "car cars drivers leasing long passenger periods time without"
                    },
                    {
                        "id": "532120",
                        "text": "Truck, Utility Trailer and RV (Recreational Vehicle) Rental and Leasing",
                        "keywords": "buses drivers leasing recreational rental renting rv rvs semi-trailers tractors trailer trailers truck trucks utility vehicle vehicles without"
                    },
                    {
                        "id": "532210",
                        "text": "Consumer Electronics and Appliance Rental",
                        "keywords": "appliance appliances consumer electronics rental renting"
                    },
                    {
                        "id": "532280",
                        "text": "All Other Consumer Goods Rental",
                        "keywords": "theatrical wardrobes costumes rental exercise physical fitness equipment home health household furniture musical instrument piano guitar violins cellos party supplies leasing pleasure boats canoes rowboats sailboats recreation sports golf carts"
                    },
                    {
                        "id": "532310",
                        "text": "General Rental Centres",
                        "keywords": "banquet builders' centres commercial consumer contractors' conveniently equipment facilities garden goods home industrial inventories lawn limited located maintain moving operate party periods provide range rental rented renting repair short supplies these they time tools"
                    },
                    {
                        "id": "532410",
                        "text": "Construction, Transportation, Mining, and Forestry Machinery and Equipment Rental and Leasing",
                        "keywords": "construction equipment forestry heavy leasing machinery mining operators rental renting transportation without"
                    },
                    {
                        "id": "532420",
                        "text": "Office Machinery and Equipment Rental and Leasing",
                        "keywords": "equipment leasing machinery office rental renting"
                    },
                    {
                        "id": "532490",
                        "text": "Other Commercial and Industrial Machinery and Equipment Rental and Leasing",
                        "keywords": "commercial equipment industrial leasing machinery rental renting"
                    }
                ]
            },
            {
                "id": "533",
                "text": "Lessors of Non-Financial Intangible Assets (Except Copyrighted Works)",
                "keywords": "agreements allowing assets brand copyrighted fee franchise holding intangible lessors names non-financial patents reproduce trademarks use works",
                "children": [
                    {
                        "id": "533110",
                        "text": "Lessors of Non-Financial Intangible Assets (Except Copyrighted Works)",
                        "keywords": "agreements allowing assets brand copyrighted fee franchise holding intangible lessors names non-financial patents reproduce trademarks use works"
                    }
                ]
            }
        ]
    },
    {
        "id": "54",
        "text": "Professional, Scientific and Technical Services",
        "keywords": "accounting advertising almost architectural assignment basis capital care case college components consulting dependent design development diagnosis distinguishing education employees engineering equipment every expertise fact feature grouped health human importance individual input instruction knowledge legal main major management mapping materials most much processes production professional provider providing requires research scientific sell service services skills subjects surveying technical these though thus training treatment university variety wholly wide worker",
        "children": [
            {
                "id": "5411",
                "text": "Legal Services",
                "keywords": "lawyers legal notaries offices paralegal paralegals providing services",
                "children": [
                    {
                        "id": "541190",
                        "text": "Other Legal Services",
                        "keywords": "legal paralegal practitioners providing services"
                    },
                    {
                        "id": "541120",
                        "text": "Offices of Notaries",
                        "keywords": "approving contracts documents drafting estate indexing lawyers legal notaries offices real receiving storing transactions wills"
                    },
                    {
                        "id": "541110",
                        "text": "Offices of Lawyers",
                        "keywords": "area barristers corporate criminal estate expertise family intellectual known law lawyers legal offices practice practitioners property provide range real solicitors specific"
                    }
                ]
            },
            {
                "id": "5412",
                "text": "Accounting, Tax Preparation, Bookkeeping and Payroll Services",
                "keywords": "accounting auditing billing bookkeeping budgets designing developing financial payroll payrolls preparation preparing processing records returns services statements systems tax",
                "children": [
                    {
                        "id": "541212",
                        "text": "Offices of Accountants",
                        "keywords": "accountants accounting advice auditing bookkeeping budgets consulting design development financial insolvency management matters offices payroll preparation provide providing provision range records reports return review services statements systems tax these"
                    },
                    {
                        "id": "541213",
                        "text": "Tax Preparation Services",
                        "keywords": "accounting billing bookkeeping payroll preparation processing provide providing return services tax these"
                    },
                    {
                        "id": "541215",
                        "text": "Bookkeeping, Payroll and Related Services",
                        "keywords": "accounting auditing billing bookkeeping financial management payroll preparation processing provide providing records reports review services statements these"
                    }
                ]
            },
            {
                "id": "5413",
                "text": "Architectural, Engineering and Related Services",
                "keywords": "architectural building design drafting engineering graphic industrial inspection interior laboratory landscape mapping on-site providing services specialized structure surveying testing",
                "children": [
                    {
                        "id": "541350",
                        "text": "Building Inspection Services",
                        "keywords": "aspects building buyers component condition estate evaluate inspection involved physical prepare property providing real report services structure systems these transactions"
                    },
                    {
                        "id": "541340",
                        "text": "Drafting Services",
                        "keywords": "architectural buildings components detailed drafting drawing engineering illustrations layouts plans services specifications structures systems"
                    },
                    {
                        "id": "541330",
                        "text": "Engineering Services",
                        "keywords": "advice applying assignments construction design designs development during engineering evaluation feasibility final following inspection installation instruments involve machines materials phase plans preliminary preparation principles processes projects provision services structures studies systems technical these undertaken utilization"
                    },
                    {
                        "id": "541310",
                        "text": "Architectural Services",
                        "keywords": "applying architectural building buildings codes commercial construction design designing industrial institutional knowledge leisure materials planning procedures regulations residential services structures zoning"
                    },
                    {
                        "id": "541320",
                        "text": "Landscape Architectural Services",
                        "keywords": "administering airports applying architectural areas buildings characteristics commercial design designing development highways hospitals industrial knowledge land landscape location parks planning projects recreational residential schools services structures subdivisions use"
                    },
                    {
                        "id": "541370",
                        "text": "Surveying and Mapping (except Geophysical) Services",
                        "keywords": "above areas base below cadastral cartographic control creating creation earth easements floor geodesy geographic geophysical geospatial gis global gps information land mapping parcels photogrammetric positioning providing quality rights sea segregating services surface surveying system these topographic underground utility view"
                    },
                    {
                        "id": "541360",
                        "text": "Geophysical Surveying and Mapping Services",
                        "keywords": "conduct data depending electrical electromagnetic engineering extent gas geophysical gravity interpreting locating magnetic mapping measuring minerals oil purpose purposes radioactive remote resources seismic sensing services specialize subsurface survey surveying surveys techniques these they used variety"
                    },
                    {
                        "id": "541380",
                        "text": "Testing Laboratories",
                        "keywords": "analytical chemical laboratories laboratory occur on-site physical providing services testing"
                    }
                ]
            },
            {
                "id": "5414",
                "text": "Specialized Design Services",
                "keywords": "architectural computer design engineering providing services specialized systems",
                "children": [
                    {
                        "id": "541410",
                        "text": "Interior Design Services",
                        "keywords": "administering aesthetic areas building care codes commercial consideration consultants corporate decorating design designers designing electrical exclusively fittings floor furniture health hospitality institutional interior mechanical meet needs patterns people physical planning projects providing regulations residential safety services spaces traffic work"
                    },
                    {
                        "id": "541490",
                        "text": "Other Specialized Design Services",
                        "keywords": "design professional providing services specialized"
                    },
                    {
                        "id": "541430",
                        "text": "Graphic Design Services",
                        "keywords": "advertising clarify communication complex concepts convey corporate design designing displays graphic identification identities information managing materials messages packaging planning printed production project screen services signage specific systems these video visual"
                    },
                    {
                        "id": "541420",
                        "text": "Industrial Design Services",
                        "keywords": "appeal appearance colour consideration construction creating design designs determination developing distribution efficiency finishes function human industrial maintenance market materials mechanisms needs optimize product production products safety services shape specifications surface these use value"
                    }
                ]
            },
            {
                "id": "5415",
                "text": "Computer Systems Design and Related Services",
                "keywords": "advice clients' communication computer computer-related creation customer data design designing expertise facilities field hardware home information integrate internet management meet modifying needs on-site operation pages planning processing professional providing services software supporting systems technical technologies testing writing",
                "children": [
                    {
                        "id": "541514",
                        "text": "Computer Systems Design and Related Services (except Video Game Design and Development)",
                        "keywords": "advice analysis application area automation CAD CAE CAM clients' communication computer computer-aided computer-related consultants consulting creation custom customer data design designing developers development disaster engineering expertise facilities field hardware home information installation integrate integration integrators internet Internet IT LAN local maintenance management meet modifying multiple needs network office on-site operation packages page pages planning processing professional programs programming providing recovery requirements services software support supporting system systems technical technology technologies testing users' web writing"
                    },
                    {
                        "id": "541515",
                        "text": "Video Game Design and Development Services",
                        "keywords": "custom developing designing game games video"
                    }
                ]
            },
            {
                "id": "5416",
                "text": "Management, Scientific and Technical Consulting Services",
                "keywords": "advice assistance consulting environmental expert issues management organizations providing scientific services technical",
                "children": [
                    {
                        "id": "541690",
                        "text": "Other Scientific and Technical Consulting Services",
                        "keywords": "advice assistance consulting issues organizations providing scientific services technical"
                    },
                    {
                        "id": "541620",
                        "text": "Environmental Consulting Services",
                        "keywords": "advice air areas asbestos assistance consultants consulting contamination control employ engineers environmental evaluate expertise hazardous identify issues law materials measure multi-disciplined organizations pollutants problems providing quality recommend remediation risks sanitation scientists services site solutions staff substances technicians these they toxic water"
                    },
                    {
                        "id": "541612",
                        "text": "Human Resources Consulting Services",
                        "keywords": "administration advice assistance benefits communication compensation consulting employee executive human issues management organizations personnel planning policies practices procedures providing recruitment resource resources salary search services systems wage"
                    },
                    {
                        "id": "541611",
                        "text": "Administrative Management and General Management Consulting Services",
                        "keywords": "administrative advice asset assistance budgeting business clients consultants consulting distribution equity financial full human improvement issues logistics management marketing new office organizational organizations physical planning process provide providing range records resource selection services site start-up strategic"
                    },
                    {
                        "id": "541619",
                        "text": "Other Management Consulting Services",
                        "keywords": "advice assistance consulting issues management organizations providing services"
                    }
                ]
            },
            {
                "id": "5417",
                "text": "Scientific Research and Development Services",
                "keywords": "application basis conducting creation development domain experimental expertise findings gain improved investigation knowledge new original processes products research scientific services significantly systematic undertaken within",
                "children": [
                    {
                        "id": "541710",
                        "text": "Research and Development in the Physical, Engineering and Life Sciences",
                        "keywords": "agriculture allied biology biotechnology botany chemistry computers conducting development electronics engineering environmental experimental fisheries forestry geology health life mathematics medicine oceanography pharmacy physical physics research sciences subjects veterinary"
                    },
                    {
                        "id": "541720",
                        "text": "Research and Development in the Social Sciences and Humanities",
                        "keywords": "analyses conducting development economics education humanities language law psychology research sciences social sociology"
                    }
                ]
            },
            {
                "id": "5418",
                "text": "Advertising, Public Relations, and Related Services",
                "keywords": "advertisers advertising agencies campaigns creating delivering direct display implementing indoor lettering mail mass-media materials media outdoor owners painting placing providing public relation relations samples selling services sign space specialty time trimming welcoming window",
                "children": [
                    {
                        "id": "541870",
                        "text": "Advertising Material Distribution Services",
                        "keywords": "advertising delivery distribution electronic mail material materials samples services"
                    },
                    {
                        "id": "541899",
                        "text": "All Other Services Related to Advertising",
                        "keywords": "advertising providing services"
                    },
                    {
                        "id": "541860",
                        "text": "Direct Mail Advertising",
                        "keywords": "advertising campaigns compile creating designing direct distribution lists mail mailing maintain material preparing rent sell these"
                    },
                    {
                        "id": "541850",
                        "text": "Display Advertising",
                        "keywords": "advertising billboards creating display displays electronic facilities indoor mall material outdoor painted panels placing printed public shopping sites structures transit vehicles within"
                    },
                    {
                        "id": "541840",
                        "text": "Media Representatives",
                        "keywords": "media owners representatives selling space time"
                    },
                    {
                        "id": "541830",
                        "text": "Media Buying Agencies",
                        "keywords": "advertisers advertising agencies buying media owners purchasing reselling space time"
                    },
                    {
                        "id": "541820",
                        "text": "Public Relations Services",
                        "keywords": "campaigns clients creating designed image implementing interests promote public relation relations services these"
                    },
                    {
                        "id": "541810",
                        "text": "Advertising Agencies",
                        "keywords": "advertising advice agencies buying campaigns capabilities creating creative full in-house management material media newspapers organized periodicals placing planning production provide radio range services subcontracting television these"
                    },
                    {
                        "id": "541891",
                        "text": "Specialty Advertising Distributors",
                        "keywords": "accessories act advertising applied badges between buttons calendars clients creating desk distribute distributors free-of-charge instruments intermediaries messages organizing product production products promotional specialty stickers suppliers these wearables who writing"
                    }
                ]
            },
            {
                "id": "5419",
                "text": "Other Professional, Scientific and Technical Services",
                "keywords": "houses interpreters marketing opinion photographic polling practices professional providing public research scientific services studios technical translators veterinary",
                "children": [
                    {
                        "id": "541940",
                        "text": "Veterinary Services",
                        "keywords": "animals dentistry laboratories licensed medicine practice practitioners services surgery veterinary"
                    },
                    {
                        "id": "541920",
                        "text": "Photographic Services",
                        "keywords": "aerial commercial computer event events field industrial photographic photography portrait providing services special specialize still taping these video"
                    },
                    {
                        "id": "541910",
                        "text": "Marketing Research and Public Opinion Polling",
                        "keywords": "data marketing opinion polling presenting public recording research tabulating"
                    },
                    {
                        "id": "541930",
                        "text": "Translation and Interpretation Services",
                        "keywords": "interpretation interpreting language material providing services sign speech translating translation written"
                    },
                    {
                        "id": "541990",
                        "text": "All Other Professional, Scientific and Technical Services",
                        "keywords": "professional provision scientific services technical"
                    }
                ]
            }
        ]
    },
    {
        "id": "55",
        "text": "Management of Companies and Enterprises",
        "keywords": "assets companies controlling decisions enterprises entrust financial function holding influencing interest management managers managing owning portfolio purpose securities they undertake",
        "children": [
            {
                "id": "551113",
                "text": "Holding Companies",
                "keywords": "businesses companies control decisions equity exercising holding influencing interests management purpose securities subsidiaries these"
            },
            {
                "id": "551114",
                "text": "Head Offices",
                "keywords": "administrative affiliated head management offices providing services support"
            }
        ]
    },
    {
        "id": "56",
        "text": "Administrative and Support, Waste Management and Remediation Services",
        "keywords": "administration administrative arranging buildings cases claims cleaning clients collecting collection day-to-day different disposal documents economy facilities found hiring households in-house labelling management material operation operations orders organizations packaging payments personnel placing polluted preparing products provide providing recovery remediation sectors security septic services sites specialize support surveillance tanks therefore these travel treatment types undertaken variety waste",
        "children": [
            {
                "id": "561",
                "text": "Administrative and Support Services",
                "keywords": "administration administrative arranging basis buildings cases claims cleaning clients collecting day-to-day documents economy found hiring households individual in-house labelling operations orders organizations packaging payments personnel placing preparing process products provide providing sectors security services specialize support surveillance therefore these they travel undertaken variety",
                "children": [
                    {
                        "id": "561910",
                        "text": "Packaging and Labelling Services",
                        "keywords": "client-owned imprinting labelling materials package packaging service services"
                    },
                    {
                        "id": "561920",
                        "text": "Convention and Trade Show Organizers",
                        "keywords": "convention conventions events facilities operate organizers organizing place promoting show shows supporting take these they trade whether"
                    },
                    {
                        "id": "561621",
                        "text": "Security Systems Services (except Locksmiths)",
                        "keywords": "alarm alarms along burglar electronic fire installation locksmiths maintenance monitoring remote security selling services systems"
                    },
                    {
                        "id": "561622",
                        "text": "Locksmiths",
                        "keywords": "adjusting along devices electronic installation installing locking locksmiths mechanical rebuilding repair repairing safes security selling services vaults"
                    },
                    {
                        "id": "561710",
                        "text": "Exterminating and Pest Control Services",
                        "keywords": "around buildings control controlling exterminating insects pest pests rodents services structures"
                    },
                    {
                        "id": "561990",
                        "text": "All Other Support Services",
                        "keywords": "providing services support"
                    },
                    {
                        "id": "561590",
                        "text": "Other Travel Arrangement and Reservation Services",
                        "keywords": "agencies arrangement operators providing reservation services tour travel"
                    },
                    {
                        "id": "561520",
                        "text": "Tour Operators",
                        "keywords": "agencies arranging assembling marketing operators tour tours travel"
                    },
                    {
                        "id": "561510",
                        "text": "Travel Agencies",
                        "keywords": "accommodation acting agencies agents clients commercial companies operators public selling services tour transportation travel"
                    },
                    {
                        "id": "561613",
                        "text": "Armoured Car Services",
                        "keywords": "armoured car delivering equipment items money personnel picking properties protect receipts services transit valuable while"
                    },
                    {
                        "id": "561611",
                        "text": "Investigation Services",
                        "keywords": "detective investigation providing services"
                    },
                    {
                        "id": "561612",
                        "text": "Security Guard and Patrol Services",
                        "keywords": "guard patrol providing security services"
                    },
                    {
                        "id": "561410",
                        "text": "Document Preparation Services",
                        "keywords": "court desktop document documents editing preparation processing proofreading providing publishing reporting secretarial services stenographic transcription word writing"
                    },
                    {
                        "id": "561490",
                        "text": "Other Business Support Services",
                        "keywords": "business providing services support"
                    },
                    {
                        "id": "561440",
                        "text": "Collection Agencies",
                        "keywords": "agencies claims clients collecting collection payment payments remitting these"
                    },
                    {
                        "id": "561430",
                        "text": "Business Service Centres",
                        "keywords": "advertising business centres computer copy copying direct-mail facsimile known mailbox mailing office on-site pc personal postal processing product provide providing range rental retailing service services shops support word"
                    },
                    {
                        "id": "561420",
                        "text": "Telephone Call Centres",
                        "keywords": "answering call calls centres clients funds information mailbox messages orders products promoting providing raising receiving relaying services soliciting telephone these voice"
                    },
                    {
                        "id": "561110",
                        "text": "Office Administrative Services",
                        "keywords": "administer administrative billing business carry clients client's complete coordinate day-to-day direct distribution financing keeping managerial office operating operations out personnel physical provide providing range record services staff these"
                    },
                    {
                        "id": "561450",
                        "text": "Credit Bureaus",
                        "keywords": "bureaus businesses compiling credit employment evaluate financial histories individuals information institutions investigation need persons providing retailers services these who worthiness"
                    },
                    {
                        "id": "561330",
                        "text": "Professional Employer Organizations",
                        "keywords": "accountability accounting acquire administration back benefits businesses client clients clients' co-employment decision degrees duties employee employees employer exercise human labour lease leased leasing management managing operate operations organizations output payroll performing personnel planning preparation professional profitability providing purposes range recruiting regard relating relations relationship resource resources return role serve services specialized strategic tax these varying wide work"
                    },
                    {
                        "id": "561320",
                        "text": "Temporary Help Services",
                        "keywords": "client clients' direct employees help individuals limited periods provide provided service services sites supervision supplement supplying temporary these time work workers workforce"
                    },
                    {
                        "id": "561310",
                        "text": "Employment Placement Agencies and Executive Search Services",
                        "keywords": "agencies applicants basis employees employment executive individuals listing permanent placed placement placing referring search selecting services temporary vacancies"
                    },
                    {
                        "id": "561210",
                        "text": "Facilities Support Services",
                        "keywords": "business carry client client's core disposal facilities guard involved janitorial laundry logistical mail maintenance operating operations out provide providing reception responsible routing security services staff support these they trash within"
                    },
                    {
                        "id": "561721",
                        "text": "Window Cleaning Services",
                        "keywords": "cleaning services window windows"
                    },
                    {
                        "id": "561722",
                        "text": "Janitorial Services (except Window Cleaning)",
                        "keywords": "aircraft building cars cleaning equipment interiors janitorial rail services ships transportation window"
                    },
                    {
                        "id": "561730",
                        "text": "Landscaping Services",
                        "keywords": "along care construction decks fences gardens installation installing landscape landscaping lawns maintenance plants ponds providing retaining services shrubs structures these trees walkways walls"
                    },
                    {
                        "id": "561740",
                        "text": "Carpet and Upholstery Cleaning Services",
                        "keywords": "carpet carpets cleaning dyeing rugs services upholstery"
                    },
                    {
                        "id": "561791",
                        "text": "Duct and Chimney Cleaning Services",
                        "keywords": "chimney cleaning duct furnace providing services"
                    },
                    {
                        "id": "561799",
                        "text": "All Other Services to Buildings and Dwellings",
                        "keywords": "building buildings cleaning dwellings exterior pool providing sandblasting services swimming"
                    }
                ]
            },
            {
                "id": "562",
                "text": "Waste Management and Remediation Services",
                "keywords": "collection disposal environmental facilities management material providing pumping recovery remediation septic services tank treatment waste",
                "children": [
                    {
                        "id": "562990",
                        "text": "All Other Waste Management Services",
                        "keywords": "management services waste"
                    },
                    {
                        "id": "562110",
                        "text": "Waste Collection",
                        "keywords": "area collecting collection hauling hazardous local non-hazardous packaging responsible stations transfer transport treating waste within"
                    },
                    {
                        "id": "562210",
                        "text": "Waste Treatment and Disposal",
                        "keywords": "collection disposal facilities fill hazardous incinerators integrate land non-hazardous operating sites treatment waste"
                    },
                    {
                        "id": "562910",
                        "text": "Remediation Services",
                        "keywords": "buildings clean-up contaminated contouring ground hazardous integrated land material mine reclamation remediation removal revegetation services site sites soil treatment waste water"
                    },
                    {
                        "id": "562920",
                        "text": "Material Recovery Facilities",
                        "keywords": "categories distinct facilities material materials mixed operating prepared recovery recyclable removed shipment sorted waste"
                    }
                ]
            }
        ]
    },
    {
        "id": "61",
        "text": "Educational Services",
        "keywords": "ability accommodation adapted centres colleges commonality correspondence delivered demonstrate direct diverse educational expertise explain food hearing home impairments imparted inputs institutions instruction labour language lessons matter means namely needs offer operated owned privately process profit provided providing publicly replace requisite schools self-learning services settings share sign specialized students subject subjects supervise teachers teaching television tell these they training universities variety verbal who wide workplace",
        "children": [
            {
                "id": "611690",
                "text": "All Other Schools and Instruction",
                "keywords": "instruction providing schools services"
            },
            {
                "id": "611630",
                "text": "Language Schools",
                "keywords": "career conversational courses educational enrichment foreign instruction intensive language offer opportunities personal providing ranging schools skills these training"
            },
            {
                "id": "611620",
                "text": "Athletic Instruction",
                "keywords": "athletic camps day instruction overnight providing sports"
            },
            {
                "id": "611110",
                "text": "Elementary and Secondary Schools",
                "keywords": "academic basic comprise courses education elementary grade kindergarten preparatory providing schools secondary th"
            },
            {
                "id": "611710",
                "text": "Educational Support Services",
                "keywords": "educational non-instructional processes providing services support systems"
            },
            {
                "id": "611210",
                "text": "Community Colleges and C.E.G.E.P.s",
                "keywords": "academic admission associate below cegeps certificates colleges community courses degree degrees diploma diplomas equivalent granting high least level program providing requirement school technical training university"
            },
            {
                "id": "611310",
                "text": "Universities",
                "keywords": "academic admission baccalaureate courses degree degrees diploma equivalent graduate granting high least levels professional programs providing requirement school training universities"
            },
            {
                "id": "611410",
                "text": "Business and Secretarial Schools",
                "keywords": "addition basic business career classes clerical communications computer courses court designed desktop individuals machine offer office operation procedures processing providing publishing pursuing reception reporting schools secretarial skills spreadsheets stenographic these word"
            },
            {
                "id": "611420",
                "text": "Computer Training",
                "keywords": "area business client's computer computerized conducting electronics establishment's facilities instruction local location management network off-site operations own packages phases programming provided software systems technology training"
            },
            {
                "id": "611430",
                "text": "Professional and Management Development Training",
                "keywords": "array career client's courses customers customized development employers' establishment's facilities individuals instruction location management meet modified needs off-site own professional programs provided providing seminars short-duration special training"
            },
            {
                "id": "611510",
                "text": "Technical and Trade Schools",
                "keywords": "certification correspondence leads non-academic providing schools subjects technical trade trades training variety vocational"
            },
            {
                "id": "611610",
                "text": "Fine Arts Schools",
                "keywords": "art arts commercial dance drama fine graphic instruction music photography professional providing schools"
            }
        ]
    },
    {
        "id": "62",
        "text": "Health Care and Social Assistance",
        "keywords": "assistance care child community counselling diagnosis food health housing medical protection providing reasons rehabilitation requiring residential services social treatment vocational welfare",
        "children": [
            {
                "id": "621",
                "text": "Ambulatory Health Care Services",
                "keywords": "ambulatory care equipment facilities health indirectly most out-patient patients practitioners process production provide providing services significant",
                "children": [
                    {
                        "id": "621320",
                        "text": "Offices of Optometrists",
                        "keywords": "acuity contact determine examinations exercises eye eyeglasses fitting lenses offices optician optometrists optometry perform practice practitioners prescribe prescription presence private problems provide provided selling services these they vision visual"
                    },
                    {
                        "id": "621310",
                        "text": "Offices of Chiropractors",
                        "keywords": "adjustment chiropractic chiropractors column diagnostic disorders extremities manipulation medicine neuro-musculoskeletal offices practice practitioners private provide spinal therapeutic these treatment"
                    },
                    {
                        "id": "621210",
                        "text": "Offices of Dentists",
                        "keywords": "accept appointment called centres clinics dental dentistry dentists especially extended hours licensed office offices patients practice private sometimes specialized surgery walk-in without"
                    },
                    {
                        "id": "621110",
                        "text": "Offices of Physicians",
                        "keywords": "accept appointment called centres clinics confused especially extended hours licensed medical medicine must office offices out-patient patients physicians practice private referred sometimes specialized surgery these walk-in without"
                    },
                    {
                        "id": "621990",
                        "text": "All Other Ambulatory Health Care Services",
                        "keywords": "ambulatory care health providing services"
                    },
                    {
                        "id": "621912",
                        "text": "Air Ambulance Services",
                        "keywords": "air ambulance care emergency equipment equipped life-saving medical operated patients personnel provision services trained transportation vehicles"
                    },
                    {
                        "id": "621911",
                        "text": "Ambulance (except Air Ambulance) Services",
                        "keywords": "air ambulance care emergency equipment equipped ground life-saving medical operated patients personnel provision services trained transportation vehicles"
                    },
                    {
                        "id": "621610",
                        "text": "Home Health Care Services",
                        "keywords": "audiology care combined companion counselling dietary equipment health home homemaker intravenous listed medical medications nursing nutritional occupational personal physical provide providing range services skilled social speech supplies therapy vocational"
                    },
                    {
                        "id": "621510",
                        "text": "Medical and Diagnostic Laboratories",
                        "keywords": "analytic diagnostic health laboratories medical patient practitioner profession provided providing referral services these"
                    },
                    {
                        "id": "621499",
                        "text": "All Other Out-Patient Care Centres",
                        "keywords": "care centres clinics confused dialysis health medical must offices out-patient practitioners providing referred services specialized staff these"
                    },
                    {
                        "id": "621494",
                        "text": "Community Health Centres",
                        "keywords": "care centres clinics community confused health medical must offices out-patient practitioners provides referred services staff these variety within"
                    },
                    {
                        "id": "621410",
                        "text": "Family Planning Centres",
                        "keywords": "basis centres contraceptive counselling family genetic medical medically-indicated out-patient planning pregnancy prenatal providing range services staff sterilization termination therapeutic voluntary"
                    },
                    {
                        "id": "621420",
                        "text": "Out-Patient Mental Health and Substance Abuse Centres",
                        "keywords": "abuse alcohol centres counselling diagnosis disorders health information issues medical mental out-patient provide providing range regarding services staff substance these treatment wide"
                    },
                    {
                        "id": "621390",
                        "text": "Offices of All Other Health Practitioners",
                        "keywords": "health offices practitioners providing services"
                    },
                    {
                        "id": "621340",
                        "text": "Offices of Physical, Occupational, and Speech Therapists and Audiologists",
                        "keywords": "adapt administering audiologists designed diagnosing disabilities educational functioning hearing help language medically-prescribed mental occupational offices patients physical planning problems recreational regain social speech therapists therapy treating treatment"
                    },
                    {
                        "id": "621330",
                        "text": "Offices of Mental Health Practitioners (except Physicians)",
                        "keywords": "clinical degree doctorate health hold medicine mental offices physicians practitioners providing psychiatric psychologists services social who workers"
                    }
                ]
            },
            {
                "id": "622",
                "text": "Hospitals",
                "keywords": "accommodation activity diagnostic equipment facilities form health hospitals in-patients integral licensed medical nurses organized out-patient physicians process production professionals provide providing secondary services significant specialized staff technicians technologists these treatment use variety wide",
                "children": [
                    {
                        "id": "622210",
                        "text": "Psychiatric and Substance Abuse Hospitals",
                        "keywords": "abuse diagnostic disorders electroencephalograph extended hospital hospitals illness licensed medical mental monitoring out-patient patients provide providing psychiatric requires services stay substance suffer these treatment who"
                    },
                    {
                        "id": "622112",
                        "text": "Paediatric Hospitals",
                        "keywords": "children clinical conditions diagnostic diseases hospitals in-patient laboratory licensed medical out-patient paediatric pharmacy provide providing services these treatment variety wide x-ray"
                    },
                    {
                        "id": "622111",
                        "text": "General (except Paediatric) Hospitals",
                        "keywords": "clinical conditions diagnostic diseases hospitals in-patients laboratory licensed medical out-patient paediatric pharmacy provide providing services these treatment variety wide x-ray"
                    },
                    {
                        "id": "622310",
                        "text": "Specialty (except Psychiatric and Substance Abuse) Hospitals",
                        "keywords": "abuse adjustive care chronically clinical condition diagnostic disabled disease educational hospitals ill in-patients laboratory licensed long-term medical out-patient people physical physically-challenged provide providing psychiatric psychological rehabilitation restorative services social specialty specific substance therapy treatment vocational work x-ray"
                    }
                ]
            },
            {
                "id": "623",
                "text": "Nursing and Residential Care Facilities",
                "keywords": "care combined component facilities health largely mix nursing process production provided providing required residential residents services significant social supervisory types",
                "children": [
                    {
                        "id": "623310",
                        "text": "Community Care Facilities for the Elderly",
                        "keywords": "assistance board care community daily desire elderly facilities fully housekeeping independently instances live living nursing on-site personal persons provide providing residential residents room separate services skilled supervision themselves these unable who"
                    },
                    {
                        "id": "623222",
                        "text": "Homes for the Psychiatrically Disabled",
                        "keywords": "addition board care counselling disabled health homes illnesses incidental medical mental offered patients provide providing psychiatrically range rehabilitation residential room services social supervision support these they treatment wide"
                    },
                    {
                        "id": "623210",
                        "text": "Residential Developmental Handicap Facilities",
                        "keywords": "board care counselling developmental developmentally diagnosed facilities focus handicap handicapped handicaps health home hospitals institutional institutions persons protective provide provided providing referred residential room services setting supervision these though"
                    },
                    {
                        "id": "623221",
                        "text": "Residential Substance Abuse Facilities",
                        "keywords": "abuse addition board care counselling facilities illnesses incidental medical mental offered patients provide providing range rehabilitation residential room services social substance supervision support these they treatment wide"
                    },
                    {
                        "id": "623110",
                        "text": "Nursing Care Facilities",
                        "keywords": "care continuous extended facilities facility individuals in-patient nursing personal providing rehabilitative require requiring services stay"
                    },
                    {
                        "id": "623992",
                        "text": "Homes for Emotionally Disturbed Children",
                        "keywords": "additional board care children disturbed emotional emotionally homes parental-type problems provide providing required residential room services specialized supervision these well"
                    },
                    {
                        "id": "623993",
                        "text": "Homes for the Physically Handicapped or Disabled",
                        "keywords": "ambulant care disabilities disabled handicapped handicaps homes impairments physical physically providing residential residents services supervision visual"
                    },
                    {
                        "id": "623991",
                        "text": "Transition Homes for Women",
                        "keywords": "board care counselling extended homes protective provide providing residential room services social supervision these transition victims violence who women"
                    },
                    {
                        "id": "623999",
                        "text": "All Other Residential Care Facilities",
                        "keywords": "care facilities providing residential"
                    }
                ]
            },
            {
                "id": "624",
                "text": "Social Assistance",
                "keywords": "accommodation assistance basis clients providing residential services short-stay social these variety wide",
                "children": [
                    {
                        "id": "624230",
                        "text": "Emergency and Other Relief Services",
                        "keywords": "clothing counselling disasters domestic emergency food international medical providing relief resettlement services shelter victims"
                    },
                    {
                        "id": "624220",
                        "text": "Community Housing Services",
                        "keywords": "abuse assault assists caught child community construction crisis disabled domestic elderly families home homeless homeowner homeowners homes housing individuals low-cost low-income medical organizations partnership patients provide providing repair residential runaway services sexual shelter short-term temporary transitional victims violence volunteer who youths"
                    },
                    {
                        "id": "624210",
                        "text": "Community Food Services",
                        "keywords": "age blankets clothing collect collection community deliver delivery disability distribute donated fixed food illness locations meals mobile needy persons poor preparation prepare provide reason services themselves these unable who"
                    },
                    {
                        "id": "624110",
                        "text": "Child and Youth Services",
                        "keywords": "assistance child children non-residential providing services social youth"
                    },
                    {
                        "id": "624190",
                        "text": "Other Individual and Family Services",
                        "keywords": "assistance family individual non-residential providing services social"
                    },
                    {
                        "id": "624120",
                        "text": "Services for the Elderly and Persons with Disabilities",
                        "keywords": "areas assistance care companionship day-care developmentally disabilities elderly handicapped home improve individuals life non-medical non-residential persons provide providing quality services social support these welfare"
                    },
                    {
                        "id": "624410",
                        "text": "Child Day-Care Services",
                        "keywords": "care child children day-care educational infants offer older pre-kindergarten programs providing school services these they"
                    },
                    {
                        "id": "624310",
                        "text": "Vocational Rehabilitation Services",
                        "keywords": "because counselling disabilities disadvantage education employment experience habilitation handicapped job job-market lack mentally persons physically providing rehabilitation services sheltered skill training underemployed unemployed vocational who work workshops"
                    }
                ]
            }
        ]
    },
    {
        "id": "71",
        "text": "Arts, Entertainment and Recreation",
        "keywords": "amusement artistic arts below creative cultural educational enable entertainment events exhibit exhibits facilities historical hobbies important intended interest interests leisure-time listed live meet most naics necessary objects operate operating participate patrons performances preserve produce production products promote provide providing public pursue recreation recreational sectors services sites skills sports technical these viewing",
        "children": [
            {
                "id": "7111",
                "text": "Performing Arts Companies",
                "keywords": "actors actresses artists arts circuses companies dance dancers groups ice-skating involve live musical performances performing presentations producing shows singers theatre",
                "children": [
                    {
                        "id": "711190",
                        "text": "Other Performing Arts Companies",
                        "keywords": "arts companies live performing presentations producing"
                    },
                    {
                        "id": "711120",
                        "text": "Dance Companies",
                        "keywords": "companies dance dancers facilities involve live operate own performances presentations producing production staging"
                    },
                    {
                        "id": "711112",
                        "text": "Musical Theatre and Opera Companies",
                        "keywords": "actors actresses beverages companies consumption dinner entertainment food involve known live musical opera performances premises presentations producing providing singers theatre theatres theatrical vocalists"
                    },
                    {
                        "id": "711130",
                        "text": "Musical Groups and Artists",
                        "keywords": "artists chamber country groups independent individual involve jazz live music musical musicians orchestras performances pop presentations producing rock symphony vocalists well"
                    },
                    {
                        "id": "711111",
                        "text": "Theatre (except Musical) Companies",
                        "keywords": "actors actresses companies facilities involve live musical operate own performances presentations producing productions staging theatre"
                    }
                ]
            },
            {
                "id": "7112",
                "text": "Spectator Sports",
                "keywords": "amateur athletes audience before clubs events facility independent operate operators presenting professional race role semi-professional spectator sporting sports these tracks",
                "children": [
                    {
                        "id": "711213",
                        "text": "Horse Race Tracks",
                        "keywords": "events horse operating presenting race racing tracks"
                    },
                    {
                        "id": "711214",
                        "text": "Other Racing Facilities and Related Activities",
                        "keywords": "automobile race tracks operation racing teams dog kennels drag strips jet car dogs training motorcycle snowmobile speedways"
                    },
                    {
                        "id": "711215",
                        "text": "Independent Athletes Performing before a Paying Audience",
                        "keywords": "golf professionals professional boxers tennis players race car driver billiard independent bowlers cyclists figure skaters mixed martial arts fighters mountain bike free riders skateboarders skiers speed sports squash track athletes wrestlers"
                    },
                    {
                        "id": "711217",
                        "text": "Sports Teams and Clubs Performing before a Paying Audience",
                        "keywords": "referees scouts hockey baseball sports teams clubs professional semi-professional amateur basketball football soccer timekeepers trainers independent"
                    }
                ]
            },
            {
                "id": "7113",
                "text": "Promoters (Presenters) of Performing Arts, Sports and Similar Events",
                "keywords": "arenas arts events facilities festivals operate operated organizing performing present presenters productions promoters promoting sports stadiums theatres these they",
                "children": [
                    {
                        "id": "711322",
                        "text": "Festivals without Facilities",
                        "keywords": "facilities festivals operated organizing promoting without"
                    },
                    {
                        "id": "711329",
                        "text": "Sports Presenters and Other Presenters without Facilities",
                        "keywords": "events facilities operated organizing presenters promoting sports without"
                    },
                    {
                        "id": "711321",
                        "text": "Performing Arts Promoters (Presenters) without Facilities",
                        "keywords": "arts facilities operated organizing performing presenters productions promoters promoting without"
                    },
                    {
                        "id": "711319",
                        "text": "Sports Stadiums and Other Presenters with Facilities",
                        "keywords": "events facilities held operating organizing own presenters presenting promoting sports stadiums these tournaments"
                    },
                    {
                        "id": "711311",
                        "text": "Live Theatres and Other Performing Arts Presenters with Facilities",
                        "keywords": "arts facilities festivals held live operating organizing performing presenters productions promoting theatre theatres these"
                    }
                ]
            },
            {
                "id": "7114",
                "text": "Agents and Managers for Artists, Athletes, Entertainers and Other Public Figures",
                "keywords": "affairs agents artists athletes careers celebrities clients client's contract creative entertainers figures financial manage managers managing negotiations organize performing promote public represent representing sports these",
                "children": [
                    {
                        "id": "711411",
                        "text": "Agents and managers for artists, entertainers and other public figures",
                        "keywords": "agents theatrical talent managers actors actresses artists authors celebrities entertainers models musicians public figures  speakers' bureaus modelling"
                    },
                    {
                        "id": "711412",
                        "text": "Sports Agents and Managers",
                        "keywords": "agents managers athletes coaches sports figures"
                    }
                ]
            },
            {
                "id": "7115",
                "text": "Independent Artists, Writers and Performers",
                "keywords": "artistic artists athletes celebrities creating cultural endorsement engaging expertise free-lance independent individuals necessary performers performing productions providing services speaking technical these works writers",
                "children": [
                    {
                        "id": "711512",
                        "text": "Independent Actors, Comedians and Performers",
                        "keywords": "actors artistic athletes celebrities comedians cultural endorsement expertise freelance independent individuals journalists necessary performers performing productions providing radio services speaking technical television these works"
                    },
                    {
                        "id": "711513",
                        "text": "Independent Writers and Authors",
                        "keywords": "artistic authors creating cultural expertise freelance independent individuals journalists literary necessary print production providing technical these works writers"
                    },
                    {
                        "id": "711511",
                        "text": "Independent visual artists and artisans",
                        "keywords": "art artistic artists arts creating cultural expertise freelance independent individuals necessary providing technical these visual works"
                    }
                ]
            },
            {
                "id": "7121",
                "text": "Heritage Institutions",
                "keywords": "cultural educational exhibiting heritage historical institutions natural objects preserving sites value wonders",
                "children": [
                    {
                        "id": "712190",
                        "text": "Nature Parks and Other Similar Institutions",
                        "keywords": "areas conservation heritage institutions maintaining nature operating parks protecting reserves"
                    },
                    {
                        "id": "712130",
                        "text": "Zoos and Botanical Gardens",
                        "keywords": "animal botanical constructing displays gardens life live maintaining plant public viewing zoos"
                    },
                    {
                        "id": "712119",
                        "text": "Other Museums",
                        "keywords": "art exhibits galleries history museums non-commercial operation science"
                    },
                    {
                        "id": "712120",
                        "text": "Historic and Heritage Sites",
                        "keywords": "accessible buildings communities events forts heritage historic historical illustrate interest maintaining persons protecting public sites viewing"
                    },
                    {
                        "id": "712111",
                        "text": "Non-Commercial Art Museums and Galleries",
                        "keywords": "acquiring art collections conserving exhibiting galleries interpreting museums non-commercial permanent public researching"
                    },
                    {
                        "id": "712115",
                        "text": "History and Science Museums",
                        "keywords": "accessible acquiring conserving cultural exhibiting historical history interpreting museums objects public science value"
                    }
                ]
            },
            {
                "id": "7131",
                "text": "Amusement Parks and Arcades",
                "keywords": "amusement arcades operating parks parlours",
                "children": [
                    {
                        "id": "713110",
                        "text": "Amusement and Theme Parks",
                        "keywords": "amusement attractions basis concession exhibits games known lease mechanical operating parks rides shows slides space theme these variety water"
                    },
                    {
                        "id": "713120",
                        "text": "Amusement Arcades",
                        "keywords": "amusement arcades operating parlours"
                    }
                ]
            },
            {
                "id": "7132",
                "text": "Gambling Industries",
                "keywords": "betting bingo casinos facilities gambling gaming halls lotteries off-track operating providing services terminals video",
                "children": [
                    {
                        "id": "713291",
                        "text": "Lotteries",
                        "keywords": "channels consumers distribution existing governments lotteries lottery operated organizing owned retail selling tickets"
                    },
                    {
                        "id": "713299",
                        "text": "All Other Gambling Industries",
                        "keywords": "gambling providing services"
                    },
                    {
                        "id": "713210",
                        "text": "Casinos (except Casino Hotels)",
                        "keywords": "along beverage casino casinos facilities food gambling games hotels machines offer operating provide services slot table these wagering"
                    }
                ]
            },
            {
                "id": "7139",
                "text": "Other Amusement and Recreation Industries",
                "keywords": "amusement bowling centres courses enable facilities fitness golf indoor marinas operating outdoor participate patrons providing recreation recreational services skiing sports",
                "children": [
                    {
                        "id": "713910",
                        "text": "Golf Courses and Country Clubs",
                        "keywords": "along beverage clubs country courses dining equipment facilities food golf instruction operate operating provide recreational rental services these"
                    },
                    {
                        "id": "713920",
                        "text": "Skiing Facilities",
                        "keywords": "areas beverage cross-country downhill equipment facilities food instruction lifts operating provide rental services ski skiing these tows"
                    },
                    {
                        "id": "713930",
                        "text": "Marinas",
                        "keywords": "boat clubs docking facilities fuel known maintenance marinas marine operate operating owners pleasure-craft rental repair retailing sailing services storage supplies without yacht"
                    },
                    {
                        "id": "713940",
                        "text": "Fitness and Recreational Sports Centres",
                        "keywords": "active centres clubs conditioning exercise facilities featuring fitness health operating physical racquet recreational skating sports swimming"
                    },
                    {
                        "id": "713950",
                        "text": "Bowling Centres",
                        "keywords": "beverage bowling centres food operating provide services these"
                    },
                    {
                        "id": "713991",
                        "text": "Sports Clubs, Teams and Leagues Performing before a Non-paying Audience",
                        "keywords": "boating rowing sailing canoe kayak clubs without marinas boxing fencing figure skating football hockey lacrosse riding rifle shooting snowmobiling soccer swimming tennis squash yacht"
                    },
                    {
                        "id": "713992",
                        "text": "Other Sport Facilities",
                        "keywords": "archery ranges ballrooms dance halls billiard pool bocce ball courts bungee jumping facilities curling rinks fishing piers operation go-cart tracks recreational golf driving practice laser tag miniature mini putt courses outdoor adventure paintball ping pong parlours pitch river rafting rock climbing shooting trampoline trapshooting zip lining"
                    },
                    {
                        "id": "713999",
                        "text": "All Other Amusement and Recreation Industries",
                        "keywords": "maintaining non-gambling coin-operated amusement devices concession operators rides carnival day summer camps fishing guide services horse rental recreational hunting guide services juke box nightclubs discotheques nudist camps observation towers outdoor adventure operations white water rafting pinball machines"
                    }
                ]
            }
        ]
    },
    {
        "id": "72",
        "text": "Accommodation and Food Services",
        "keywords": "accommodation adventure bed beverages breakfast cabins campgrounds camps casino complementary consumption cottages customer facilities fishing food hotels housekeeping hunting immediate lodging meals motels motor off order parks premises preparing providing recreational resorts services short-term snacks travellers types vacationers various vehicle",
        "children": [
            {
                "id": "721",
                "text": "Accommodation Services",
                "keywords": "accommodate accommodation according addition basis characterized clients complementary contractual designed enthusiasts even facilities facility generates hotels lodging manage management motels nature operate operating outdoor provide provided providing provision range recreational restaurants revenues services short-stay short-term staff these they travellers vacationers while",
                "children": [
                    {
                        "id": "7211",
                        "text": "Traveller Accommodation",
                        "keywords": "accommodation bed beverage breakfast cabins casino conference convention cottages facilities food homes hotels housekeeping laundry lodging motels motor offer parking providing recreational resorts rooms services short-term these traveller",
                        "children": [
                            {
                                "id": "721192",
                                "text": "Housekeeping Cottages and Cabins",
                                "keywords": "access accommodate beaches cabins cottages designed facilities fishing housekeeping known lodging private providing short-term these vacationers"
                            },
                            {
                                "id": "721198",
                                "text": "All Other Traveller Accommodation",
                                "keywords": "accommodation lodging providing short-term traveller"
                            },
                            {
                                "id": "721191",
                                "text": "Bed and Breakfast",
                                "keywords": "bed breakfast buildings character characterized converted facilities full guest highly historic homes inclusion known lodging owner owner-supervised personalized possess private provide providing rate room rooms served service short-term small staff these they unique use"
                            },
                            {
                                "id": "721120",
                                "text": "Casino Hotels",
                                "keywords": "amenities betting beverage casino conference convention entertainment facilities food gambling games hotel hotels lodging machines offer operation parking pools premises providing range services short-term slot sports swimming table these valet wagering"
                            },
                            {
                                "id": "721114",
                                "text": "Motels",
                                "keywords": "access accommodate adjacent amenities ample areas characterized clients complementary designed entrances exterior facilities guest known limited lodging motels motor parking provide provided providing room rooms services short-stay short-term structure suites these travelling two-storey vehicle within"
                            },
                            {
                                "id": "721112",
                                "text": "Motor Hotels",
                                "keywords": "access accommodate along amenities ample areas characterized clients complementary convenient designed facilities guest hotels interior known limited location lodging low-rise major motor parking provide provided providing roads rooms services short-stay short-term structure suites these travelling vehicle within"
                            },
                            {
                                "id": "721113",
                                "text": "Resorts",
                                "keywords": "access accommodate basis conference designed extensive facilities feature full-service guest indoor known lakes leisure lodging mountains next non-urban outdoor premises provide providing resorts rivers rooms setting short-term suites these vacationers year-round"
                            },
                            {
                                "id": "721111",
                                "text": "Hotels",
                                "keywords": "accessible amenities beverage complementary conference convention exercise facilities food guest guests high-rise hotels interior known laundry lodging multi-storey offer parking pools provide providing range rooms services short-term structure suites swimming these they within"
                            }
                        ]
                    },
                    {
                        "id": "7212",
                        "text": "Recreational vehicle (RV) parks and recreational camps",
                        "keywords": "accommodation adventure campgrounds camps cater characterized clients enthusiasts facilities fishing hunting nature operating outdoor parks provided range recreational rv these types vacation various vehicle",
                        "children": [
                            {
                                "id": "721212",
                                "text": "Hunting and Fishing Camps",
                                "keywords": "access beverages cabins camps facility fishing food guides housekeeping hunting meals operating outpost provide range sale services supplies these they transportation"
                            },
                            {
                                "id": "721213",
                                "text": "Recreational (except Hunting and Fishing) and Vacation Camps",
                                "keywords": "accommodation adventure amenities cabins camp camps children's equipment facilities family fishing fixed food hiking hunting offer operating organized outdoor overnight provide rafting recreational retreats riding services sites these trail vacation white-water"
                            },
                            {
                                "id": "721211",
                                "text": "Recreational vehicle (RV) parks and campgrounds",
                                "keywords": "access accommodate bars campers campgrounds equipment facilities halls laundry operating parks provide recreation recreational rooms rv rvs serviced sites snack stores tent tents these trailers travel unserviced vehicle vehicles washrooms"
                            }
                        ]
                    },
                    {
                        "id": "7213",
                        "text": "Rooming and Boarding Houses",
                        "keywords": "accommodation boarding complementary facilities housekeeping houses laundry longer-term meals occupancy operating period principal provide residence rooming serve services temporary these",
                        "children": [
                            {
                                "id": "721310",
                                "text": "Rooming and Boarding Houses",
                                "keywords": "accommodation boarding complementary facilities housekeeping houses laundry longer-term meals occupancy operating period principal provide residence rooming serve services temporary these"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "722",
                "text": "Food Services and Drinking Places",
                "keywords": "airports amusement associations beverages civic consumption customer department drinking facilities food food-service groups hotels however immediate leased level locations malls meals occur off order parks places premises preparing provided recreation reflect service services shopping snacks social stores theatres within",
                "children": [
                    {
                        "id": "7223",
                        "text": "Special Food Services",
                        "keywords": "cart customer customer's designated food location motorized non-motorized providing services special vehicle",
                        "children": [
                            {
                                "id": "722310",
                                "text": "Food Service Contractors",
                                "keywords": "airlines concessions contract contractors facilities food institutions operate period providing railways service services specific sports supplying time well"
                            },
                            {
                                "id": "722320",
                                "text": "Caterers",
                                "keywords": "caterers equipment event event-based events facilities food graduation manage meals own parties permanent prepare provide providing receptions services shows site snacks these they trade transport vehicles wedding who"
                            },
                            {
                                "id": "722330",
                                "text": "Mobile Food Services",
                                "keywords": "carts consumption food immediate meals mobile motorized non-motorized preparing services serving snacks vehicles"
                            }
                        ]
                    },
                    {
                        "id": "7224",
                        "text": "Drinking Places (Alcoholic Beverages)",
                        "keywords": "alcoholic bars beverages consumption drinking food immediate known limited places preparing provide services serving taverns these",
                        "children": [
                            {
                                "id": "722410",
                                "text": "Drinking Places (Alcoholic Beverages)",
                                "keywords": "alcoholic bars beverages consumption drinking food immediate known limited places preparing provide services serving taverns these"
                            }
                        ]
                    },
                    {
                        "id": "7225",
                        "text": "Full-Service Restaurants and Limited-Service Eating Places",
                        "keywords": "addition after alcoholic bar beverages cafeteria consumption counter customer's delivered drink eating entertainment food full-service food-services items limited-service line live location non-alcoholic offer operate order patrons pay picked places premises present provide providing restaurants seated select sell served services serving snacks specialty take-out telephone variety",
                        "children": [
                            {
                                "id": "722511",
                                "text": "Full-Service Restaurants",
                                "keywords": "addition alcoholic bar beverages bistro buffet caf"
                            },
                            {
                                "id": "722512",
                                "text": "Limited-Service Eating Places",
                                "keywords": "airports arenas bagel bakery bar bars-retail beverage beverages booths box cafeteria cafeterias carry-out chicken chinese chips coffee concession consumption counter court cream custard customer's dairy delivered dog doughnut drink drive drive-in eating fast fish food food-services fried frozen hamburger hot immediate ice in items juice licensed limited-service line location lunch muffins non-alcoholic offer orange order out outlet parlour pastries patrons pay picked pizza pizzerias places premises prepared pretzel produced products providing public refreshment restaurant restaurants room sandwich select selling service shop shops snack snacks soft sold soup specialty sports stand stands store submarine submarines take take-out telephone variety"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "id": "81",
        "text": "Other Services (except Public Administration)",
        "keywords": "administration advocating care causes defending efficiently ensure equipment finishing funeral grant-making households individuals interests laundry machinery maintenance members motor organizing performing personal pet photo political private products promoting providing public religious repairing routine services social supporting they various vehicles work",
        "children": [
            {
                "id": "811",
                "text": "Repair and Maintenance",
                "keywords": "efficiently ensure equipment machinery maintaining maintenance motor perform products repair repairing routine these they vehicles work",
                "children": [
                    {
                        "id": "8111",
                        "text": "Automotive Repair and Maintenance",
                        "keywords": "automotive cars commercial maintaining maintenance motor repair repairing trailers trucks vans vehicles",
                        "children": [
                            {
                                "id": "811119",
                                "text": "Other Automotive Mechanical and Electrical Repair and Maintenance",
                                "keywords": "automotive electrical maintenance mechanical motor providing repair specialized vehicle"
                            },
                            {
                                "id": "811121",
                                "text": "Automotive Body, Paint and Interior Repair and Maintenance",
                                "keywords": "automotive bodies body customizing interior interiors maintenance motor paint painting repair repairing vehicle"
                            },
                            {
                                "id": "811111",
                                "text": "General Automotive Repair",
                                "keywords": "automotive electrical engine exhaust maintenance mechanical motor providing range repair replacement services specializing system transmission vehicles"
                            },
                            {
                                "id": "811112",
                                "text": "Automotive Exhaust System Repair",
                                "keywords": "automotive exhaust motor repair repairing replacing system systems vehicles"
                            },
                            {
                                "id": "811122",
                                "text": "Automotive Glass Replacement Shops",
                                "keywords": "automotive glass motor repairing replacement replacing shops vehicle"
                            },
                            {
                                "id": "811192",
                                "text": "Car Washes",
                                "keywords": "car cleaning motor vehicles washes washing"
                            },
                            {
                                "id": "811199",
                                "text": "All Other Automotive Repair and Maintenance",
                                "keywords": "automotive maintenance motor providing repair vehicle"
                            }
                        ]
                    },
                    {
                        "id": "8112",
                        "text": "Electronic and Precision Equipment Repair and Maintenance",
                        "keywords": "electronic equipment instruments maintaining maintenance precision repair repairing",
                        "children": [
                            {
                                "id": "811210",
                                "text": "Electronic and Precision Equipment Repair and Maintenance",
                                "keywords": "electronic equipment instruments maintaining maintenance precision repair repairing"
                            }
                        ]
                    },
                    {
                        "id": "8113",
                        "text": "Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance",
                        "keywords": "automotive commercial electronic equipment industrial machinery maintaining maintenance repair repairing",
                        "children": [
                            {
                                "id": "811310",
                                "text": "Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance",
                                "keywords": "automotive commercial electronic equipment industrial machinery maintaining maintenance repair repairing"
                            }
                        ]
                    },
                    {
                        "id": "8114",
                        "text": "Personal and Household Goods Repair and Maintenance",
                        "keywords": "appliances bicycles boats equipment footwear furniture garden garments goods home household instruments jewellery leather maintaining maintenance musical personal recreational repair repairing watches",
                        "children": [
                            {
                                "id": "811490",
                                "text": "Other Personal and Household Goods Repair and Maintenance",
                                "keywords": "equipment goods household maintaining maintenance new personal repair repairing retail sales without"
                            },
                            {
                                "id": "811420",
                                "text": "Reupholstery and Furniture Repair",
                                "keywords": "equipment furniture new refinishing repair repairing restoring retail reupholstering reupholstery sales without"
                            },
                            {
                                "id": "811430",
                                "text": "Footwear and Leather Goods Repair",
                                "keywords": "briefcases footwear goods handbags leather leather-like repair repairing"
                            },
                            {
                                "id": "811412",
                                "text": "Appliance Repair and Maintenance",
                                "keywords": "appliance appliances equipment household maintaining maintenance new repair repairing retail sales without"
                            },
                            {
                                "id": "811411",
                                "text": "Home and Garden Equipment Repair and Maintenance",
                                "keywords": "equipment garden home maintaining maintenance new repair repairing retail sales without"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "812",
                "text": "Personal and Laundry Services",
                "keywords": "care facilities finishing funeral laundry operators parking personal pet photo providing services",
                "children": [
                    {
                        "id": "8121",
                        "text": "Personal Care Services",
                        "keywords": "care counselling diet ear esthetic hair massage personal piercing providing replacement scalp services treatment",
                        "children": [
                            {
                                "id": "812190",
                                "text": "Other Personal Care Services",
                                "keywords": "care personal providing services"
                            },
                            {
                                "id": "812114",
                                "text": "Barber Shops",
                                "keywords": "barber beards care cutting hair men moustaches providing services shaving shops styling trimming"
                            },
                            {
                                "id": "812115",
                                "text": "Beauty Salons",
                                "keywords": "beauty care esthetic hair manicures pedicures providing salons services these women"
                            },
                            {
                                "id": "812116",
                                "text": "Unisex Hair Salons",
                                "keywords": "care combine cutting esthetic hair men men's salons services styling unisex women women's"
                            }
                        ]
                    },
                    {
                        "id": "8122",
                        "text": "Funeral Services",
                        "keywords": "animal burial cemeteries conducting cremating crematoria dead funeral funerals homes human interment operating preparing remains reserved services sites structures",
                        "children": [
                            {
                                "id": "812210",
                                "text": "Funeral Homes",
                                "keywords": "burial conducting dead funeral funerals homes interment preparing"
                            },
                            {
                                "id": "812220",
                                "text": "Cemeteries and Crematoria",
                                "keywords": "animal cemeteries cremating crematoria dead human interment operating remains reserved sites structures"
                            }
                        ]
                    },
                    {
                        "id": "8123",
                        "text": "Dry Cleaning and Laundry Services",
                        "keywords": "cleaning dry dry-cleaning fabric facilities items laundered laundering laundry linens providing public self-service services supplying uniforms use",
                        "children": [
                            {
                                "id": "812330",
                                "text": "Linen and Uniform Supply",
                                "keywords": "aprons basis clothing cloths coats commercial contract diapers flame gloves gowns heat household industrial items laboratory laundering linen napkins resistant safety sheets supply supplying table towels uniform uniforms use"
                            },
                            {
                                "id": "812320",
                                "text": "Dry Cleaning and Laundry Services (except Coin-Operated)",
                                "keywords": "alteration apparel cleaning clothing coin-operated delivery dry dry-cleaning fur garments independently laundering laundries laundry leather linens operated pick-up plants power pressing provide repair repairing services stations storing these types"
                            },
                            {
                                "id": "812310",
                                "text": "Coin-Operated Laundries and Dry Cleaners",
                                "keywords": "cleaners coin-operated dry dry-cleaning facilities laundries laundry providing public self-service use"
                            }
                        ]
                    },
                    {
                        "id": "8129",
                        "text": "Other Personal Services",
                        "keywords": "care finishing parking personal pet photo providing services",
                        "children": [
                            {
                                "id": "812990",
                                "text": "All Other Personal Services",
                                "keywords": "personal providing services"
                            },
                            {
                                "id": "812930",
                                "text": "Parking Lots and Garages",
                                "keywords": "basis daily garages hourly lots monthly motor operating parking provide services temporary these vehicles"
                            },
                            {
                                "id": "812921",
                                "text": "Photo Finishing Laboratories (except One-Hour)",
                                "keywords": "basis clients commercial developing enlargements film finishing known laboratories large-scale normally one-hour photo photographic prints professional providing services slides specialty"
                            },
                            {
                                "id": "812922",
                                "text": "One-Hour Photo Finishing",
                                "keywords": "automated convenient developing equipment film finishers finishing known located locations malls one-hour photo photographic photographs printing public retail shopping still supplies these use"
                            },
                            {
                                "id": "812910",
                                "text": "Pet Care (except Veterinary) Services",
                                "keywords": "animals boarding care grooming pet services veterinary"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "813",
                "text": "Religious, Grant-Making, Civic, and Professional and Similar Organizations",
                "keywords": "advocating causes civic defending grant-making interests members organizations organizing political professional promoting religious social supporting various",
                "children": [
                    {
                        "id": "813990",
                        "text": "Other Membership Organizations",
                        "keywords": "interests members membership organizations promoting"
                    },
                    {
                        "id": "813930",
                        "text": "Labour Organizations",
                        "keywords": "between conditions employees employers improve income labour members negotiate organizations regulation relations these working"
                    },
                    {
                        "id": "813940",
                        "text": "Political Organizations",
                        "keywords": "candidates funds groups individual interests local national organizations organized parties party political promoting provincial raise"
                    },
                    {
                        "id": "813910",
                        "text": "Business Associations",
                        "keywords": "associations business certification conduct develop interests market members new newsletters products promoting publish quality research services sponsor standards statistics these"
                    },
                    {
                        "id": "813410",
                        "text": "Civic and Social Organizations",
                        "keywords": "bars civic interests members operate organizations promoting provide purposes recreational restaurants services social"
                    },
                    {
                        "id": "813310",
                        "text": "Social Advocacy Organizations",
                        "keywords": "advocacy benefit broad cause constituency contributions intended memberships organizations political promoting sell social solicit specific support"
                    },
                    {
                        "id": "813210",
                        "text": "Grant-Making and Giving Services",
                        "keywords": "awarding behalf contributions cultural educational funds giving grant-making grants health range scientific services social soliciting support trust welfare wide"
                    },
                    {
                        "id": "813110",
                        "text": "Religious Organizations",
                        "keywords": "administering operating organizations organized promoting religion religious study training worship"
                    },
                    {
                        "id": "813920",
                        "text": "Professional Organizations",
                        "keywords": "advancing interests members organizations profession professional whole"
                    }
                ]
            },
            {
                "id": "814",
                "text": "Private Households",
                "keywords": "about baby-sitting butlers caretakers concerned cooks employ employing gardeners household households individuals maids maintenance nanny operation outside premises private providing services these workers",
                "children": [
                    {
                        "id": "814110",
                        "text": "Private Households",
                        "keywords": "about baby-sitting butlers caretakers concerned cooks employ employing gardeners household households individuals maids maintenance nanny operation outside premises private providing services these workers"
                    }
                ]
            }
        ]
    },
    {
        "id": "91",
        "text": "Public Administration",
        "keywords": "administration affairs assistance based classification criterion defence enactment engage foreign government governmental immigration international interpretation judicial laws legislative national nature non-governmental order owned ownership privately programs public purely pursuant records regulations safety separate services taxation",
        "children": [
            {
                "id": "911",
                "text": "Federal Government Public Administration",
                "keywords": "administration affairs assistance defence federal foreign government governmental immigration international judicial legislative national nature order programs public safety services taxation",
                "children": [
                    {
                        "id": "911320",
                        "text": "Immigration Services",
                        "keywords": "assisting controlling country entry federal government immigrants immigration individuals promoting services"
                    },
                    {
                        "id": "911240",
                        "text": "Federal Regulatory Services",
                        "keywords": "abuse exploitation federal government groups individuals negligence protection regulatory services singly"
                    },
                    {
                        "id": "911290",
                        "text": "Other Federal Protective Services",
                        "keywords": "animal catastrophes control dealing emergencies federal government major pest protective services"
                    },
                    {
                        "id": "911230",
                        "text": "Federal Police Services",
                        "keywords": "federal forces government law maintaining means operating order police services"
                    },
                    {
                        "id": "911410",
                        "text": "Foreign Affairs",
                        "keywords": "affairs between canada countries federal foreign formal government promoting relations"
                    },
                    {
                        "id": "911420",
                        "text": "International Assistance",
                        "keywords": "assistance conditions countries development economic federal foreign government improvement international social"
                    },
                    {
                        "id": "911390",
                        "text": "Other Federal Labour, Employment and Immigration Services",
                        "keywords": "agencies citizen-oriented citizens combine departments employment federal government immigration labour promotion registration services"
                    },
                    {
                        "id": "911310",
                        "text": "Federal Labour and Employment Services",
                        "keywords": "arbitration bargaining collective conciliation conditions dealing employer-employee employment federal government improved labour market matters pertaining promotion provision relations research services working"
                    },
                    {
                        "id": "911110",
                        "text": "Defence Services",
                        "keywords": "agencies armed civilian defence forces providing services"
                    },
                    {
                        "id": "911210",
                        "text": "Federal Courts of Law",
                        "keywords": "actions appeal arbitration boards civil courts federal government interpretations judgements jurisdiction law rendering"
                    },
                    {
                        "id": "911220",
                        "text": "Federal Correctional Services",
                        "keywords": "correctional detention federal government incarceration prisons providing rehabilitation services"
                    },
                    {
                        "id": "911910",
                        "text": "Other Federal Government Public Administration",
                        "keywords": "administration assessing collecting conducting debt executive federal fiscal government governments legislative levying policies programs public relations taxes"
                    }
                ]
            },
            {
                "id": "912",
                "text": "Provincial and Territorial Public Administration",
                "keywords": "administration government governmental governments judicial legislative nature order programs provincial public safety taxation territorial",
                "children": [
                    {
                        "id": "912150",
                        "text": "Provincial Regulatory Services",
                        "keywords": "abuse exploitation governments groups individuals negligence protection provincial regulatory services singly territorial"
                    },
                    {
                        "id": "912210",
                        "text": "Provincial Labour and Employment Services",
                        "keywords": "arbitration bargaining collective conciliation conditions dealing employer-employee employment governments improved labour market matters pertaining promotion provincial provision relations research services territorial working"
                    },
                    {
                        "id": "912110",
                        "text": "Provincial Courts of Law",
                        "keywords": "actions appeal arbitration boards civil courts governments interpretations judgements jurisdiction law provincial rendering territorial"
                    },
                    {
                        "id": "912120",
                        "text": "Provincial Correctional Services",
                        "keywords": "correctional detention governments incarceration jails operating providing provincial rehabilitation services territorial"
                    },
                    {
                        "id": "912130",
                        "text": "Provincial Police Services",
                        "keywords": "forces governments law maintaining means operating order police provincial services territorial"
                    },
                    {
                        "id": "912140",
                        "text": "Provincial Fire-Fighting Services",
                        "keywords": "extinction fire-fighting fires governments investigation prevention provincial services territorial"
                    },
                    {
                        "id": "912190",
                        "text": "Other Provincial Protective Services",
                        "keywords": "animal catastrophes control dealing emergencies governments major pest protection protective provincial services territorial"
                    },
                    {
                        "id": "912910",
                        "text": "Other Provincial and Territorial Public Administration",
                        "keywords": "administration assessing collecting conducting debt executive fiscal government governments legislative levying policies programs provincial public relations taxes territorial"
                    }
                ]
            },
            {
                "id": "913",
                "text": "Local, Municipal and Regional Public Administration",
                "keywords": "administration government governmental governments legislative local municipal nature order programs public regional safety taxation",
                "children": [
                    {
                        "id": "913110",
                        "text": "Municipal Courts of Law",
                        "keywords": "actions arbitration civil courts governments interpretations judgements law local municipal rendering"
                    },
                    {
                        "id": "913120",
                        "text": "Municipal Correctional Services",
                        "keywords": "correctional detention governments incarceration jails local municipal providing rehabilitation services"
                    },
                    {
                        "id": "913130",
                        "text": "Municipal Police Services",
                        "keywords": "forces governments law local maintaining means municipal operating order police services"
                    },
                    {
                        "id": "913140",
                        "text": "Municipal Fire-Fighting Services",
                        "keywords": "extinction fire-fighting fires governments investigation local municipal prevention services"
                    },
                    {
                        "id": "913150",
                        "text": "Municipal Regulatory Services",
                        "keywords": "abuse exploitation governments groups individuals local municipal negligence protection regulatory services singly"
                    },
                    {
                        "id": "913190",
                        "text": "Other Municipal Protective Services",
                        "keywords": "animal catastrophes control dealing emergencies governments local major municipal pest protective services"
                    },
                    {
                        "id": "913910",
                        "text": "Other Local, Municipal and Regional Public Administration",
                        "keywords": "administration assessing collecting conducting debt executive fiscal government governments legislative levying local municipal planning policies programs public regional relations taxes"
                    }
                ]
            },
            {
                "id": "914",
                "text": "Aboriginal Public Administration",
                "keywords": "aboriginal administration constituents federal government governments levels municipal provided providing provincial public services variety wide would",
                "children": [
                    {
                        "id": "914110",
                        "text": "Aboriginal Public Administration",
                        "keywords": "aboriginal administration constituents federal government governments levels municipal provided providing provincial public services variety wide would"
                    }
                ]
            },
            {
                "id": "919",
                "text": "International and Other Extra-Territorial Public Administration",
                "keywords": "administration canada consular diplomatic extra-territorial foreign governmental governments international legation public service",
                "children": [
                    {
                        "id": "919110",
                        "text": "International and Other Extra-Territorial Public Administration",
                        "keywords": "administration canada consular diplomatic extra-territorial foreign governmental governments international legation public service"
                    }
                ]
            }
        ]
    }
]
